<style lang="less" scoped>
  .main {
    padding-top: 45px;
    padding-bottom: 50px;
  }
  .nav {
    background-color: #000;
    height: 45px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    color: #fff;
    position: relative;
    text-align: center;
    line-height: 45px;
    font-size: 14px;
    position: fixed;
    width: 100%;
    top: 0;
    .ivu-icon {
      margin-top: 12px;
      margin-left: 10px;
      float: left;
    }
  }
  .order-bar {
    background: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    border-top: 1px solid #eee;
    .bar-left {
      float: left;
      position: relative;
      text-align: left;
      line-height: 50px;
      font-size: 18px;
      color: #ff6615;
      font-weight: 700;
      padding-left: 15px;
    }
    .bar-right {
      line-height: 50px;
      text-align: center;
      background-color: #ff6615;
      color: #fff;
      width: 200px;
      position: absolute;
      right: 0;
    }
  }
  .diy-box {
    width: 100%;
    margin: auto;
    margin-top: 15px;
    position: relative;
    .step_name {
      font-size: 20px;
      color: #ff6615;
      font-weight: 700;
      margin-bottom: 15px;
      padding-left: 15px;
    }
    .parameter_li {
      border-bottom: 1px solid #eee;
      background: #fff;
      padding: 15px;
    }
    .parameter_name {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .parameter_box {
      margin-bottom: 15px;
      overflow: hidden;
      overflow-x: auto;
      .item {
        float: left;
        width: 200px;
        margin-right: 15px;
        .item_img {
          width: 200px;
          height: 200px;
          background: #eee;
        }
        .item_name {
          padding-top: 10px;
          padding-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
  .s-title {
    padding: 15px;
  }
  .sh-box {
    overflow: hidden;
    background: #fff;
    padding: 15px;
    position: relative;
    .ivu-icon-md-create {
      position: absolute;
      right: 25px;
      top: 50%;
      margin-top: -10px;
    }
  }
  .adviser-box {
    overflow: hidden;
    background: #fff;
    padding: 15px;
    .portrait {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      float: left;
    }
    .adviser-right {
      margin-left: 60px;
      .full_name {
        font-size: 18px;
        margin-bottom: 2px;
      }
    }
  }
  .product-li {
    background: #fff;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    padding-right: 15px;
    height: 45px;
    line-height: 45px;
    span {
      float: right;
    }
  }
</style>

<template>
  <div class="main">
    <div class="nav">
      <Icon size="24" @click="$router.go(-1)" color="#fff" type="ios-arrow-back" />
      <span>为本定制</span>
    </div>
    <div class="order-box">
      <Spin size="large" fix v-if="load"></Spin>
      <div class="make-box">
        <div class="make_li">
          <Card>
            <h3 slot="title">{{rdata.enterprise.enterprise_name}}</h3>
            <div class="address"> {{rdata.enterprise.province}} {{rdata.enterprise.city}} {{rdata.enterprise.county}} {{rdata.enterprise.address}}</div>
            <div class="contacts"> {{rdata.enterprise.contacts}} | {{rdata.enterprise.contact_number}}</div>
          </Card>
        </div>
        <div class="s-title">专属顾问</div>
        <div class="adviser-box">
          <img :src="rdata.adviser.portrait || 'assets/images/mr.jpeg'" class="portrait">
          <div class="adviser-right">
            <div class="full_name">
              {{rdata.adviser.full_name}}
            </div>
            <div class="phone">
              {{rdata.adviser.phone}}
            </div>
          </div>
        </div>
        <div class="s-title">收货信息</div>
        <div class="sh-box">
          <div class="sh-">{{rdata.consignee}} | {{rdata.receiving_phone}} </div>
          <div class="sh-">{{rdata.province}}{{rdata.city ==rdata.province ? '' : rdata.city}}{{rdata.county}}{{rdata.receiving_address}}</div>
          <Icon @click="editSh=!editSh" size="22" type="md-create" />
        </div>
        <div class="s-title">产品信息</div>
        <div class="product">
          <div class="product-li">
            活页本定制笔记本<span class="right">￥{{rdata.unit_price}} </span>
          </div>
          <div class="product-li">
            工艺费<span class="right">￥{{rdata.dan_price}}</span>
          </div>
          <div class="product-li">
            数量{{rdata.min_number}}
            <span class="right">
                  <InputNumber :min="1" v-model="rdata.number" type="number" ></InputNumber>
                 </span>
          </div>
          <div class="product-li">
            商品合计
            <span class="right">
                      ￥{{total_price}}
               </span>
          </div>
        
          <div class="s-title">合同</div>
          <div class="product-li">
            合同<a :href="rdata.contract" target="_block" style="float: right;" class="right">查看</a>
          </div>
          <div class="product-li">
            邮箱
            <span class="right">
                   <Input type="email" v-model="rdata.e_mail" placeholder="请输入电子邮箱" style="width: 200px" />
              </span>
          </div>
        </div>
        <!-- <div class="s-title">合同发票</div> -->
      </div>
    </div>
    <div class="order-bar">
      <div class="bar-left">
        ¥{{total_price}}
      </div>
      <div class="bar-right" @click="fukuan">
        去付款
      </div>
    </div>
    <Modal v-model="editSh" footer-hide :mask-closable="false" title="修改收货地址">
      <Form label-position="top">
        <FormItem label="收货人">
          <Input v-model="rdata.consignee"></Input>
        </FormItem>
        <FormItem label="联系电话">
          <Input type="number" v-model="rdata.receiving_phone"></Input>
        </FormItem>
        <FormItem label="城市">
          <Cascader :data="cityArry" v-model="city"></Cascader>
        </FormItem>
        <FormItem label="详细地址">
          <Input type="textarea" v-model="rdata.receiving_address" placeholder="请填写详细收货地址" />
        </FormItem>
        <Button type="primary" @click="save()" long>确认修改</Button>
      </Form>
    </Modal>
  </div>
</template>

<script>
  var that;
  import Store from 'store';
  import {
    POST
  } from "../plugins/core";
  export default {
    name: 'order',
    data() {
      return {
        load: true,
        editSh: false,
        city: [],
        cityArry: [{
          "value": "北京市",
          "label": "北京市",
          "id": 110000,
          "children": [{
            "value": "北京市",
            "label": "北京市",
            "id": 110100,
            "children": [{
              "value": "东城区",
              "label": "东城区",
              "id": 110101
            }, {
              "value": "西城区",
              "label": "西城区",
              "id": 110102
            }, {
              "value": "朝阳区",
              "label": "朝阳区",
              "id": 110105
            }, {
              "value": "丰台区",
              "label": "丰台区",
              "id": 110106
            }, {
              "value": "石景山区",
              "label": "石景山区",
              "id": 110107
            }, {
              "value": "海淀区",
              "label": "海淀区",
              "id": 110108
            }, {
              "value": "门头沟区",
              "label": "门头沟区",
              "id": 110109
            }, {
              "value": "房山区",
              "label": "房山区",
              "id": 110111
            }, {
              "value": "通州区",
              "label": "通州区",
              "id": 110112
            }, {
              "value": "顺义区",
              "label": "顺义区",
              "id": 110113
            }, {
              "value": "昌平区",
              "label": "昌平区",
              "id": 110114
            }, {
              "value": "大兴区",
              "label": "大兴区",
              "id": 110115
            }, {
              "value": "怀柔区",
              "label": "怀柔区",
              "id": 110116
            }, {
              "value": "平谷区",
              "label": "平谷区",
              "id": 110117
            }, {
              "value": "密云区",
              "label": "密云区",
              "id": 110118
            }, {
              "value": "延庆区",
              "label": "延庆区",
              "id": 110119
            }]
          }]
        }, {
          "value": "天津市",
          "label": "天津市",
          "id": 120000,
          "children": [{
            "value": "市辖区",
            "label": "市辖区",
            "id": 120100,
            "children": [{
              "value": "和平区",
              "label": "和平区",
              "id": 120101
            }, {
              "value": "河东区",
              "label": "河东区",
              "id": 120102
            }, {
              "value": "河西区",
              "label": "河西区",
              "id": 120103
            }, {
              "value": "南开区",
              "label": "南开区",
              "id": 120104
            }, {
              "value": "河北区",
              "label": "河北区",
              "id": 120105
            }, {
              "value": "红桥区",
              "label": "红桥区",
              "id": 120106
            }, {
              "value": "东丽区",
              "label": "东丽区",
              "id": 120110
            }, {
              "value": "西青区",
              "label": "西青区",
              "id": 120111
            }, {
              "value": "津南区",
              "label": "津南区",
              "id": 120112
            }, {
              "value": "北辰区",
              "label": "北辰区",
              "id": 120113
            }, {
              "value": "武清区",
              "label": "武清区",
              "id": 120114
            }, {
              "value": "宝坻区",
              "label": "宝坻区",
              "id": 120115
            }, {
              "value": "滨海新区",
              "label": "滨海新区",
              "id": 120116
            }, {
              "value": "宁河区",
              "label": "宁河区",
              "id": 120117
            }, {
              "value": "静海区",
              "label": "静海区",
              "id": 120118
            }, {
              "value": "蓟州区",
              "label": "蓟州区",
              "id": 120119
            }]
          }]
        }, {
          "value": "河北省",
          "label": "河北省",
          "id": 130000,
          "children": [{
            "value": "石家庄市",
            "label": "石家庄市",
            "id": 130100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130101
            }, {
              "value": "长安区",
              "label": "长安区",
              "id": 130102
            }, {
              "value": "桥西区",
              "label": "桥西区",
              "id": 130104
            }, {
              "value": "新华区",
              "label": "新华区",
              "id": 130105
            }, {
              "value": "井陉矿区",
              "label": "井陉矿区",
              "id": 130107
            }, {
              "value": "裕华区",
              "label": "裕华区",
              "id": 130108
            }, {
              "value": "藁城区",
              "label": "藁城区",
              "id": 130109
            }, {
              "value": "鹿泉区",
              "label": "鹿泉区",
              "id": 130110
            }, {
              "value": "栾城区",
              "label": "栾城区",
              "id": 130111
            }, {
              "value": "井陉县",
              "label": "井陉县",
              "id": 130121
            }, {
              "value": "正定县",
              "label": "正定县",
              "id": 130123
            }, {
              "value": "行唐县",
              "label": "行唐县",
              "id": 130125
            }, {
              "value": "灵寿县",
              "label": "灵寿县",
              "id": 130126
            }, {
              "value": "高邑县",
              "label": "高邑县",
              "id": 130127
            }, {
              "value": "深泽县",
              "label": "深泽县",
              "id": 130128
            }, {
              "value": "赞皇县",
              "label": "赞皇县",
              "id": 130129
            }, {
              "value": "无极县",
              "label": "无极县",
              "id": 130130
            }, {
              "value": "平山县",
              "label": "平山县",
              "id": 130131
            }, {
              "value": "元氏县",
              "label": "元氏县",
              "id": 130132
            }, {
              "value": "赵县",
              "label": "赵县",
              "id": 130133
            }, {
              "value": "晋州市",
              "label": "晋州市",
              "id": 130183
            }, {
              "value": "新乐市",
              "label": "新乐市",
              "id": 130184
            }]
          }, {
            "value": "唐山市",
            "label": "唐山市",
            "id": 130200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130201
            }, {
              "value": "路南区",
              "label": "路南区",
              "id": 130202
            }, {
              "value": "路北区",
              "label": "路北区",
              "id": 130203
            }, {
              "value": "古冶区",
              "label": "古冶区",
              "id": 130204
            }, {
              "value": "开平区",
              "label": "开平区",
              "id": 130205
            }, {
              "value": "丰南区",
              "label": "丰南区",
              "id": 130207
            }, {
              "value": "丰润区",
              "label": "丰润区",
              "id": 130208
            }, {
              "value": "曹妃甸区",
              "label": "曹妃甸区",
              "id": 130209
            }, {
              "value": "滦县",
              "label": "滦县",
              "id": 130223
            }, {
              "value": "滦南县",
              "label": "滦南县",
              "id": 130224
            }, {
              "value": "乐亭县",
              "label": "乐亭县",
              "id": 130225
            }, {
              "value": "迁西县",
              "label": "迁西县",
              "id": 130227
            }, {
              "value": "玉田县",
              "label": "玉田县",
              "id": 130229
            }, {
              "value": "遵化市",
              "label": "遵化市",
              "id": 130281
            }, {
              "value": "迁安市",
              "label": "迁安市",
              "id": 130283
            }]
          }, {
            "value": "秦皇岛市",
            "label": "秦皇岛市",
            "id": 130300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130301
            }, {
              "value": "海港区",
              "label": "海港区",
              "id": 130302
            }, {
              "value": "山海关区",
              "label": "山海关区",
              "id": 130303
            }, {
              "value": "北戴河区",
              "label": "北戴河区",
              "id": 130304
            }, {
              "value": "抚宁区",
              "label": "抚宁区",
              "id": 130306
            }, {
              "value": "青龙满族自治县",
              "label": "青龙满族自治县",
              "id": 130321
            }, {
              "value": "昌黎县",
              "label": "昌黎县",
              "id": 130322
            }, {
              "value": "卢龙县",
              "label": "卢龙县",
              "id": 130324
            }]
          }, {
            "value": "邯郸市",
            "label": "邯郸市",
            "id": 130400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130401
            }, {
              "value": "邯山区",
              "label": "邯山区",
              "id": 130402
            }, {
              "value": "丛台区",
              "label": "丛台区",
              "id": 130403
            }, {
              "value": "复兴区",
              "label": "复兴区",
              "id": 130404
            }, {
              "value": "峰峰矿区",
              "label": "峰峰矿区",
              "id": 130406
            }, {
              "value": "邯郸县",
              "label": "邯郸县",
              "id": 130421
            }, {
              "value": "临漳县",
              "label": "临漳县",
              "id": 130423
            }, {
              "value": "成安县",
              "label": "成安县",
              "id": 130424
            }, {
              "value": "大名县",
              "label": "大名县",
              "id": 130425
            }, {
              "value": "涉县",
              "label": "涉县",
              "id": 130426
            }, {
              "value": "磁县",
              "label": "磁县",
              "id": 130427
            }, {
              "value": "肥乡县",
              "label": "肥乡县",
              "id": 130428
            }, {
              "value": "永年县",
              "label": "永年县",
              "id": 130429
            }, {
              "value": "邱县",
              "label": "邱县",
              "id": 130430
            }, {
              "value": "鸡泽县",
              "label": "鸡泽县",
              "id": 130431
            }, {
              "value": "广平县",
              "label": "广平县",
              "id": 130432
            }, {
              "value": "馆陶县",
              "label": "馆陶县",
              "id": 130433
            }, {
              "value": "魏县",
              "label": "魏县",
              "id": 130434
            }, {
              "value": "曲周县",
              "label": "曲周县",
              "id": 130435
            }, {
              "value": "武安市",
              "label": "武安市",
              "id": 130481
            }]
          }, {
            "value": "邢台市",
            "label": "邢台市",
            "id": 130500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130501
            }, {
              "value": "桥东区",
              "label": "桥东区",
              "id": 130502
            }, {
              "value": "桥西区",
              "label": "桥西区",
              "id": 130503
            }, {
              "value": "邢台县",
              "label": "邢台县",
              "id": 130521
            }, {
              "value": "临城县",
              "label": "临城县",
              "id": 130522
            }, {
              "value": "内丘县",
              "label": "内丘县",
              "id": 130523
            }, {
              "value": "柏乡县",
              "label": "柏乡县",
              "id": 130524
            }, {
              "value": "隆尧县",
              "label": "隆尧县",
              "id": 130525
            }, {
              "value": "任县",
              "label": "任县",
              "id": 130526
            }, {
              "value": "南和县",
              "label": "南和县",
              "id": 130527
            }, {
              "value": "宁晋县",
              "label": "宁晋县",
              "id": 130528
            }, {
              "value": "巨鹿县",
              "label": "巨鹿县",
              "id": 130529
            }, {
              "value": "新河县",
              "label": "新河县",
              "id": 130530
            }, {
              "value": "广宗县",
              "label": "广宗县",
              "id": 130531
            }, {
              "value": "平乡县",
              "label": "平乡县",
              "id": 130532
            }, {
              "value": "威县",
              "label": "威县",
              "id": 130533
            }, {
              "value": "清河县",
              "label": "清河县",
              "id": 130534
            }, {
              "value": "临西县",
              "label": "临西县",
              "id": 130535
            }, {
              "value": "南宫市",
              "label": "南宫市",
              "id": 130581
            }, {
              "value": "沙河市",
              "label": "沙河市",
              "id": 130582
            }]
          }, {
            "value": "保定市",
            "label": "保定市",
            "id": 130600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130601
            }, {
              "value": "竞秀区",
              "label": "竞秀区",
              "id": 130602
            }, {
              "value": "莲池区",
              "label": "莲池区",
              "id": 130606
            }, {
              "value": "满城区",
              "label": "满城区",
              "id": 130607
            }, {
              "value": "清苑区",
              "label": "清苑区",
              "id": 130608
            }, {
              "value": "徐水区",
              "label": "徐水区",
              "id": 130609
            }, {
              "value": "涞水县",
              "label": "涞水县",
              "id": 130623
            }, {
              "value": "阜平县",
              "label": "阜平县",
              "id": 130624
            }, {
              "value": "定兴县",
              "label": "定兴县",
              "id": 130626
            }, {
              "value": "唐县",
              "label": "唐县",
              "id": 130627
            }, {
              "value": "高阳县",
              "label": "高阳县",
              "id": 130628
            }, {
              "value": "容城县",
              "label": "容城县",
              "id": 130629
            }, {
              "value": "涞源县",
              "label": "涞源县",
              "id": 130630
            }, {
              "value": "望都县",
              "label": "望都县",
              "id": 130631
            }, {
              "value": "安新县",
              "label": "安新县",
              "id": 130632
            }, {
              "value": "易县",
              "label": "易县",
              "id": 130633
            }, {
              "value": "曲阳县",
              "label": "曲阳县",
              "id": 130634
            }, {
              "value": "蠡县",
              "label": "蠡县",
              "id": 130635
            }, {
              "value": "顺平县",
              "label": "顺平县",
              "id": 130636
            }, {
              "value": "博野县",
              "label": "博野县",
              "id": 130637
            }, {
              "value": "雄县",
              "label": "雄县",
              "id": 130638
            }, {
              "value": "涿州市",
              "label": "涿州市",
              "id": 130681
            }, {
              "value": "安国市",
              "label": "安国市",
              "id": 130683
            }, {
              "value": "高碑店市",
              "label": "高碑店市",
              "id": 130684
            }]
          }, {
            "value": "张家口市",
            "label": "张家口市",
            "id": 130700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130701
            }, {
              "value": "桥东区",
              "label": "桥东区",
              "id": 130702
            }, {
              "value": "桥西区",
              "label": "桥西区",
              "id": 130703
            }, {
              "value": "宣化区",
              "label": "宣化区",
              "id": 130705
            }, {
              "value": "下花园区",
              "label": "下花园区",
              "id": 130706
            }, {
              "value": "万全区",
              "label": "万全区",
              "id": 130708
            }, {
              "value": "崇礼区",
              "label": "崇礼区",
              "id": 130709
            }, {
              "value": "张北县",
              "label": "张北县",
              "id": 130722
            }, {
              "value": "康保县",
              "label": "康保县",
              "id": 130723
            }, {
              "value": "沽源县",
              "label": "沽源县",
              "id": 130724
            }, {
              "value": "尚义县",
              "label": "尚义县",
              "id": 130725
            }, {
              "value": "蔚县",
              "label": "蔚县",
              "id": 130726
            }, {
              "value": "阳原县",
              "label": "阳原县",
              "id": 130727
            }, {
              "value": "怀安县",
              "label": "怀安县",
              "id": 130728
            }, {
              "value": "怀来县",
              "label": "怀来县",
              "id": 130730
            }, {
              "value": "涿鹿县",
              "label": "涿鹿县",
              "id": 130731
            }, {
              "value": "赤城县",
              "label": "赤城县",
              "id": 130732
            }]
          }, {
            "value": "承德市",
            "label": "承德市",
            "id": 130800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130801
            }, {
              "value": "双桥区",
              "label": "双桥区",
              "id": 130802
            }, {
              "value": "双滦区",
              "label": "双滦区",
              "id": 130803
            }, {
              "value": "鹰手营子矿区",
              "label": "鹰手营子矿区",
              "id": 130804
            }, {
              "value": "承德县",
              "label": "承德县",
              "id": 130821
            }, {
              "value": "兴隆县",
              "label": "兴隆县",
              "id": 130822
            }, {
              "value": "平泉县",
              "label": "平泉县",
              "id": 130823
            }, {
              "value": "滦平县",
              "label": "滦平县",
              "id": 130824
            }, {
              "value": "隆化县",
              "label": "隆化县",
              "id": 130825
            }, {
              "value": "丰宁满族自治县",
              "label": "丰宁满族自治县",
              "id": 130826
            }, {
              "value": "宽城满族自治县",
              "label": "宽城满族自治县",
              "id": 130827
            }, {
              "value": "围场满族蒙古族自治县",
              "label": "围场满族蒙古族自治县",
              "id": 130828
            }]
          }, {
            "value": "沧州市",
            "label": "沧州市",
            "id": 130900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 130901
            }, {
              "value": "新华区",
              "label": "新华区",
              "id": 130902
            }, {
              "value": "运河区",
              "label": "运河区",
              "id": 130903
            }, {
              "value": "沧县",
              "label": "沧县",
              "id": 130921
            }, {
              "value": "青县",
              "label": "青县",
              "id": 130922
            }, {
              "value": "东光县",
              "label": "东光县",
              "id": 130923
            }, {
              "value": "海兴县",
              "label": "海兴县",
              "id": 130924
            }, {
              "value": "盐山县",
              "label": "盐山县",
              "id": 130925
            }, {
              "value": "肃宁县",
              "label": "肃宁县",
              "id": 130926
            }, {
              "value": "南皮县",
              "label": "南皮县",
              "id": 130927
            }, {
              "value": "吴桥县",
              "label": "吴桥县",
              "id": 130928
            }, {
              "value": "献县",
              "label": "献县",
              "id": 130929
            }, {
              "value": "孟村回族自治县",
              "label": "孟村回族自治县",
              "id": 130930
            }, {
              "value": "泊头市",
              "label": "泊头市",
              "id": 130981
            }, {
              "value": "任丘市",
              "label": "任丘市",
              "id": 130982
            }, {
              "value": "黄骅市",
              "label": "黄骅市",
              "id": 130983
            }, {
              "value": "河间市",
              "label": "河间市",
              "id": 130984
            }]
          }, {
            "value": "廊坊市",
            "label": "廊坊市",
            "id": 131000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 131001
            }, {
              "value": "安次区",
              "label": "安次区",
              "id": 131002
            }, {
              "value": "广阳区",
              "label": "广阳区",
              "id": 131003
            }, {
              "value": "固安县",
              "label": "固安县",
              "id": 131022
            }, {
              "value": "永清县",
              "label": "永清县",
              "id": 131023
            }, {
              "value": "香河县",
              "label": "香河县",
              "id": 131024
            }, {
              "value": "大城县",
              "label": "大城县",
              "id": 131025
            }, {
              "value": "文安县",
              "label": "文安县",
              "id": 131026
            }, {
              "value": "大厂回族自治县",
              "label": "大厂回族自治县",
              "id": 131028
            }, {
              "value": "霸州市",
              "label": "霸州市",
              "id": 131081
            }, {
              "value": "三河市",
              "label": "三河市",
              "id": 131082
            }]
          }, {
            "value": "衡水市",
            "label": "衡水市",
            "id": 131100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 131101
            }, {
              "value": "桃城区",
              "label": "桃城区",
              "id": 131102
            }, {
              "value": "冀州区",
              "label": "冀州区",
              "id": 131103
            }, {
              "value": "枣强县",
              "label": "枣强县",
              "id": 131121
            }, {
              "value": "武邑县",
              "label": "武邑县",
              "id": 131122
            }, {
              "value": "武强县",
              "label": "武强县",
              "id": 131123
            }, {
              "value": "饶阳县",
              "label": "饶阳县",
              "id": 131124
            }, {
              "value": "安平县",
              "label": "安平县",
              "id": 131125
            }, {
              "value": "故城县",
              "label": "故城县",
              "id": 131126
            }, {
              "value": "景县",
              "label": "景县",
              "id": 131127
            }, {
              "value": "阜城县",
              "label": "阜城县",
              "id": 131128
            }, {
              "value": "深州市",
              "label": "深州市",
              "id": 131182
            }]
          }, {
            "value": "省直辖县级行政区划",
            "label": "省直辖县级行政区划",
            "id": 139000,
            "children": [{
              "value": "定州市",
              "label": "定州市",
              "id": 139001
            }, {
              "value": "辛集市",
              "label": "辛集市",
              "id": 139002
            }]
          }]
        }, {
          "value": "山西省",
          "label": "山西省",
          "id": 140000,
          "children": [{
            "value": "太原市",
            "label": "太原市",
            "id": 140100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140101
            }, {
              "value": "小店区",
              "label": "小店区",
              "id": 140105
            }, {
              "value": "迎泽区",
              "label": "迎泽区",
              "id": 140106
            }, {
              "value": "杏花岭区",
              "label": "杏花岭区",
              "id": 140107
            }, {
              "value": "尖草坪区",
              "label": "尖草坪区",
              "id": 140108
            }, {
              "value": "万柏林区",
              "label": "万柏林区",
              "id": 140109
            }, {
              "value": "晋源区",
              "label": "晋源区",
              "id": 140110
            }, {
              "value": "清徐县",
              "label": "清徐县",
              "id": 140121
            }, {
              "value": "阳曲县",
              "label": "阳曲县",
              "id": 140122
            }, {
              "value": "娄烦县",
              "label": "娄烦县",
              "id": 140123
            }, {
              "value": "古交市",
              "label": "古交市",
              "id": 140181
            }]
          }, {
            "value": "大同市",
            "label": "大同市",
            "id": 140200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140201
            }, {
              "value": "城区",
              "label": "城区",
              "id": 140202
            }, {
              "value": "矿区",
              "label": "矿区",
              "id": 140203
            }, {
              "value": "南郊区",
              "label": "南郊区",
              "id": 140211
            }, {
              "value": "新荣区",
              "label": "新荣区",
              "id": 140212
            }, {
              "value": "阳高县",
              "label": "阳高县",
              "id": 140221
            }, {
              "value": "天镇县",
              "label": "天镇县",
              "id": 140222
            }, {
              "value": "广灵县",
              "label": "广灵县",
              "id": 140223
            }, {
              "value": "灵丘县",
              "label": "灵丘县",
              "id": 140224
            }, {
              "value": "浑源县",
              "label": "浑源县",
              "id": 140225
            }, {
              "value": "左云县",
              "label": "左云县",
              "id": 140226
            }, {
              "value": "大同县",
              "label": "大同县",
              "id": 140227
            }]
          }, {
            "value": "阳泉市",
            "label": "阳泉市",
            "id": 140300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140301
            }, {
              "value": "城区",
              "label": "城区",
              "id": 140302
            }, {
              "value": "矿区",
              "label": "矿区",
              "id": 140303
            }, {
              "value": "郊区",
              "label": "郊区",
              "id": 140311
            }, {
              "value": "平定县",
              "label": "平定县",
              "id": 140321
            }, {
              "value": "盂县",
              "label": "盂县",
              "id": 140322
            }]
          }, {
            "value": "长治市",
            "label": "长治市",
            "id": 140400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140401
            }, {
              "value": "城区",
              "label": "城区",
              "id": 140402
            }, {
              "value": "郊区",
              "label": "郊区",
              "id": 140411
            }, {
              "value": "长治县",
              "label": "长治县",
              "id": 140421
            }, {
              "value": "襄垣县",
              "label": "襄垣县",
              "id": 140423
            }, {
              "value": "屯留县",
              "label": "屯留县",
              "id": 140424
            }, {
              "value": "平顺县",
              "label": "平顺县",
              "id": 140425
            }, {
              "value": "黎城县",
              "label": "黎城县",
              "id": 140426
            }, {
              "value": "壶关县",
              "label": "壶关县",
              "id": 140427
            }, {
              "value": "长子县",
              "label": "长子县",
              "id": 140428
            }, {
              "value": "武乡县",
              "label": "武乡县",
              "id": 140429
            }, {
              "value": "沁县",
              "label": "沁县",
              "id": 140430
            }, {
              "value": "沁源县",
              "label": "沁源县",
              "id": 140431
            }, {
              "value": "潞城市",
              "label": "潞城市",
              "id": 140481
            }]
          }, {
            "value": "晋城市",
            "label": "晋城市",
            "id": 140500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140501
            }, {
              "value": "城区",
              "label": "城区",
              "id": 140502
            }, {
              "value": "沁水县",
              "label": "沁水县",
              "id": 140521
            }, {
              "value": "阳城县",
              "label": "阳城县",
              "id": 140522
            }, {
              "value": "陵川县",
              "label": "陵川县",
              "id": 140524
            }, {
              "value": "泽州县",
              "label": "泽州县",
              "id": 140525
            }, {
              "value": "高平市",
              "label": "高平市",
              "id": 140581
            }]
          }, {
            "value": "朔州市",
            "label": "朔州市",
            "id": 140600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140601
            }, {
              "value": "朔城区",
              "label": "朔城区",
              "id": 140602
            }, {
              "value": "平鲁区",
              "label": "平鲁区",
              "id": 140603
            }, {
              "value": "山阴县",
              "label": "山阴县",
              "id": 140621
            }, {
              "value": "应县",
              "label": "应县",
              "id": 140622
            }, {
              "value": "右玉县",
              "label": "右玉县",
              "id": 140623
            }, {
              "value": "怀仁县",
              "label": "怀仁县",
              "id": 140624
            }]
          }, {
            "value": "晋中市",
            "label": "晋中市",
            "id": 140700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140701
            }, {
              "value": "榆次区",
              "label": "榆次区",
              "id": 140702
            }, {
              "value": "榆社县",
              "label": "榆社县",
              "id": 140721
            }, {
              "value": "左权县",
              "label": "左权县",
              "id": 140722
            }, {
              "value": "和顺县",
              "label": "和顺县",
              "id": 140723
            }, {
              "value": "昔阳县",
              "label": "昔阳县",
              "id": 140724
            }, {
              "value": "寿阳县",
              "label": "寿阳县",
              "id": 140725
            }, {
              "value": "太谷县",
              "label": "太谷县",
              "id": 140726
            }, {
              "value": "祁县",
              "label": "祁县",
              "id": 140727
            }, {
              "value": "平遥县",
              "label": "平遥县",
              "id": 140728
            }, {
              "value": "灵石县",
              "label": "灵石县",
              "id": 140729
            }, {
              "value": "介休市",
              "label": "介休市",
              "id": 140781
            }]
          }, {
            "value": "运城市",
            "label": "运城市",
            "id": 140800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140801
            }, {
              "value": "盐湖区",
              "label": "盐湖区",
              "id": 140802
            }, {
              "value": "临猗县",
              "label": "临猗县",
              "id": 140821
            }, {
              "value": "万荣县",
              "label": "万荣县",
              "id": 140822
            }, {
              "value": "闻喜县",
              "label": "闻喜县",
              "id": 140823
            }, {
              "value": "稷山县",
              "label": "稷山县",
              "id": 140824
            }, {
              "value": "新绛县",
              "label": "新绛县",
              "id": 140825
            }, {
              "value": "绛县",
              "label": "绛县",
              "id": 140826
            }, {
              "value": "垣曲县",
              "label": "垣曲县",
              "id": 140827
            }, {
              "value": "夏县",
              "label": "夏县",
              "id": 140828
            }, {
              "value": "平陆县",
              "label": "平陆县",
              "id": 140829
            }, {
              "value": "芮城县",
              "label": "芮城县",
              "id": 140830
            }, {
              "value": "永济市",
              "label": "永济市",
              "id": 140881
            }, {
              "value": "河津市",
              "label": "河津市",
              "id": 140882
            }]
          }, {
            "value": "忻州市",
            "label": "忻州市",
            "id": 140900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 140901
            }, {
              "value": "忻府区",
              "label": "忻府区",
              "id": 140902
            }, {
              "value": "定襄县",
              "label": "定襄县",
              "id": 140921
            }, {
              "value": "五台县",
              "label": "五台县",
              "id": 140922
            }, {
              "value": "代县",
              "label": "代县",
              "id": 140923
            }, {
              "value": "繁峙县",
              "label": "繁峙县",
              "id": 140924
            }, {
              "value": "宁武县",
              "label": "宁武县",
              "id": 140925
            }, {
              "value": "静乐县",
              "label": "静乐县",
              "id": 140926
            }, {
              "value": "神池县",
              "label": "神池县",
              "id": 140927
            }, {
              "value": "五寨县",
              "label": "五寨县",
              "id": 140928
            }, {
              "value": "岢岚县",
              "label": "岢岚县",
              "id": 140929
            }, {
              "value": "河曲县",
              "label": "河曲县",
              "id": 140930
            }, {
              "value": "保德县",
              "label": "保德县",
              "id": 140931
            }, {
              "value": "偏关县",
              "label": "偏关县",
              "id": 140932
            }, {
              "value": "原平市",
              "label": "原平市",
              "id": 140981
            }]
          }, {
            "value": "临汾市",
            "label": "临汾市",
            "id": 141000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 141001
            }, {
              "value": "尧都区",
              "label": "尧都区",
              "id": 141002
            }, {
              "value": "曲沃县",
              "label": "曲沃县",
              "id": 141021
            }, {
              "value": "翼城县",
              "label": "翼城县",
              "id": 141022
            }, {
              "value": "襄汾县",
              "label": "襄汾县",
              "id": 141023
            }, {
              "value": "洪洞县",
              "label": "洪洞县",
              "id": 141024
            }, {
              "value": "古县",
              "label": "古县",
              "id": 141025
            }, {
              "value": "安泽县",
              "label": "安泽县",
              "id": 141026
            }, {
              "value": "浮山县",
              "label": "浮山县",
              "id": 141027
            }, {
              "value": "吉县",
              "label": "吉县",
              "id": 141028
            }, {
              "value": "乡宁县",
              "label": "乡宁县",
              "id": 141029
            }, {
              "value": "大宁县",
              "label": "大宁县",
              "id": 141030
            }, {
              "value": "隰县",
              "label": "隰县",
              "id": 141031
            }, {
              "value": "永和县",
              "label": "永和县",
              "id": 141032
            }, {
              "value": "蒲县",
              "label": "蒲县",
              "id": 141033
            }, {
              "value": "汾西县",
              "label": "汾西县",
              "id": 141034
            }, {
              "value": "侯马市",
              "label": "侯马市",
              "id": 141081
            }, {
              "value": "霍州市",
              "label": "霍州市",
              "id": 141082
            }]
          }, {
            "value": "吕梁市",
            "label": "吕梁市",
            "id": 141100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 141101
            }, {
              "value": "离石区",
              "label": "离石区",
              "id": 141102
            }, {
              "value": "文水县",
              "label": "文水县",
              "id": 141121
            }, {
              "value": "交城县",
              "label": "交城县",
              "id": 141122
            }, {
              "value": "兴县",
              "label": "兴县",
              "id": 141123
            }, {
              "value": "临县",
              "label": "临县",
              "id": 141124
            }, {
              "value": "柳林县",
              "label": "柳林县",
              "id": 141125
            }, {
              "value": "石楼县",
              "label": "石楼县",
              "id": 141126
            }, {
              "value": "岚县",
              "label": "岚县",
              "id": 141127
            }, {
              "value": "方山县",
              "label": "方山县",
              "id": 141128
            }, {
              "value": "中阳县",
              "label": "中阳县",
              "id": 141129
            }, {
              "value": "交口县",
              "label": "交口县",
              "id": 141130
            }, {
              "value": "孝义市",
              "label": "孝义市",
              "id": 141181
            }, {
              "value": "汾阳市",
              "label": "汾阳市",
              "id": 141182
            }]
          }]
        }, {
          "value": "内蒙古自治区",
          "label": "内蒙古自治区",
          "id": 150000,
          "children": [{
            "value": "呼和浩特市",
            "label": "呼和浩特市",
            "id": 150100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150101
            }, {
              "value": "新城区",
              "label": "新城区",
              "id": 150102
            }, {
              "value": "回民区",
              "label": "回民区",
              "id": 150103
            }, {
              "value": "玉泉区",
              "label": "玉泉区",
              "id": 150104
            }, {
              "value": "赛罕区",
              "label": "赛罕区",
              "id": 150105
            }, {
              "value": "土默特左旗",
              "label": "土默特左旗",
              "id": 150121
            }, {
              "value": "托克托县",
              "label": "托克托县",
              "id": 150122
            }, {
              "value": "和林格尔县",
              "label": "和林格尔县",
              "id": 150123
            }, {
              "value": "清水河县",
              "label": "清水河县",
              "id": 150124
            }, {
              "value": "武川县",
              "label": "武川县",
              "id": 150125
            }]
          }, {
            "value": "包头市",
            "label": "包头市",
            "id": 150200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150201
            }, {
              "value": "东河区",
              "label": "东河区",
              "id": 150202
            }, {
              "value": "昆都仑区",
              "label": "昆都仑区",
              "id": 150203
            }, {
              "value": "青山区",
              "label": "青山区",
              "id": 150204
            }, {
              "value": "石拐区",
              "label": "石拐区",
              "id": 150205
            }, {
              "value": "白云鄂博矿区",
              "label": "白云鄂博矿区",
              "id": 150206
            }, {
              "value": "九原区",
              "label": "九原区",
              "id": 150207
            }, {
              "value": "土默特右旗",
              "label": "土默特右旗",
              "id": 150221
            }, {
              "value": "固阳县",
              "label": "固阳县",
              "id": 150222
            }, {
              "value": "达尔罕茂明安联合旗",
              "label": "达尔罕茂明安联合旗",
              "id": 150223
            }]
          }, {
            "value": "乌海市",
            "label": "乌海市",
            "id": 150300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150301
            }, {
              "value": "海勃湾区",
              "label": "海勃湾区",
              "id": 150302
            }, {
              "value": "海南区",
              "label": "海南区",
              "id": 150303
            }, {
              "value": "乌达区",
              "label": "乌达区",
              "id": 150304
            }]
          }, {
            "value": "赤峰市",
            "label": "赤峰市",
            "id": 150400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150401
            }, {
              "value": "红山区",
              "label": "红山区",
              "id": 150402
            }, {
              "value": "元宝山区",
              "label": "元宝山区",
              "id": 150403
            }, {
              "value": "松山区",
              "label": "松山区",
              "id": 150404
            }, {
              "value": "阿鲁科尔沁旗",
              "label": "阿鲁科尔沁旗",
              "id": 150421
            }, {
              "value": "巴林左旗",
              "label": "巴林左旗",
              "id": 150422
            }, {
              "value": "巴林右旗",
              "label": "巴林右旗",
              "id": 150423
            }, {
              "value": "林西县",
              "label": "林西县",
              "id": 150424
            }, {
              "value": "克什克腾旗",
              "label": "克什克腾旗",
              "id": 150425
            }, {
              "value": "翁牛特旗",
              "label": "翁牛特旗",
              "id": 150426
            }, {
              "value": "喀喇沁旗",
              "label": "喀喇沁旗",
              "id": 150428
            }, {
              "value": "宁城县",
              "label": "宁城县",
              "id": 150429
            }, {
              "value": "敖汉旗",
              "label": "敖汉旗",
              "id": 150430
            }]
          }, {
            "value": "通辽市",
            "label": "通辽市",
            "id": 150500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150501
            }, {
              "value": "科尔沁区",
              "label": "科尔沁区",
              "id": 150502
            }, {
              "value": "科尔沁左翼中旗",
              "label": "科尔沁左翼中旗",
              "id": 150521
            }, {
              "value": "科尔沁左翼后旗",
              "label": "科尔沁左翼后旗",
              "id": 150522
            }, {
              "value": "开鲁县",
              "label": "开鲁县",
              "id": 150523
            }, {
              "value": "库伦旗",
              "label": "库伦旗",
              "id": 150524
            }, {
              "value": "奈曼旗",
              "label": "奈曼旗",
              "id": 150525
            }, {
              "value": "扎鲁特旗",
              "label": "扎鲁特旗",
              "id": 150526
            }, {
              "value": "霍林郭勒市",
              "label": "霍林郭勒市",
              "id": 150581
            }]
          }, {
            "value": "鄂尔多斯市",
            "label": "鄂尔多斯市",
            "id": 150600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150601
            }, {
              "value": "东胜区",
              "label": "东胜区",
              "id": 150602
            }, {
              "value": "康巴什区",
              "label": "康巴什区",
              "id": 150603
            }, {
              "value": "达拉特旗",
              "label": "达拉特旗",
              "id": 150621
            }, {
              "value": "准格尔旗",
              "label": "准格尔旗",
              "id": 150622
            }, {
              "value": "鄂托克前旗",
              "label": "鄂托克前旗",
              "id": 150623
            }, {
              "value": "鄂托克旗",
              "label": "鄂托克旗",
              "id": 150624
            }, {
              "value": "杭锦旗",
              "label": "杭锦旗",
              "id": 150625
            }, {
              "value": "乌审旗",
              "label": "乌审旗",
              "id": 150626
            }, {
              "value": "伊金霍洛旗",
              "label": "伊金霍洛旗",
              "id": 150627
            }]
          }, {
            "value": "呼伦贝尔市",
            "label": "呼伦贝尔市",
            "id": 150700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150701
            }, {
              "value": "海拉尔区",
              "label": "海拉尔区",
              "id": 150702
            }, {
              "value": "扎赉诺尔区",
              "label": "扎赉诺尔区",
              "id": 150703
            }, {
              "value": "阿荣旗",
              "label": "阿荣旗",
              "id": 150721
            }, {
              "value": "莫力达瓦达斡尔族自治旗",
              "label": "莫力达瓦达斡尔族自治旗",
              "id": 150722
            }, {
              "value": "鄂伦春自治旗",
              "label": "鄂伦春自治旗",
              "id": 150723
            }, {
              "value": "鄂温克族自治旗",
              "label": "鄂温克族自治旗",
              "id": 150724
            }, {
              "value": "陈巴尔虎旗",
              "label": "陈巴尔虎旗",
              "id": 150725
            }, {
              "value": "新巴尔虎左旗",
              "label": "新巴尔虎左旗",
              "id": 150726
            }, {
              "value": "新巴尔虎右旗",
              "label": "新巴尔虎右旗",
              "id": 150727
            }, {
              "value": "满洲里市",
              "label": "满洲里市",
              "id": 150781
            }, {
              "value": "牙克石市",
              "label": "牙克石市",
              "id": 150782
            }, {
              "value": "扎兰屯市",
              "label": "扎兰屯市",
              "id": 150783
            }, {
              "value": "额尔古纳市",
              "label": "额尔古纳市",
              "id": 150784
            }, {
              "value": "根河市",
              "label": "根河市",
              "id": 150785
            }]
          }, {
            "value": "巴彦淖尔市",
            "label": "巴彦淖尔市",
            "id": 150800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150801
            }, {
              "value": "临河区",
              "label": "临河区",
              "id": 150802
            }, {
              "value": "五原县",
              "label": "五原县",
              "id": 150821
            }, {
              "value": "磴口县",
              "label": "磴口县",
              "id": 150822
            }, {
              "value": "乌拉特前旗",
              "label": "乌拉特前旗",
              "id": 150823
            }, {
              "value": "乌拉特中旗",
              "label": "乌拉特中旗",
              "id": 150824
            }, {
              "value": "乌拉特后旗",
              "label": "乌拉特后旗",
              "id": 150825
            }, {
              "value": "杭锦后旗",
              "label": "杭锦后旗",
              "id": 150826
            }]
          }, {
            "value": "乌兰察布市",
            "label": "乌兰察布市",
            "id": 150900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 150901
            }, {
              "value": "集宁区",
              "label": "集宁区",
              "id": 150902
            }, {
              "value": "卓资县",
              "label": "卓资县",
              "id": 150921
            }, {
              "value": "化德县",
              "label": "化德县",
              "id": 150922
            }, {
              "value": "商都县",
              "label": "商都县",
              "id": 150923
            }, {
              "value": "兴和县",
              "label": "兴和县",
              "id": 150924
            }, {
              "value": "凉城县",
              "label": "凉城县",
              "id": 150925
            }, {
              "value": "察哈尔右翼前旗",
              "label": "察哈尔右翼前旗",
              "id": 150926
            }, {
              "value": "察哈尔右翼中旗",
              "label": "察哈尔右翼中旗",
              "id": 150927
            }, {
              "value": "察哈尔右翼后旗",
              "label": "察哈尔右翼后旗",
              "id": 150928
            }, {
              "value": "四子王旗",
              "label": "四子王旗",
              "id": 150929
            }, {
              "value": "丰镇市",
              "label": "丰镇市",
              "id": 150981
            }]
          }, {
            "value": "兴安盟",
            "label": "兴安盟",
            "id": 152200,
            "children": [{
              "value": "乌兰浩特市",
              "label": "乌兰浩特市",
              "id": 152201
            }, {
              "value": "阿尔山市",
              "label": "阿尔山市",
              "id": 152202
            }, {
              "value": "科尔沁右翼前旗",
              "label": "科尔沁右翼前旗",
              "id": 152221
            }, {
              "value": "科尔沁右翼中旗",
              "label": "科尔沁右翼中旗",
              "id": 152222
            }, {
              "value": "扎赉特旗",
              "label": "扎赉特旗",
              "id": 152223
            }, {
              "value": "突泉县",
              "label": "突泉县",
              "id": 152224
            }]
          }, {
            "value": "锡林郭勒盟",
            "label": "锡林郭勒盟",
            "id": 152500,
            "children": [{
              "value": "二连浩特市",
              "label": "二连浩特市",
              "id": 152501
            }, {
              "value": "锡林浩特市",
              "label": "锡林浩特市",
              "id": 152502
            }, {
              "value": "阿巴嘎旗",
              "label": "阿巴嘎旗",
              "id": 152522
            }, {
              "value": "苏尼特左旗",
              "label": "苏尼特左旗",
              "id": 152523
            }, {
              "value": "苏尼特右旗",
              "label": "苏尼特右旗",
              "id": 152524
            }, {
              "value": "东乌珠穆沁旗",
              "label": "东乌珠穆沁旗",
              "id": 152525
            }, {
              "value": "西乌珠穆沁旗",
              "label": "西乌珠穆沁旗",
              "id": 152526
            }, {
              "value": "太仆寺旗",
              "label": "太仆寺旗",
              "id": 152527
            }, {
              "value": "镶黄旗",
              "label": "镶黄旗",
              "id": 152528
            }, {
              "value": "正镶白旗",
              "label": "正镶白旗",
              "id": 152529
            }, {
              "value": "正蓝旗",
              "label": "正蓝旗",
              "id": 152530
            }, {
              "value": "多伦县",
              "label": "多伦县",
              "id": 152531
            }]
          }, {
            "value": "阿拉善盟",
            "label": "阿拉善盟",
            "id": 152900,
            "children": [{
              "value": "阿拉善左旗",
              "label": "阿拉善左旗",
              "id": 152921
            }, {
              "value": "阿拉善右旗",
              "label": "阿拉善右旗",
              "id": 152922
            }, {
              "value": "额济纳旗",
              "label": "额济纳旗",
              "id": 152923
            }]
          }]
        }, {
          "value": "辽宁省",
          "label": "辽宁省",
          "id": 210000,
          "children": [{
            "value": "沈阳市",
            "label": "沈阳市",
            "id": 210100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210101
            }, {
              "value": "和平区",
              "label": "和平区",
              "id": 210102
            }, {
              "value": "沈河区",
              "label": "沈河区",
              "id": 210103
            }, {
              "value": "大东区",
              "label": "大东区",
              "id": 210104
            }, {
              "value": "皇姑区",
              "label": "皇姑区",
              "id": 210105
            }, {
              "value": "铁西区",
              "label": "铁西区",
              "id": 210106
            }, {
              "value": "苏家屯区",
              "label": "苏家屯区",
              "id": 210111
            }, {
              "value": "浑南区",
              "label": "浑南区",
              "id": 210112
            }, {
              "value": "沈北新区",
              "label": "沈北新区",
              "id": 210113
            }, {
              "value": "于洪区",
              "label": "于洪区",
              "id": 210114
            }, {
              "value": "辽中区",
              "label": "辽中区",
              "id": 210115
            }, {
              "value": "康平县",
              "label": "康平县",
              "id": 210123
            }, {
              "value": "法库县",
              "label": "法库县",
              "id": 210124
            }, {
              "value": "新民市",
              "label": "新民市",
              "id": 210181
            }]
          }, {
            "value": "大连市",
            "label": "大连市",
            "id": 210200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210201
            }, {
              "value": "中山区",
              "label": "中山区",
              "id": 210202
            }, {
              "value": "西岗区",
              "label": "西岗区",
              "id": 210203
            }, {
              "value": "沙河口区",
              "label": "沙河口区",
              "id": 210204
            }, {
              "value": "甘井子区",
              "label": "甘井子区",
              "id": 210211
            }, {
              "value": "旅顺口区",
              "label": "旅顺口区",
              "id": 210212
            }, {
              "value": "金州区",
              "label": "金州区",
              "id": 210213
            }, {
              "value": "普兰店区",
              "label": "普兰店区",
              "id": 210214
            }, {
              "value": "长海县",
              "label": "长海县",
              "id": 210224
            }, {
              "value": "瓦房店市",
              "label": "瓦房店市",
              "id": 210281
            }, {
              "value": "庄河市",
              "label": "庄河市",
              "id": 210283
            }]
          }, {
            "value": "鞍山市",
            "label": "鞍山市",
            "id": 210300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210301
            }, {
              "value": "铁东区",
              "label": "铁东区",
              "id": 210302
            }, {
              "value": "铁西区",
              "label": "铁西区",
              "id": 210303
            }, {
              "value": "立山区",
              "label": "立山区",
              "id": 210304
            }, {
              "value": "千山区",
              "label": "千山区",
              "id": 210311
            }, {
              "value": "台安县",
              "label": "台安县",
              "id": 210321
            }, {
              "value": "岫岩满族自治县",
              "label": "岫岩满族自治县",
              "id": 210323
            }, {
              "value": "海城市",
              "label": "海城市",
              "id": 210381
            }]
          }, {
            "value": "抚顺市",
            "label": "抚顺市",
            "id": 210400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210401
            }, {
              "value": "新抚区",
              "label": "新抚区",
              "id": 210402
            }, {
              "value": "东洲区",
              "label": "东洲区",
              "id": 210403
            }, {
              "value": "望花区",
              "label": "望花区",
              "id": 210404
            }, {
              "value": "顺城区",
              "label": "顺城区",
              "id": 210411
            }, {
              "value": "抚顺县",
              "label": "抚顺县",
              "id": 210421
            }, {
              "value": "新宾满族自治县",
              "label": "新宾满族自治县",
              "id": 210422
            }, {
              "value": "清原满族自治县",
              "label": "清原满族自治县",
              "id": 210423
            }]
          }, {
            "value": "本溪市",
            "label": "本溪市",
            "id": 210500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210501
            }, {
              "value": "平山区",
              "label": "平山区",
              "id": 210502
            }, {
              "value": "溪湖区",
              "label": "溪湖区",
              "id": 210503
            }, {
              "value": "明山区",
              "label": "明山区",
              "id": 210504
            }, {
              "value": "南芬区",
              "label": "南芬区",
              "id": 210505
            }, {
              "value": "本溪满族自治县",
              "label": "本溪满族自治县",
              "id": 210521
            }, {
              "value": "桓仁满族自治县",
              "label": "桓仁满族自治县",
              "id": 210522
            }]
          }, {
            "value": "丹东市",
            "label": "丹东市",
            "id": 210600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210601
            }, {
              "value": "元宝区",
              "label": "元宝区",
              "id": 210602
            }, {
              "value": "振兴区",
              "label": "振兴区",
              "id": 210603
            }, {
              "value": "振安区",
              "label": "振安区",
              "id": 210604
            }, {
              "value": "宽甸满族自治县",
              "label": "宽甸满族自治县",
              "id": 210624
            }, {
              "value": "东港市",
              "label": "东港市",
              "id": 210681
            }, {
              "value": "凤城市",
              "label": "凤城市",
              "id": 210682
            }]
          }, {
            "value": "锦州市",
            "label": "锦州市",
            "id": 210700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210701
            }, {
              "value": "古塔区",
              "label": "古塔区",
              "id": 210702
            }, {
              "value": "凌河区",
              "label": "凌河区",
              "id": 210703
            }, {
              "value": "太和区",
              "label": "太和区",
              "id": 210711
            }, {
              "value": "黑山县",
              "label": "黑山县",
              "id": 210726
            }, {
              "value": "义县",
              "label": "义县",
              "id": 210727
            }, {
              "value": "凌海市",
              "label": "凌海市",
              "id": 210781
            }, {
              "value": "北镇市",
              "label": "北镇市",
              "id": 210782
            }]
          }, {
            "value": "营口市",
            "label": "营口市",
            "id": 210800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210801
            }, {
              "value": "站前区",
              "label": "站前区",
              "id": 210802
            }, {
              "value": "西市区",
              "label": "西市区",
              "id": 210803
            }, {
              "value": "鲅鱼圈区",
              "label": "鲅鱼圈区",
              "id": 210804
            }, {
              "value": "老边区",
              "label": "老边区",
              "id": 210811
            }, {
              "value": "盖州市",
              "label": "盖州市",
              "id": 210881
            }, {
              "value": "大石桥市",
              "label": "大石桥市",
              "id": 210882
            }]
          }, {
            "value": "阜新市",
            "label": "阜新市",
            "id": 210900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 210901
            }, {
              "value": "海州区",
              "label": "海州区",
              "id": 210902
            }, {
              "value": "新邱区",
              "label": "新邱区",
              "id": 210903
            }, {
              "value": "太平区",
              "label": "太平区",
              "id": 210904
            }, {
              "value": "清河门区",
              "label": "清河门区",
              "id": 210905
            }, {
              "value": "细河区",
              "label": "细河区",
              "id": 210911
            }, {
              "value": "阜新蒙古族自治县",
              "label": "阜新蒙古族自治县",
              "id": 210921
            }, {
              "value": "彰武县",
              "label": "彰武县",
              "id": 210922
            }]
          }, {
            "value": "辽阳市",
            "label": "辽阳市",
            "id": 211000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 211001
            }, {
              "value": "白塔区",
              "label": "白塔区",
              "id": 211002
            }, {
              "value": "文圣区",
              "label": "文圣区",
              "id": 211003
            }, {
              "value": "宏伟区",
              "label": "宏伟区",
              "id": 211004
            }, {
              "value": "弓长岭区",
              "label": "弓长岭区",
              "id": 211005
            }, {
              "value": "太子河区",
              "label": "太子河区",
              "id": 211011
            }, {
              "value": "辽阳县",
              "label": "辽阳县",
              "id": 211021
            }, {
              "value": "灯塔市",
              "label": "灯塔市",
              "id": 211081
            }]
          }, {
            "value": "盘锦市",
            "label": "盘锦市",
            "id": 211100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 211101
            }, {
              "value": "双台子区",
              "label": "双台子区",
              "id": 211102
            }, {
              "value": "兴隆台区",
              "label": "兴隆台区",
              "id": 211103
            }, {
              "value": "大洼区",
              "label": "大洼区",
              "id": 211104
            }, {
              "value": "盘山县",
              "label": "盘山县",
              "id": 211122
            }]
          }, {
            "value": "铁岭市",
            "label": "铁岭市",
            "id": 211200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 211201
            }, {
              "value": "银州区",
              "label": "银州区",
              "id": 211202
            }, {
              "value": "清河区",
              "label": "清河区",
              "id": 211204
            }, {
              "value": "铁岭县",
              "label": "铁岭县",
              "id": 211221
            }, {
              "value": "西丰县",
              "label": "西丰县",
              "id": 211223
            }, {
              "value": "昌图县",
              "label": "昌图县",
              "id": 211224
            }, {
              "value": "调兵山市",
              "label": "调兵山市",
              "id": 211281
            }, {
              "value": "开原市",
              "label": "开原市",
              "id": 211282
            }]
          }, {
            "value": "朝阳市",
            "label": "朝阳市",
            "id": 211300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 211301
            }, {
              "value": "双塔区",
              "label": "双塔区",
              "id": 211302
            }, {
              "value": "龙城区",
              "label": "龙城区",
              "id": 211303
            }, {
              "value": "朝阳县",
              "label": "朝阳县",
              "id": 211321
            }, {
              "value": "建平县",
              "label": "建平县",
              "id": 211322
            }, {
              "value": "喀喇沁左翼蒙古族自治县",
              "label": "喀喇沁左翼蒙古族自治县",
              "id": 211324
            }, {
              "value": "北票市",
              "label": "北票市",
              "id": 211381
            }, {
              "value": "凌源市",
              "label": "凌源市",
              "id": 211382
            }]
          }, {
            "value": "葫芦岛市",
            "label": "葫芦岛市",
            "id": 211400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 211401
            }, {
              "value": "连山区",
              "label": "连山区",
              "id": 211402
            }, {
              "value": "龙港区",
              "label": "龙港区",
              "id": 211403
            }, {
              "value": "南票区",
              "label": "南票区",
              "id": 211404
            }, {
              "value": "绥中县",
              "label": "绥中县",
              "id": 211421
            }, {
              "value": "建昌县",
              "label": "建昌县",
              "id": 211422
            }, {
              "value": "兴城市",
              "label": "兴城市",
              "id": 211481
            }]
          }]
        }, {
          "value": "吉林省",
          "label": "吉林省",
          "id": 220000,
          "children": [{
            "value": "长春市",
            "label": "长春市",
            "id": 220100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220101
            }, {
              "value": "南关区",
              "label": "南关区",
              "id": 220102
            }, {
              "value": "宽城区",
              "label": "宽城区",
              "id": 220103
            }, {
              "value": "朝阳区",
              "label": "朝阳区",
              "id": 220104
            }, {
              "value": "二道区",
              "label": "二道区",
              "id": 220105
            }, {
              "value": "绿园区",
              "label": "绿园区",
              "id": 220106
            }, {
              "value": "双阳区",
              "label": "双阳区",
              "id": 220112
            }, {
              "value": "九台区",
              "label": "九台区",
              "id": 220113
            }, {
              "value": "农安县",
              "label": "农安县",
              "id": 220122
            }, {
              "value": "榆树市",
              "label": "榆树市",
              "id": 220182
            }, {
              "value": "德惠市",
              "label": "德惠市",
              "id": 220183
            }]
          }, {
            "value": "吉林市",
            "label": "吉林市",
            "id": 220200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220201
            }, {
              "value": "昌邑区",
              "label": "昌邑区",
              "id": 220202
            }, {
              "value": "龙潭区",
              "label": "龙潭区",
              "id": 220203
            }, {
              "value": "船营区",
              "label": "船营区",
              "id": 220204
            }, {
              "value": "丰满区",
              "label": "丰满区",
              "id": 220211
            }, {
              "value": "永吉县",
              "label": "永吉县",
              "id": 220221
            }, {
              "value": "蛟河市",
              "label": "蛟河市",
              "id": 220281
            }, {
              "value": "桦甸市",
              "label": "桦甸市",
              "id": 220282
            }, {
              "value": "舒兰市",
              "label": "舒兰市",
              "id": 220283
            }, {
              "value": "磐石市",
              "label": "磐石市",
              "id": 220284
            }]
          }, {
            "value": "四平市",
            "label": "四平市",
            "id": 220300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220301
            }, {
              "value": "铁西区",
              "label": "铁西区",
              "id": 220302
            }, {
              "value": "铁东区",
              "label": "铁东区",
              "id": 220303
            }, {
              "value": "梨树县",
              "label": "梨树县",
              "id": 220322
            }, {
              "value": "伊通满族自治县",
              "label": "伊通满族自治县",
              "id": 220323
            }, {
              "value": "公主岭市",
              "label": "公主岭市",
              "id": 220381
            }, {
              "value": "双辽市",
              "label": "双辽市",
              "id": 220382
            }]
          }, {
            "value": "辽源市",
            "label": "辽源市",
            "id": 220400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220401
            }, {
              "value": "龙山区",
              "label": "龙山区",
              "id": 220402
            }, {
              "value": "西安区",
              "label": "西安区",
              "id": 220403
            }, {
              "value": "东丰县",
              "label": "东丰县",
              "id": 220421
            }, {
              "value": "东辽县",
              "label": "东辽县",
              "id": 220422
            }]
          }, {
            "value": "通化市",
            "label": "通化市",
            "id": 220500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220501
            }, {
              "value": "东昌区",
              "label": "东昌区",
              "id": 220502
            }, {
              "value": "二道江区",
              "label": "二道江区",
              "id": 220503
            }, {
              "value": "通化县",
              "label": "通化县",
              "id": 220521
            }, {
              "value": "辉南县",
              "label": "辉南县",
              "id": 220523
            }, {
              "value": "柳河县",
              "label": "柳河县",
              "id": 220524
            }, {
              "value": "梅河口市",
              "label": "梅河口市",
              "id": 220581
            }, {
              "value": "集安市",
              "label": "集安市",
              "id": 220582
            }]
          }, {
            "value": "白山市",
            "label": "白山市",
            "id": 220600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220601
            }, {
              "value": "浑江区",
              "label": "浑江区",
              "id": 220602
            }, {
              "value": "江源区",
              "label": "江源区",
              "id": 220605
            }, {
              "value": "抚松县",
              "label": "抚松县",
              "id": 220621
            }, {
              "value": "靖宇县",
              "label": "靖宇县",
              "id": 220622
            }, {
              "value": "长白朝鲜族自治县",
              "label": "长白朝鲜族自治县",
              "id": 220623
            }, {
              "value": "临江市",
              "label": "临江市",
              "id": 220681
            }]
          }, {
            "value": "松原市",
            "label": "松原市",
            "id": 220700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220701
            }, {
              "value": "宁江区",
              "label": "宁江区",
              "id": 220702
            }, {
              "value": "前郭尔罗斯蒙古族自治县",
              "label": "前郭尔罗斯蒙古族自治县",
              "id": 220721
            }, {
              "value": "长岭县",
              "label": "长岭县",
              "id": 220722
            }, {
              "value": "乾安县",
              "label": "乾安县",
              "id": 220723
            }, {
              "value": "扶余市",
              "label": "扶余市",
              "id": 220781
            }]
          }, {
            "value": "白城市",
            "label": "白城市",
            "id": 220800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 220801
            }, {
              "value": "洮北区",
              "label": "洮北区",
              "id": 220802
            }, {
              "value": "镇赉县",
              "label": "镇赉县",
              "id": 220821
            }, {
              "value": "通榆县",
              "label": "通榆县",
              "id": 220822
            }, {
              "value": "洮南市",
              "label": "洮南市",
              "id": 220881
            }, {
              "value": "大安市",
              "label": "大安市",
              "id": 220882
            }]
          }, {
            "value": "延边朝鲜族自治州",
            "label": "延边朝鲜族自治州",
            "id": 222400,
            "children": [{
              "value": "延吉市",
              "label": "延吉市",
              "id": 222401
            }, {
              "value": "图们市",
              "label": "图们市",
              "id": 222402
            }, {
              "value": "敦化市",
              "label": "敦化市",
              "id": 222403
            }, {
              "value": "珲春市",
              "label": "珲春市",
              "id": 222404
            }, {
              "value": "龙井市",
              "label": "龙井市",
              "id": 222405
            }, {
              "value": "和龙市",
              "label": "和龙市",
              "id": 222406
            }, {
              "value": "汪清县",
              "label": "汪清县",
              "id": 222424
            }, {
              "value": "安图县",
              "label": "安图县",
              "id": 222426
            }]
          }]
        }, {
          "value": "黑龙江省",
          "label": "黑龙江省",
          "id": 230000,
          "children": [{
            "value": "哈尔滨市",
            "label": "哈尔滨市",
            "id": 230100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230101
            }, {
              "value": "道里区",
              "label": "道里区",
              "id": 230102
            }, {
              "value": "南岗区",
              "label": "南岗区",
              "id": 230103
            }, {
              "value": "道外区",
              "label": "道外区",
              "id": 230104
            }, {
              "value": "平房区",
              "label": "平房区",
              "id": 230108
            }, {
              "value": "松北区",
              "label": "松北区",
              "id": 230109
            }, {
              "value": "香坊区",
              "label": "香坊区",
              "id": 230110
            }, {
              "value": "呼兰区",
              "label": "呼兰区",
              "id": 230111
            }, {
              "value": "阿城区",
              "label": "阿城区",
              "id": 230112
            }, {
              "value": "双城区",
              "label": "双城区",
              "id": 230113
            }, {
              "value": "依兰县",
              "label": "依兰县",
              "id": 230123
            }, {
              "value": "方正县",
              "label": "方正县",
              "id": 230124
            }, {
              "value": "宾县",
              "label": "宾县",
              "id": 230125
            }, {
              "value": "巴彦县",
              "label": "巴彦县",
              "id": 230126
            }, {
              "value": "木兰县",
              "label": "木兰县",
              "id": 230127
            }, {
              "value": "通河县",
              "label": "通河县",
              "id": 230128
            }, {
              "value": "延寿县",
              "label": "延寿县",
              "id": 230129
            }, {
              "value": "尚志市",
              "label": "尚志市",
              "id": 230183
            }, {
              "value": "五常市",
              "label": "五常市",
              "id": 230184
            }]
          }, {
            "value": "齐齐哈尔市",
            "label": "齐齐哈尔市",
            "id": 230200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230201
            }, {
              "value": "龙沙区",
              "label": "龙沙区",
              "id": 230202
            }, {
              "value": "建华区",
              "label": "建华区",
              "id": 230203
            }, {
              "value": "铁锋区",
              "label": "铁锋区",
              "id": 230204
            }, {
              "value": "昂昂溪区",
              "label": "昂昂溪区",
              "id": 230205
            }, {
              "value": "富拉尔基区",
              "label": "富拉尔基区",
              "id": 230206
            }, {
              "value": "碾子山区",
              "label": "碾子山区",
              "id": 230207
            }, {
              "value": "梅里斯达斡尔族区",
              "label": "梅里斯达斡尔族区",
              "id": 230208
            }, {
              "value": "龙江县",
              "label": "龙江县",
              "id": 230221
            }, {
              "value": "依安县",
              "label": "依安县",
              "id": 230223
            }, {
              "value": "泰来县",
              "label": "泰来县",
              "id": 230224
            }, {
              "value": "甘南县",
              "label": "甘南县",
              "id": 230225
            }, {
              "value": "富裕县",
              "label": "富裕县",
              "id": 230227
            }, {
              "value": "克山县",
              "label": "克山县",
              "id": 230229
            }, {
              "value": "克东县",
              "label": "克东县",
              "id": 230230
            }, {
              "value": "拜泉县",
              "label": "拜泉县",
              "id": 230231
            }, {
              "value": "讷河市",
              "label": "讷河市",
              "id": 230281
            }]
          }, {
            "value": "鸡西市",
            "label": "鸡西市",
            "id": 230300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230301
            }, {
              "value": "鸡冠区",
              "label": "鸡冠区",
              "id": 230302
            }, {
              "value": "恒山区",
              "label": "恒山区",
              "id": 230303
            }, {
              "value": "滴道区",
              "label": "滴道区",
              "id": 230304
            }, {
              "value": "梨树区",
              "label": "梨树区",
              "id": 230305
            }, {
              "value": "城子河区",
              "label": "城子河区",
              "id": 230306
            }, {
              "value": "麻山区",
              "label": "麻山区",
              "id": 230307
            }, {
              "value": "鸡东县",
              "label": "鸡东县",
              "id": 230321
            }, {
              "value": "虎林市",
              "label": "虎林市",
              "id": 230381
            }, {
              "value": "密山市",
              "label": "密山市",
              "id": 230382
            }]
          }, {
            "value": "鹤岗市",
            "label": "鹤岗市",
            "id": 230400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230401
            }, {
              "value": "向阳区",
              "label": "向阳区",
              "id": 230402
            }, {
              "value": "工农区",
              "label": "工农区",
              "id": 230403
            }, {
              "value": "南山区",
              "label": "南山区",
              "id": 230404
            }, {
              "value": "兴安区",
              "label": "兴安区",
              "id": 230405
            }, {
              "value": "东山区",
              "label": "东山区",
              "id": 230406
            }, {
              "value": "兴山区",
              "label": "兴山区",
              "id": 230407
            }, {
              "value": "萝北县",
              "label": "萝北县",
              "id": 230421
            }, {
              "value": "绥滨县",
              "label": "绥滨县",
              "id": 230422
            }]
          }, {
            "value": "双鸭山市",
            "label": "双鸭山市",
            "id": 230500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230501
            }, {
              "value": "尖山区",
              "label": "尖山区",
              "id": 230502
            }, {
              "value": "岭东区",
              "label": "岭东区",
              "id": 230503
            }, {
              "value": "四方台区",
              "label": "四方台区",
              "id": 230505
            }, {
              "value": "宝山区",
              "label": "宝山区",
              "id": 230506
            }, {
              "value": "集贤县",
              "label": "集贤县",
              "id": 230521
            }, {
              "value": "友谊县",
              "label": "友谊县",
              "id": 230522
            }, {
              "value": "宝清县",
              "label": "宝清县",
              "id": 230523
            }, {
              "value": "饶河县",
              "label": "饶河县",
              "id": 230524
            }]
          }, {
            "value": "大庆市",
            "label": "大庆市",
            "id": 230600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230601
            }, {
              "value": "萨尔图区",
              "label": "萨尔图区",
              "id": 230602
            }, {
              "value": "龙凤区",
              "label": "龙凤区",
              "id": 230603
            }, {
              "value": "让胡路区",
              "label": "让胡路区",
              "id": 230604
            }, {
              "value": "红岗区",
              "label": "红岗区",
              "id": 230605
            }, {
              "value": "大同区",
              "label": "大同区",
              "id": 230606
            }, {
              "value": "肇州县",
              "label": "肇州县",
              "id": 230621
            }, {
              "value": "肇源县",
              "label": "肇源县",
              "id": 230622
            }, {
              "value": "林甸县",
              "label": "林甸县",
              "id": 230623
            }, {
              "value": "杜尔伯特蒙古族自治县",
              "label": "杜尔伯特蒙古族自治县",
              "id": 230624
            }]
          }, {
            "value": "伊春市",
            "label": "伊春市",
            "id": 230700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230701
            }, {
              "value": "伊春区",
              "label": "伊春区",
              "id": 230702
            }, {
              "value": "南岔区",
              "label": "南岔区",
              "id": 230703
            }, {
              "value": "友好区",
              "label": "友好区",
              "id": 230704
            }, {
              "value": "西林区",
              "label": "西林区",
              "id": 230705
            }, {
              "value": "翠峦区",
              "label": "翠峦区",
              "id": 230706
            }, {
              "value": "新青区",
              "label": "新青区",
              "id": 230707
            }, {
              "value": "美溪区",
              "label": "美溪区",
              "id": 230708
            }, {
              "value": "金山屯区",
              "label": "金山屯区",
              "id": 230709
            }, {
              "value": "五营区",
              "label": "五营区",
              "id": 230710
            }, {
              "value": "乌马河区",
              "label": "乌马河区",
              "id": 230711
            }, {
              "value": "汤旺河区",
              "label": "汤旺河区",
              "id": 230712
            }, {
              "value": "带岭区",
              "label": "带岭区",
              "id": 230713
            }, {
              "value": "乌伊岭区",
              "label": "乌伊岭区",
              "id": 230714
            }, {
              "value": "红星区",
              "label": "红星区",
              "id": 230715
            }, {
              "value": "上甘岭区",
              "label": "上甘岭区",
              "id": 230716
            }, {
              "value": "嘉荫县",
              "label": "嘉荫县",
              "id": 230722
            }, {
              "value": "铁力市",
              "label": "铁力市",
              "id": 230781
            }]
          }, {
            "value": "佳木斯市",
            "label": "佳木斯市",
            "id": 230800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230801
            }, {
              "value": "向阳区",
              "label": "向阳区",
              "id": 230803
            }, {
              "value": "前进区",
              "label": "前进区",
              "id": 230804
            }, {
              "value": "东风区",
              "label": "东风区",
              "id": 230805
            }, {
              "value": "郊区",
              "label": "郊区",
              "id": 230811
            }, {
              "value": "桦南县",
              "label": "桦南县",
              "id": 230822
            }, {
              "value": "桦川县",
              "label": "桦川县",
              "id": 230826
            }, {
              "value": "汤原县",
              "label": "汤原县",
              "id": 230828
            }, {
              "value": "同江市",
              "label": "同江市",
              "id": 230881
            }, {
              "value": "富锦市",
              "label": "富锦市",
              "id": 230882
            }, {
              "value": "抚远市",
              "label": "抚远市",
              "id": 230883
            }]
          }, {
            "value": "七台河市",
            "label": "七台河市",
            "id": 230900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 230901
            }, {
              "value": "新兴区",
              "label": "新兴区",
              "id": 230902
            }, {
              "value": "桃山区",
              "label": "桃山区",
              "id": 230903
            }, {
              "value": "茄子河区",
              "label": "茄子河区",
              "id": 230904
            }, {
              "value": "勃利县",
              "label": "勃利县",
              "id": 230921
            }]
          }, {
            "value": "牡丹江市",
            "label": "牡丹江市",
            "id": 231000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 231001
            }, {
              "value": "东安区",
              "label": "东安区",
              "id": 231002
            }, {
              "value": "阳明区",
              "label": "阳明区",
              "id": 231003
            }, {
              "value": "爱民区",
              "label": "爱民区",
              "id": 231004
            }, {
              "value": "西安区",
              "label": "西安区",
              "id": 231005
            }, {
              "value": "林口县",
              "label": "林口县",
              "id": 231025
            }, {
              "value": "绥芬河市",
              "label": "绥芬河市",
              "id": 231081
            }, {
              "value": "海林市",
              "label": "海林市",
              "id": 231083
            }, {
              "value": "宁安市",
              "label": "宁安市",
              "id": 231084
            }, {
              "value": "穆棱市",
              "label": "穆棱市",
              "id": 231085
            }, {
              "value": "东宁市",
              "label": "东宁市",
              "id": 231086
            }]
          }, {
            "value": "黑河市",
            "label": "黑河市",
            "id": 231100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 231101
            }, {
              "value": "爱辉区",
              "label": "爱辉区",
              "id": 231102
            }, {
              "value": "嫩江县",
              "label": "嫩江县",
              "id": 231121
            }, {
              "value": "逊克县",
              "label": "逊克县",
              "id": 231123
            }, {
              "value": "孙吴县",
              "label": "孙吴县",
              "id": 231124
            }, {
              "value": "北安市",
              "label": "北安市",
              "id": 231181
            }, {
              "value": "五大连池市",
              "label": "五大连池市",
              "id": 231182
            }]
          }, {
            "value": "绥化市",
            "label": "绥化市",
            "id": 231200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 231201
            }, {
              "value": "北林区",
              "label": "北林区",
              "id": 231202
            }, {
              "value": "望奎县",
              "label": "望奎县",
              "id": 231221
            }, {
              "value": "兰西县",
              "label": "兰西县",
              "id": 231222
            }, {
              "value": "青冈县",
              "label": "青冈县",
              "id": 231223
            }, {
              "value": "庆安县",
              "label": "庆安县",
              "id": 231224
            }, {
              "value": "明水县",
              "label": "明水县",
              "id": 231225
            }, {
              "value": "绥棱县",
              "label": "绥棱县",
              "id": 231226
            }, {
              "value": "安达市",
              "label": "安达市",
              "id": 231281
            }, {
              "value": "肇东市",
              "label": "肇东市",
              "id": 231282
            }, {
              "value": "海伦市",
              "label": "海伦市",
              "id": 231283
            }]
          }, {
            "value": "大兴安岭地区",
            "label": "大兴安岭地区",
            "id": 232700,
            "children": [{
              "value": "呼玛县",
              "label": "呼玛县",
              "id": 232721
            }, {
              "value": "塔河县",
              "label": "塔河县",
              "id": 232722
            }, {
              "value": "漠河县",
              "label": "漠河县",
              "id": 232723
            }]
          }]
        }, {
          "value": "上海市",
          "label": "上海市",
          "id": 310000,
          "children": [{
            "value": "市辖区",
            "label": "市辖区",
            "id": 310100,
            "children": [{
              "value": "黄浦区",
              "label": "黄浦区",
              "id": 310101
            }, {
              "value": "徐汇区",
              "label": "徐汇区",
              "id": 310104
            }, {
              "value": "长宁区",
              "label": "长宁区",
              "id": 310105
            }, {
              "value": "静安区",
              "label": "静安区",
              "id": 310106
            }, {
              "value": "普陀区",
              "label": "普陀区",
              "id": 310107
            }, {
              "value": "虹口区",
              "label": "虹口区",
              "id": 310109
            }, {
              "value": "杨浦区",
              "label": "杨浦区",
              "id": 310110
            }, {
              "value": "闵行区",
              "label": "闵行区",
              "id": 310112
            }, {
              "value": "宝山区",
              "label": "宝山区",
              "id": 310113
            }, {
              "value": "嘉定区",
              "label": "嘉定区",
              "id": 310114
            }, {
              "value": "浦东新区",
              "label": "浦东新区",
              "id": 310115
            }, {
              "value": "金山区",
              "label": "金山区",
              "id": 310116
            }, {
              "value": "松江区",
              "label": "松江区",
              "id": 310117
            }, {
              "value": "青浦区",
              "label": "青浦区",
              "id": 310118
            }, {
              "value": "奉贤区",
              "label": "奉贤区",
              "id": 310120
            }, {
              "value": "崇明区",
              "label": "崇明区",
              "id": 310151
            }]
          }]
        }, {
          "value": "江苏省",
          "label": "江苏省",
          "id": 320000,
          "children": [{
            "value": "南京市",
            "label": "南京市",
            "id": 320100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320101
            }, {
              "value": "玄武区",
              "label": "玄武区",
              "id": 320102
            }, {
              "value": "秦淮区",
              "label": "秦淮区",
              "id": 320104
            }, {
              "value": "建邺区",
              "label": "建邺区",
              "id": 320105
            }, {
              "value": "鼓楼区",
              "label": "鼓楼区",
              "id": 320106
            }, {
              "value": "浦口区",
              "label": "浦口区",
              "id": 320111
            }, {
              "value": "栖霞区",
              "label": "栖霞区",
              "id": 320113
            }, {
              "value": "雨花台区",
              "label": "雨花台区",
              "id": 320114
            }, {
              "value": "江宁区",
              "label": "江宁区",
              "id": 320115
            }, {
              "value": "六合区",
              "label": "六合区",
              "id": 320116
            }, {
              "value": "溧水区",
              "label": "溧水区",
              "id": 320117
            }, {
              "value": "高淳区",
              "label": "高淳区",
              "id": 320118
            }]
          }, {
            "value": "无锡市",
            "label": "无锡市",
            "id": 320200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320201
            }, {
              "value": "锡山区",
              "label": "锡山区",
              "id": 320205
            }, {
              "value": "惠山区",
              "label": "惠山区",
              "id": 320206
            }, {
              "value": "滨湖区",
              "label": "滨湖区",
              "id": 320211
            }, {
              "value": "梁溪区",
              "label": "梁溪区",
              "id": 320213
            }, {
              "value": "新吴区",
              "label": "新吴区",
              "id": 320214
            }, {
              "value": "江阴市",
              "label": "江阴市",
              "id": 320281
            }, {
              "value": "宜兴市",
              "label": "宜兴市",
              "id": 320282
            }]
          }, {
            "value": "徐州市",
            "label": "徐州市",
            "id": 320300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320301
            }, {
              "value": "鼓楼区",
              "label": "鼓楼区",
              "id": 320302
            }, {
              "value": "云龙区",
              "label": "云龙区",
              "id": 320303
            }, {
              "value": "贾汪区",
              "label": "贾汪区",
              "id": 320305
            }, {
              "value": "泉山区",
              "label": "泉山区",
              "id": 320311
            }, {
              "value": "铜山区",
              "label": "铜山区",
              "id": 320312
            }, {
              "value": "丰县",
              "label": "丰县",
              "id": 320321
            }, {
              "value": "沛县",
              "label": "沛县",
              "id": 320322
            }, {
              "value": "睢宁县",
              "label": "睢宁县",
              "id": 320324
            }, {
              "value": "新沂市",
              "label": "新沂市",
              "id": 320381
            }, {
              "value": "邳州市",
              "label": "邳州市",
              "id": 320382
            }]
          }, {
            "value": "常州市",
            "label": "常州市",
            "id": 320400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320401
            }, {
              "value": "天宁区",
              "label": "天宁区",
              "id": 320402
            }, {
              "value": "钟楼区",
              "label": "钟楼区",
              "id": 320404
            }, {
              "value": "新北区",
              "label": "新北区",
              "id": 320411
            }, {
              "value": "武进区",
              "label": "武进区",
              "id": 320412
            }, {
              "value": "金坛区",
              "label": "金坛区",
              "id": 320413
            }, {
              "value": "溧阳市",
              "label": "溧阳市",
              "id": 320481
            }]
          }, {
            "value": "苏州市",
            "label": "苏州市",
            "id": 320500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320501
            }, {
              "value": "虎丘区",
              "label": "虎丘区",
              "id": 320505
            }, {
              "value": "吴中区",
              "label": "吴中区",
              "id": 320506
            }, {
              "value": "相城区",
              "label": "相城区",
              "id": 320507
            }, {
              "value": "姑苏区",
              "label": "姑苏区",
              "id": 320508
            }, {
              "value": "吴江区",
              "label": "吴江区",
              "id": 320509
            }, {
              "value": "常熟市",
              "label": "常熟市",
              "id": 320581
            }, {
              "value": "张家港市",
              "label": "张家港市",
              "id": 320582
            }, {
              "value": "昆山市",
              "label": "昆山市",
              "id": 320583
            }, {
              "value": "太仓市",
              "label": "太仓市",
              "id": 320585
            }]
          }, {
            "value": "南通市",
            "label": "南通市",
            "id": 320600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320601
            }, {
              "value": "崇川区",
              "label": "崇川区",
              "id": 320602
            }, {
              "value": "港闸区",
              "label": "港闸区",
              "id": 320611
            }, {
              "value": "通州区",
              "label": "通州区",
              "id": 320612
            }, {
              "value": "海安县",
              "label": "海安县",
              "id": 320621
            }, {
              "value": "如东县",
              "label": "如东县",
              "id": 320623
            }, {
              "value": "启东市",
              "label": "启东市",
              "id": 320681
            }, {
              "value": "如皋市",
              "label": "如皋市",
              "id": 320682
            }, {
              "value": "海门市",
              "label": "海门市",
              "id": 320684
            }]
          }, {
            "value": "连云港市",
            "label": "连云港市",
            "id": 320700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320701
            }, {
              "value": "连云区",
              "label": "连云区",
              "id": 320703
            }, {
              "value": "海州区",
              "label": "海州区",
              "id": 320706
            }, {
              "value": "赣榆区",
              "label": "赣榆区",
              "id": 320707
            }, {
              "value": "东海县",
              "label": "东海县",
              "id": 320722
            }, {
              "value": "灌云县",
              "label": "灌云县",
              "id": 320723
            }, {
              "value": "灌南县",
              "label": "灌南县",
              "id": 320724
            }]
          }, {
            "value": "淮安市",
            "label": "淮安市",
            "id": 320800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320801
            }, {
              "value": "淮安区",
              "label": "淮安区",
              "id": 320803
            }, {
              "value": "淮阴区",
              "label": "淮阴区",
              "id": 320804
            }, {
              "value": "清江浦区",
              "label": "清江浦区",
              "id": 320812
            }, {
              "value": "洪泽区",
              "label": "洪泽区",
              "id": 320813
            }, {
              "value": "涟水县",
              "label": "涟水县",
              "id": 320826
            }, {
              "value": "盱眙县",
              "label": "盱眙县",
              "id": 320830
            }, {
              "value": "金湖县",
              "label": "金湖县",
              "id": 320831
            }]
          }, {
            "value": "盐城市",
            "label": "盐城市",
            "id": 320900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 320901
            }, {
              "value": "亭湖区",
              "label": "亭湖区",
              "id": 320902
            }, {
              "value": "盐都区",
              "label": "盐都区",
              "id": 320903
            }, {
              "value": "大丰区",
              "label": "大丰区",
              "id": 320904
            }, {
              "value": "响水县",
              "label": "响水县",
              "id": 320921
            }, {
              "value": "滨海县",
              "label": "滨海县",
              "id": 320922
            }, {
              "value": "阜宁县",
              "label": "阜宁县",
              "id": 320923
            }, {
              "value": "射阳县",
              "label": "射阳县",
              "id": 320924
            }, {
              "value": "建湖县",
              "label": "建湖县",
              "id": 320925
            }, {
              "value": "东台市",
              "label": "东台市",
              "id": 320981
            }]
          }, {
            "value": "扬州市",
            "label": "扬州市",
            "id": 321000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 321001
            }, {
              "value": "广陵区",
              "label": "广陵区",
              "id": 321002
            }, {
              "value": "邗江区",
              "label": "邗江区",
              "id": 321003
            }, {
              "value": "江都区",
              "label": "江都区",
              "id": 321012
            }, {
              "value": "宝应县",
              "label": "宝应县",
              "id": 321023
            }, {
              "value": "仪征市",
              "label": "仪征市",
              "id": 321081
            }, {
              "value": "高邮市",
              "label": "高邮市",
              "id": 321084
            }]
          }, {
            "value": "镇江市",
            "label": "镇江市",
            "id": 321100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 321101
            }, {
              "value": "京口区",
              "label": "京口区",
              "id": 321102
            }, {
              "value": "润州区",
              "label": "润州区",
              "id": 321111
            }, {
              "value": "丹徒区",
              "label": "丹徒区",
              "id": 321112
            }, {
              "value": "丹阳市",
              "label": "丹阳市",
              "id": 321181
            }, {
              "value": "扬中市",
              "label": "扬中市",
              "id": 321182
            }, {
              "value": "句容市",
              "label": "句容市",
              "id": 321183
            }]
          }, {
            "value": "泰州市",
            "label": "泰州市",
            "id": 321200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 321201
            }, {
              "value": "海陵区",
              "label": "海陵区",
              "id": 321202
            }, {
              "value": "高港区",
              "label": "高港区",
              "id": 321203
            }, {
              "value": "姜堰区",
              "label": "姜堰区",
              "id": 321204
            }, {
              "value": "兴化市",
              "label": "兴化市",
              "id": 321281
            }, {
              "value": "靖江市",
              "label": "靖江市",
              "id": 321282
            }, {
              "value": "泰兴市",
              "label": "泰兴市",
              "id": 321283
            }]
          }, {
            "value": "宿迁市",
            "label": "宿迁市",
            "id": 321300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 321301
            }, {
              "value": "宿城区",
              "label": "宿城区",
              "id": 321302
            }, {
              "value": "宿豫区",
              "label": "宿豫区",
              "id": 321311
            }, {
              "value": "沭阳县",
              "label": "沭阳县",
              "id": 321322
            }, {
              "value": "泗阳县",
              "label": "泗阳县",
              "id": 321323
            }, {
              "value": "泗洪县",
              "label": "泗洪县",
              "id": 321324
            }]
          }]
        }, {
          "value": "浙江省",
          "label": "浙江省",
          "id": 330000,
          "children": [{
            "value": "杭州市",
            "label": "杭州市",
            "id": 330100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330101
            }, {
              "value": "上城区",
              "label": "上城区",
              "id": 330102
            }, {
              "value": "下城区",
              "label": "下城区",
              "id": 330103
            }, {
              "value": "江干区",
              "label": "江干区",
              "id": 330104
            }, {
              "value": "拱墅区",
              "label": "拱墅区",
              "id": 330105
            }, {
              "value": "西湖区",
              "label": "西湖区",
              "id": 330106
            }, {
              "value": "滨江区",
              "label": "滨江区",
              "id": 330108
            }, {
              "value": "萧山区",
              "label": "萧山区",
              "id": 330109
            }, {
              "value": "余杭区",
              "label": "余杭区",
              "id": 330110
            }, {
              "value": "富阳区",
              "label": "富阳区",
              "id": 330111
            }, {
              "value": "桐庐县",
              "label": "桐庐县",
              "id": 330122
            }, {
              "value": "淳安县",
              "label": "淳安县",
              "id": 330127
            }, {
              "value": "建德市",
              "label": "建德市",
              "id": 330182
            }, {
              "value": "临安市",
              "label": "临安市",
              "id": 330185
            }]
          }, {
            "value": "宁波市",
            "label": "宁波市",
            "id": 330200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330201
            }, {
              "value": "海曙区",
              "label": "海曙区",
              "id": 330203
            }, {
              "value": "江东区",
              "label": "江东区",
              "id": 330204
            }, {
              "value": "江北区",
              "label": "江北区",
              "id": 330205
            }, {
              "value": "北仑区",
              "label": "北仑区",
              "id": 330206
            }, {
              "value": "镇海区",
              "label": "镇海区",
              "id": 330211
            }, {
              "value": "鄞州区",
              "label": "鄞州区",
              "id": 330212
            }, {
              "value": "象山县",
              "label": "象山县",
              "id": 330225
            }, {
              "value": "宁海县",
              "label": "宁海县",
              "id": 330226
            }, {
              "value": "余姚市",
              "label": "余姚市",
              "id": 330281
            }, {
              "value": "慈溪市",
              "label": "慈溪市",
              "id": 330282
            }, {
              "value": "奉化市",
              "label": "奉化市",
              "id": 330283
            }]
          }, {
            "value": "温州市",
            "label": "温州市",
            "id": 330300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330301
            }, {
              "value": "鹿城区",
              "label": "鹿城区",
              "id": 330302
            }, {
              "value": "龙湾区",
              "label": "龙湾区",
              "id": 330303
            }, {
              "value": "瓯海区",
              "label": "瓯海区",
              "id": 330304
            }, {
              "value": "洞头区",
              "label": "洞头区",
              "id": 330305
            }, {
              "value": "永嘉县",
              "label": "永嘉县",
              "id": 330324
            }, {
              "value": "平阳县",
              "label": "平阳县",
              "id": 330326
            }, {
              "value": "苍南县",
              "label": "苍南县",
              "id": 330327
            }, {
              "value": "文成县",
              "label": "文成县",
              "id": 330328
            }, {
              "value": "泰顺县",
              "label": "泰顺县",
              "id": 330329
            }, {
              "value": "瑞安市",
              "label": "瑞安市",
              "id": 330381
            }, {
              "value": "乐清市",
              "label": "乐清市",
              "id": 330382
            }]
          }, {
            "value": "嘉兴市",
            "label": "嘉兴市",
            "id": 330400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330401
            }, {
              "value": "南湖区",
              "label": "南湖区",
              "id": 330402
            }, {
              "value": "秀洲区",
              "label": "秀洲区",
              "id": 330411
            }, {
              "value": "嘉善县",
              "label": "嘉善县",
              "id": 330421
            }, {
              "value": "海盐县",
              "label": "海盐县",
              "id": 330424
            }, {
              "value": "海宁市",
              "label": "海宁市",
              "id": 330481
            }, {
              "value": "平湖市",
              "label": "平湖市",
              "id": 330482
            }, {
              "value": "桐乡市",
              "label": "桐乡市",
              "id": 330483
            }]
          }, {
            "value": "湖州市",
            "label": "湖州市",
            "id": 330500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330501
            }, {
              "value": "吴兴区",
              "label": "吴兴区",
              "id": 330502
            }, {
              "value": "南浔区",
              "label": "南浔区",
              "id": 330503
            }, {
              "value": "德清县",
              "label": "德清县",
              "id": 330521
            }, {
              "value": "长兴县",
              "label": "长兴县",
              "id": 330522
            }, {
              "value": "安吉县",
              "label": "安吉县",
              "id": 330523
            }]
          }, {
            "value": "绍兴市",
            "label": "绍兴市",
            "id": 330600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330601
            }, {
              "value": "越城区",
              "label": "越城区",
              "id": 330602
            }, {
              "value": "柯桥区",
              "label": "柯桥区",
              "id": 330603
            }, {
              "value": "上虞区",
              "label": "上虞区",
              "id": 330604
            }, {
              "value": "新昌县",
              "label": "新昌县",
              "id": 330624
            }, {
              "value": "诸暨市",
              "label": "诸暨市",
              "id": 330681
            }, {
              "value": "嵊州市",
              "label": "嵊州市",
              "id": 330683
            }]
          }, {
            "value": "金华市",
            "label": "金华市",
            "id": 330700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330701
            }, {
              "value": "婺城区",
              "label": "婺城区",
              "id": 330702
            }, {
              "value": "金东区",
              "label": "金东区",
              "id": 330703
            }, {
              "value": "武义县",
              "label": "武义县",
              "id": 330723
            }, {
              "value": "浦江县",
              "label": "浦江县",
              "id": 330726
            }, {
              "value": "磐安县",
              "label": "磐安县",
              "id": 330727
            }, {
              "value": "兰溪市",
              "label": "兰溪市",
              "id": 330781
            }, {
              "value": "义乌市",
              "label": "义乌市",
              "id": 330782
            }, {
              "value": "东阳市",
              "label": "东阳市",
              "id": 330783
            }, {
              "value": "永康市",
              "label": "永康市",
              "id": 330784
            }]
          }, {
            "value": "衢州市",
            "label": "衢州市",
            "id": 330800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330801
            }, {
              "value": "柯城区",
              "label": "柯城区",
              "id": 330802
            }, {
              "value": "衢江区",
              "label": "衢江区",
              "id": 330803
            }, {
              "value": "常山县",
              "label": "常山县",
              "id": 330822
            }, {
              "value": "开化县",
              "label": "开化县",
              "id": 330824
            }, {
              "value": "龙游县",
              "label": "龙游县",
              "id": 330825
            }, {
              "value": "江山市",
              "label": "江山市",
              "id": 330881
            }]
          }, {
            "value": "舟山市",
            "label": "舟山市",
            "id": 330900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 330901
            }, {
              "value": "定海区",
              "label": "定海区",
              "id": 330902
            }, {
              "value": "普陀区",
              "label": "普陀区",
              "id": 330903
            }, {
              "value": "岱山县",
              "label": "岱山县",
              "id": 330921
            }, {
              "value": "嵊泗县",
              "label": "嵊泗县",
              "id": 330922
            }]
          }, {
            "value": "台州市",
            "label": "台州市",
            "id": 331000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 331001
            }, {
              "value": "椒江区",
              "label": "椒江区",
              "id": 331002
            }, {
              "value": "黄岩区",
              "label": "黄岩区",
              "id": 331003
            }, {
              "value": "路桥区",
              "label": "路桥区",
              "id": 331004
            }, {
              "value": "玉环县",
              "label": "玉环县",
              "id": 331021
            }, {
              "value": "三门县",
              "label": "三门县",
              "id": 331022
            }, {
              "value": "天台县",
              "label": "天台县",
              "id": 331023
            }, {
              "value": "仙居县",
              "label": "仙居县",
              "id": 331024
            }, {
              "value": "温岭市",
              "label": "温岭市",
              "id": 331081
            }, {
              "value": "临海市",
              "label": "临海市",
              "id": 331082
            }]
          }, {
            "value": "丽水市",
            "label": "丽水市",
            "id": 331100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 331101
            }, {
              "value": "莲都区",
              "label": "莲都区",
              "id": 331102
            }, {
              "value": "青田县",
              "label": "青田县",
              "id": 331121
            }, {
              "value": "缙云县",
              "label": "缙云县",
              "id": 331122
            }, {
              "value": "遂昌县",
              "label": "遂昌县",
              "id": 331123
            }, {
              "value": "松阳县",
              "label": "松阳县",
              "id": 331124
            }, {
              "value": "云和县",
              "label": "云和县",
              "id": 331125
            }, {
              "value": "庆元县",
              "label": "庆元县",
              "id": 331126
            }, {
              "value": "景宁畲族自治县",
              "label": "景宁畲族自治县",
              "id": 331127
            }, {
              "value": "龙泉市",
              "label": "龙泉市",
              "id": 331181
            }]
          }]
        }, {
          "value": "安徽省",
          "label": "安徽省",
          "id": 340000,
          "children": [{
            "value": "合肥市",
            "label": "合肥市",
            "id": 340100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340101
            }, {
              "value": "瑶海区",
              "label": "瑶海区",
              "id": 340102
            }, {
              "value": "庐阳区",
              "label": "庐阳区",
              "id": 340103
            }, {
              "value": "蜀山区",
              "label": "蜀山区",
              "id": 340104
            }, {
              "value": "包河区",
              "label": "包河区",
              "id": 340111
            }, {
              "value": "长丰县",
              "label": "长丰县",
              "id": 340121
            }, {
              "value": "肥东县",
              "label": "肥东县",
              "id": 340122
            }, {
              "value": "肥西县",
              "label": "肥西县",
              "id": 340123
            }, {
              "value": "庐江县",
              "label": "庐江县",
              "id": 340124
            }, {
              "value": "巢湖市",
              "label": "巢湖市",
              "id": 340181
            }]
          }, {
            "value": "芜湖市",
            "label": "芜湖市",
            "id": 340200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340201
            }, {
              "value": "镜湖区",
              "label": "镜湖区",
              "id": 340202
            }, {
              "value": "弋江区",
              "label": "弋江区",
              "id": 340203
            }, {
              "value": "鸠江区",
              "label": "鸠江区",
              "id": 340207
            }, {
              "value": "三山区",
              "label": "三山区",
              "id": 340208
            }, {
              "value": "芜湖县",
              "label": "芜湖县",
              "id": 340221
            }, {
              "value": "繁昌县",
              "label": "繁昌县",
              "id": 340222
            }, {
              "value": "南陵县",
              "label": "南陵县",
              "id": 340223
            }, {
              "value": "无为县",
              "label": "无为县",
              "id": 340225
            }]
          }, {
            "value": "蚌埠市",
            "label": "蚌埠市",
            "id": 340300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340301
            }, {
              "value": "龙子湖区",
              "label": "龙子湖区",
              "id": 340302
            }, {
              "value": "蚌山区",
              "label": "蚌山区",
              "id": 340303
            }, {
              "value": "禹会区",
              "label": "禹会区",
              "id": 340304
            }, {
              "value": "淮上区",
              "label": "淮上区",
              "id": 340311
            }, {
              "value": "怀远县",
              "label": "怀远县",
              "id": 340321
            }, {
              "value": "五河县",
              "label": "五河县",
              "id": 340322
            }, {
              "value": "固镇县",
              "label": "固镇县",
              "id": 340323
            }]
          }, {
            "value": "淮南市",
            "label": "淮南市",
            "id": 340400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340401
            }, {
              "value": "大通区",
              "label": "大通区",
              "id": 340402
            }, {
              "value": "田家庵区",
              "label": "田家庵区",
              "id": 340403
            }, {
              "value": "谢家集区",
              "label": "谢家集区",
              "id": 340404
            }, {
              "value": "八公山区",
              "label": "八公山区",
              "id": 340405
            }, {
              "value": "潘集区",
              "label": "潘集区",
              "id": 340406
            }, {
              "value": "凤台县",
              "label": "凤台县",
              "id": 340421
            }, {
              "value": "寿县",
              "label": "寿县",
              "id": 340422
            }]
          }, {
            "value": "马鞍山市",
            "label": "马鞍山市",
            "id": 340500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340501
            }, {
              "value": "花山区",
              "label": "花山区",
              "id": 340503
            }, {
              "value": "雨山区",
              "label": "雨山区",
              "id": 340504
            }, {
              "value": "博望区",
              "label": "博望区",
              "id": 340506
            }, {
              "value": "当涂县",
              "label": "当涂县",
              "id": 340521
            }, {
              "value": "含山县",
              "label": "含山县",
              "id": 340522
            }, {
              "value": "和县",
              "label": "和县",
              "id": 340523
            }]
          }, {
            "value": "淮北市",
            "label": "淮北市",
            "id": 340600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340601
            }, {
              "value": "杜集区",
              "label": "杜集区",
              "id": 340602
            }, {
              "value": "相山区",
              "label": "相山区",
              "id": 340603
            }, {
              "value": "烈山区",
              "label": "烈山区",
              "id": 340604
            }, {
              "value": "濉溪县",
              "label": "濉溪县",
              "id": 340621
            }]
          }, {
            "value": "铜陵市",
            "label": "铜陵市",
            "id": 340700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340701
            }, {
              "value": "铜官区",
              "label": "铜官区",
              "id": 340705
            }, {
              "value": "义安区",
              "label": "义安区",
              "id": 340706
            }, {
              "value": "郊区",
              "label": "郊区",
              "id": 340711
            }, {
              "value": "枞阳县",
              "label": "枞阳县",
              "id": 340722
            }]
          }, {
            "value": "安庆市",
            "label": "安庆市",
            "id": 340800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 340801
            }, {
              "value": "迎江区",
              "label": "迎江区",
              "id": 340802
            }, {
              "value": "大观区",
              "label": "大观区",
              "id": 340803
            }, {
              "value": "宜秀区",
              "label": "宜秀区",
              "id": 340811
            }, {
              "value": "怀宁县",
              "label": "怀宁县",
              "id": 340822
            }, {
              "value": "潜山县",
              "label": "潜山县",
              "id": 340824
            }, {
              "value": "太湖县",
              "label": "太湖县",
              "id": 340825
            }, {
              "value": "宿松县",
              "label": "宿松县",
              "id": 340826
            }, {
              "value": "望江县",
              "label": "望江县",
              "id": 340827
            }, {
              "value": "岳西县",
              "label": "岳西县",
              "id": 340828
            }, {
              "value": "桐城市",
              "label": "桐城市",
              "id": 340881
            }]
          }, {
            "value": "黄山市",
            "label": "黄山市",
            "id": 341000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341001
            }, {
              "value": "屯溪区",
              "label": "屯溪区",
              "id": 341002
            }, {
              "value": "黄山区",
              "label": "黄山区",
              "id": 341003
            }, {
              "value": "徽州区",
              "label": "徽州区",
              "id": 341004
            }, {
              "value": "歙县",
              "label": "歙县",
              "id": 341021
            }, {
              "value": "休宁县",
              "label": "休宁县",
              "id": 341022
            }, {
              "value": "黟县",
              "label": "黟县",
              "id": 341023
            }, {
              "value": "祁门县",
              "label": "祁门县",
              "id": 341024
            }]
          }, {
            "value": "滁州市",
            "label": "滁州市",
            "id": 341100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341101
            }, {
              "value": "琅琊区",
              "label": "琅琊区",
              "id": 341102
            }, {
              "value": "南谯区",
              "label": "南谯区",
              "id": 341103
            }, {
              "value": "来安县",
              "label": "来安县",
              "id": 341122
            }, {
              "value": "全椒县",
              "label": "全椒县",
              "id": 341124
            }, {
              "value": "定远县",
              "label": "定远县",
              "id": 341125
            }, {
              "value": "凤阳县",
              "label": "凤阳县",
              "id": 341126
            }, {
              "value": "天长市",
              "label": "天长市",
              "id": 341181
            }, {
              "value": "明光市",
              "label": "明光市",
              "id": 341182
            }]
          }, {
            "value": "阜阳市",
            "label": "阜阳市",
            "id": 341200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341201
            }, {
              "value": "颍州区",
              "label": "颍州区",
              "id": 341202
            }, {
              "value": "颍东区",
              "label": "颍东区",
              "id": 341203
            }, {
              "value": "颍泉区",
              "label": "颍泉区",
              "id": 341204
            }, {
              "value": "临泉县",
              "label": "临泉县",
              "id": 341221
            }, {
              "value": "太和县",
              "label": "太和县",
              "id": 341222
            }, {
              "value": "阜南县",
              "label": "阜南县",
              "id": 341225
            }, {
              "value": "颍上县",
              "label": "颍上县",
              "id": 341226
            }, {
              "value": "界首市",
              "label": "界首市",
              "id": 341282
            }]
          }, {
            "value": "宿州市",
            "label": "宿州市",
            "id": 341300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341301
            }, {
              "value": "埇桥区",
              "label": "埇桥区",
              "id": 341302
            }, {
              "value": "砀山县",
              "label": "砀山县",
              "id": 341321
            }, {
              "value": "萧县",
              "label": "萧县",
              "id": 341322
            }, {
              "value": "灵璧县",
              "label": "灵璧县",
              "id": 341323
            }, {
              "value": "泗县",
              "label": "泗县",
              "id": 341324
            }]
          }, {
            "value": "六安市",
            "label": "六安市",
            "id": 341500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341501
            }, {
              "value": "金安区",
              "label": "金安区",
              "id": 341502
            }, {
              "value": "裕安区",
              "label": "裕安区",
              "id": 341503
            }, {
              "value": "叶集区",
              "label": "叶集区",
              "id": 341504
            }, {
              "value": "霍邱县",
              "label": "霍邱县",
              "id": 341522
            }, {
              "value": "舒城县",
              "label": "舒城县",
              "id": 341523
            }, {
              "value": "金寨县",
              "label": "金寨县",
              "id": 341524
            }, {
              "value": "霍山县",
              "label": "霍山县",
              "id": 341525
            }]
          }, {
            "value": "亳州市",
            "label": "亳州市",
            "id": 341600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341601
            }, {
              "value": "谯城区",
              "label": "谯城区",
              "id": 341602
            }, {
              "value": "涡阳县",
              "label": "涡阳县",
              "id": 341621
            }, {
              "value": "蒙城县",
              "label": "蒙城县",
              "id": 341622
            }, {
              "value": "利辛县",
              "label": "利辛县",
              "id": 341623
            }]
          }, {
            "value": "池州市",
            "label": "池州市",
            "id": 341700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341701
            }, {
              "value": "贵池区",
              "label": "贵池区",
              "id": 341702
            }, {
              "value": "东至县",
              "label": "东至县",
              "id": 341721
            }, {
              "value": "石台县",
              "label": "石台县",
              "id": 341722
            }, {
              "value": "青阳县",
              "label": "青阳县",
              "id": 341723
            }]
          }, {
            "value": "宣城市",
            "label": "宣城市",
            "id": 341800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 341801
            }, {
              "value": "宣州区",
              "label": "宣州区",
              "id": 341802
            }, {
              "value": "郎溪县",
              "label": "郎溪县",
              "id": 341821
            }, {
              "value": "广德县",
              "label": "广德县",
              "id": 341822
            }, {
              "value": "泾县",
              "label": "泾县",
              "id": 341823
            }, {
              "value": "绩溪县",
              "label": "绩溪县",
              "id": 341824
            }, {
              "value": "旌德县",
              "label": "旌德县",
              "id": 341825
            }, {
              "value": "宁国市",
              "label": "宁国市",
              "id": 341881
            }]
          }]
        }, {
          "value": "福建省",
          "label": "福建省",
          "id": 350000,
          "children": [{
            "value": "福州市",
            "label": "福州市",
            "id": 350100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350101
            }, {
              "value": "鼓楼区",
              "label": "鼓楼区",
              "id": 350102
            }, {
              "value": "台江区",
              "label": "台江区",
              "id": 350103
            }, {
              "value": "仓山区",
              "label": "仓山区",
              "id": 350104
            }, {
              "value": "马尾区",
              "label": "马尾区",
              "id": 350105
            }, {
              "value": "晋安区",
              "label": "晋安区",
              "id": 350111
            }, {
              "value": "闽侯县",
              "label": "闽侯县",
              "id": 350121
            }, {
              "value": "连江县",
              "label": "连江县",
              "id": 350122
            }, {
              "value": "罗源县",
              "label": "罗源县",
              "id": 350123
            }, {
              "value": "闽清县",
              "label": "闽清县",
              "id": 350124
            }, {
              "value": "永泰县",
              "label": "永泰县",
              "id": 350125
            }, {
              "value": "平潭县",
              "label": "平潭县",
              "id": 350128
            }, {
              "value": "福清市",
              "label": "福清市",
              "id": 350181
            }, {
              "value": "长乐市",
              "label": "长乐市",
              "id": 350182
            }]
          }, {
            "value": "厦门市",
            "label": "厦门市",
            "id": 350200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350201
            }, {
              "value": "思明区",
              "label": "思明区",
              "id": 350203
            }, {
              "value": "海沧区",
              "label": "海沧区",
              "id": 350205
            }, {
              "value": "湖里区",
              "label": "湖里区",
              "id": 350206
            }, {
              "value": "集美区",
              "label": "集美区",
              "id": 350211
            }, {
              "value": "同安区",
              "label": "同安区",
              "id": 350212
            }, {
              "value": "翔安区",
              "label": "翔安区",
              "id": 350213
            }]
          }, {
            "value": "莆田市",
            "label": "莆田市",
            "id": 350300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350301
            }, {
              "value": "城厢区",
              "label": "城厢区",
              "id": 350302
            }, {
              "value": "涵江区",
              "label": "涵江区",
              "id": 350303
            }, {
              "value": "荔城区",
              "label": "荔城区",
              "id": 350304
            }, {
              "value": "秀屿区",
              "label": "秀屿区",
              "id": 350305
            }, {
              "value": "仙游县",
              "label": "仙游县",
              "id": 350322
            }]
          }, {
            "value": "三明市",
            "label": "三明市",
            "id": 350400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350401
            }, {
              "value": "梅列区",
              "label": "梅列区",
              "id": 350402
            }, {
              "value": "三元区",
              "label": "三元区",
              "id": 350403
            }, {
              "value": "明溪县",
              "label": "明溪县",
              "id": 350421
            }, {
              "value": "清流县",
              "label": "清流县",
              "id": 350423
            }, {
              "value": "宁化县",
              "label": "宁化县",
              "id": 350424
            }, {
              "value": "大田县",
              "label": "大田县",
              "id": 350425
            }, {
              "value": "尤溪县",
              "label": "尤溪县",
              "id": 350426
            }, {
              "value": "沙县",
              "label": "沙县",
              "id": 350427
            }, {
              "value": "将乐县",
              "label": "将乐县",
              "id": 350428
            }, {
              "value": "泰宁县",
              "label": "泰宁县",
              "id": 350429
            }, {
              "value": "建宁县",
              "label": "建宁县",
              "id": 350430
            }, {
              "value": "永安市",
              "label": "永安市",
              "id": 350481
            }]
          }, {
            "value": "泉州市",
            "label": "泉州市",
            "id": 350500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350501
            }, {
              "value": "鲤城区",
              "label": "鲤城区",
              "id": 350502
            }, {
              "value": "丰泽区",
              "label": "丰泽区",
              "id": 350503
            }, {
              "value": "洛江区",
              "label": "洛江区",
              "id": 350504
            }, {
              "value": "泉港区",
              "label": "泉港区",
              "id": 350505
            }, {
              "value": "惠安县",
              "label": "惠安县",
              "id": 350521
            }, {
              "value": "安溪县",
              "label": "安溪县",
              "id": 350524
            }, {
              "value": "永春县",
              "label": "永春县",
              "id": 350525
            }, {
              "value": "德化县",
              "label": "德化县",
              "id": 350526
            }, {
              "value": "金门县",
              "label": "金门县",
              "id": 350527
            }, {
              "value": "石狮市",
              "label": "石狮市",
              "id": 350581
            }, {
              "value": "晋江市",
              "label": "晋江市",
              "id": 350582
            }, {
              "value": "南安市",
              "label": "南安市",
              "id": 350583
            }]
          }, {
            "value": "漳州市",
            "label": "漳州市",
            "id": 350600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350601
            }, {
              "value": "芗城区",
              "label": "芗城区",
              "id": 350602
            }, {
              "value": "龙文区",
              "label": "龙文区",
              "id": 350603
            }, {
              "value": "云霄县",
              "label": "云霄县",
              "id": 350622
            }, {
              "value": "漳浦县",
              "label": "漳浦县",
              "id": 350623
            }, {
              "value": "诏安县",
              "label": "诏安县",
              "id": 350624
            }, {
              "value": "长泰县",
              "label": "长泰县",
              "id": 350625
            }, {
              "value": "东山县",
              "label": "东山县",
              "id": 350626
            }, {
              "value": "南靖县",
              "label": "南靖县",
              "id": 350627
            }, {
              "value": "平和县",
              "label": "平和县",
              "id": 350628
            }, {
              "value": "华安县",
              "label": "华安县",
              "id": 350629
            }, {
              "value": "龙海市",
              "label": "龙海市",
              "id": 350681
            }]
          }, {
            "value": "南平市",
            "label": "南平市",
            "id": 350700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350701
            }, {
              "value": "延平区",
              "label": "延平区",
              "id": 350702
            }, {
              "value": "建阳区",
              "label": "建阳区",
              "id": 350703
            }, {
              "value": "顺昌县",
              "label": "顺昌县",
              "id": 350721
            }, {
              "value": "浦城县",
              "label": "浦城县",
              "id": 350722
            }, {
              "value": "光泽县",
              "label": "光泽县",
              "id": 350723
            }, {
              "value": "松溪县",
              "label": "松溪县",
              "id": 350724
            }, {
              "value": "政和县",
              "label": "政和县",
              "id": 350725
            }, {
              "value": "邵武市",
              "label": "邵武市",
              "id": 350781
            }, {
              "value": "武夷山市",
              "label": "武夷山市",
              "id": 350782
            }, {
              "value": "建瓯市",
              "label": "建瓯市",
              "id": 350783
            }]
          }, {
            "value": "龙岩市",
            "label": "龙岩市",
            "id": 350800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350801
            }, {
              "value": "新罗区",
              "label": "新罗区",
              "id": 350802
            }, {
              "value": "永定区",
              "label": "永定区",
              "id": 350803
            }, {
              "value": "长汀县",
              "label": "长汀县",
              "id": 350821
            }, {
              "value": "上杭县",
              "label": "上杭县",
              "id": 350823
            }, {
              "value": "武平县",
              "label": "武平县",
              "id": 350824
            }, {
              "value": "连城县",
              "label": "连城县",
              "id": 350825
            }, {
              "value": "漳平市",
              "label": "漳平市",
              "id": 350881
            }]
          }, {
            "value": "宁德市",
            "label": "宁德市",
            "id": 350900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 350901
            }, {
              "value": "蕉城区",
              "label": "蕉城区",
              "id": 350902
            }, {
              "value": "霞浦县",
              "label": "霞浦县",
              "id": 350921
            }, {
              "value": "古田县",
              "label": "古田县",
              "id": 350922
            }, {
              "value": "屏南县",
              "label": "屏南县",
              "id": 350923
            }, {
              "value": "寿宁县",
              "label": "寿宁县",
              "id": 350924
            }, {
              "value": "周宁县",
              "label": "周宁县",
              "id": 350925
            }, {
              "value": "柘荣县",
              "label": "柘荣县",
              "id": 350926
            }, {
              "value": "福安市",
              "label": "福安市",
              "id": 350981
            }, {
              "value": "福鼎市",
              "label": "福鼎市",
              "id": 350982
            }]
          }]
        }, {
          "value": "江西省",
          "label": "江西省",
          "id": 360000,
          "children": [{
            "value": "南昌市",
            "label": "南昌市",
            "id": 360100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360101
            }, {
              "value": "东湖区",
              "label": "东湖区",
              "id": 360102
            }, {
              "value": "西湖区",
              "label": "西湖区",
              "id": 360103
            }, {
              "value": "青云谱区",
              "label": "青云谱区",
              "id": 360104
            }, {
              "value": "湾里区",
              "label": "湾里区",
              "id": 360105
            }, {
              "value": "青山湖区",
              "label": "青山湖区",
              "id": 360111
            }, {
              "value": "新建区",
              "label": "新建区",
              "id": 360112
            }, {
              "value": "南昌县",
              "label": "南昌县",
              "id": 360121
            }, {
              "value": "安义县",
              "label": "安义县",
              "id": 360123
            }, {
              "value": "进贤县",
              "label": "进贤县",
              "id": 360124
            }]
          }, {
            "value": "景德镇市",
            "label": "景德镇市",
            "id": 360200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360201
            }, {
              "value": "昌江区",
              "label": "昌江区",
              "id": 360202
            }, {
              "value": "珠山区",
              "label": "珠山区",
              "id": 360203
            }, {
              "value": "浮梁县",
              "label": "浮梁县",
              "id": 360222
            }, {
              "value": "乐平市",
              "label": "乐平市",
              "id": 360281
            }]
          }, {
            "value": "萍乡市",
            "label": "萍乡市",
            "id": 360300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360301
            }, {
              "value": "安源区",
              "label": "安源区",
              "id": 360302
            }, {
              "value": "湘东区",
              "label": "湘东区",
              "id": 360313
            }, {
              "value": "莲花县",
              "label": "莲花县",
              "id": 360321
            }, {
              "value": "上栗县",
              "label": "上栗县",
              "id": 360322
            }, {
              "value": "芦溪县",
              "label": "芦溪县",
              "id": 360323
            }]
          }, {
            "value": "九江市",
            "label": "九江市",
            "id": 360400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360401
            }, {
              "value": "濂溪区",
              "label": "濂溪区",
              "id": 360402
            }, {
              "value": "浔阳区",
              "label": "浔阳区",
              "id": 360403
            }, {
              "value": "九江县",
              "label": "九江县",
              "id": 360421
            }, {
              "value": "武宁县",
              "label": "武宁县",
              "id": 360423
            }, {
              "value": "修水县",
              "label": "修水县",
              "id": 360424
            }, {
              "value": "永修县",
              "label": "永修县",
              "id": 360425
            }, {
              "value": "德安县",
              "label": "德安县",
              "id": 360426
            }, {
              "value": "都昌县",
              "label": "都昌县",
              "id": 360428
            }, {
              "value": "湖口县",
              "label": "湖口县",
              "id": 360429
            }, {
              "value": "彭泽县",
              "label": "彭泽县",
              "id": 360430
            }, {
              "value": "瑞昌市",
              "label": "瑞昌市",
              "id": 360481
            }, {
              "value": "共青城市",
              "label": "共青城市",
              "id": 360482
            }, {
              "value": "庐山市",
              "label": "庐山市",
              "id": 360483
            }]
          }, {
            "value": "新余市",
            "label": "新余市",
            "id": 360500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360501
            }, {
              "value": "渝水区",
              "label": "渝水区",
              "id": 360502
            }, {
              "value": "分宜县",
              "label": "分宜县",
              "id": 360521
            }]
          }, {
            "value": "鹰潭市",
            "label": "鹰潭市",
            "id": 360600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360601
            }, {
              "value": "月湖区",
              "label": "月湖区",
              "id": 360602
            }, {
              "value": "余江县",
              "label": "余江县",
              "id": 360622
            }, {
              "value": "贵溪市",
              "label": "贵溪市",
              "id": 360681
            }]
          }, {
            "value": "赣州市",
            "label": "赣州市",
            "id": 360700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360701
            }, {
              "value": "章贡区",
              "label": "章贡区",
              "id": 360702
            }, {
              "value": "南康区",
              "label": "南康区",
              "id": 360703
            }, {
              "value": "赣县",
              "label": "赣县",
              "id": 360721
            }, {
              "value": "信丰县",
              "label": "信丰县",
              "id": 360722
            }, {
              "value": "大余县",
              "label": "大余县",
              "id": 360723
            }, {
              "value": "上犹县",
              "label": "上犹县",
              "id": 360724
            }, {
              "value": "崇义县",
              "label": "崇义县",
              "id": 360725
            }, {
              "value": "安远县",
              "label": "安远县",
              "id": 360726
            }, {
              "value": "龙南县",
              "label": "龙南县",
              "id": 360727
            }, {
              "value": "定南县",
              "label": "定南县",
              "id": 360728
            }, {
              "value": "全南县",
              "label": "全南县",
              "id": 360729
            }, {
              "value": "宁都县",
              "label": "宁都县",
              "id": 360730
            }, {
              "value": "于都县",
              "label": "于都县",
              "id": 360731
            }, {
              "value": "兴国县",
              "label": "兴国县",
              "id": 360732
            }, {
              "value": "会昌县",
              "label": "会昌县",
              "id": 360733
            }, {
              "value": "寻乌县",
              "label": "寻乌县",
              "id": 360734
            }, {
              "value": "石城县",
              "label": "石城县",
              "id": 360735
            }, {
              "value": "瑞金市",
              "label": "瑞金市",
              "id": 360781
            }]
          }, {
            "value": "吉安市",
            "label": "吉安市",
            "id": 360800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360801
            }, {
              "value": "吉州区",
              "label": "吉州区",
              "id": 360802
            }, {
              "value": "青原区",
              "label": "青原区",
              "id": 360803
            }, {
              "value": "吉安县",
              "label": "吉安县",
              "id": 360821
            }, {
              "value": "吉水县",
              "label": "吉水县",
              "id": 360822
            }, {
              "value": "峡江县",
              "label": "峡江县",
              "id": 360823
            }, {
              "value": "新干县",
              "label": "新干县",
              "id": 360824
            }, {
              "value": "永丰县",
              "label": "永丰县",
              "id": 360825
            }, {
              "value": "泰和县",
              "label": "泰和县",
              "id": 360826
            }, {
              "value": "遂川县",
              "label": "遂川县",
              "id": 360827
            }, {
              "value": "万安县",
              "label": "万安县",
              "id": 360828
            }, {
              "value": "安福县",
              "label": "安福县",
              "id": 360829
            }, {
              "value": "永新县",
              "label": "永新县",
              "id": 360830
            }, {
              "value": "井冈山市",
              "label": "井冈山市",
              "id": 360881
            }]
          }, {
            "value": "宜春市",
            "label": "宜春市",
            "id": 360900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 360901
            }, {
              "value": "袁州区",
              "label": "袁州区",
              "id": 360902
            }, {
              "value": "奉新县",
              "label": "奉新县",
              "id": 360921
            }, {
              "value": "万载县",
              "label": "万载县",
              "id": 360922
            }, {
              "value": "上高县",
              "label": "上高县",
              "id": 360923
            }, {
              "value": "宜丰县",
              "label": "宜丰县",
              "id": 360924
            }, {
              "value": "靖安县",
              "label": "靖安县",
              "id": 360925
            }, {
              "value": "铜鼓县",
              "label": "铜鼓县",
              "id": 360926
            }, {
              "value": "丰城市",
              "label": "丰城市",
              "id": 360981
            }, {
              "value": "樟树市",
              "label": "樟树市",
              "id": 360982
            }, {
              "value": "高安市",
              "label": "高安市",
              "id": 360983
            }]
          }, {
            "value": "抚州市",
            "label": "抚州市",
            "id": 361000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 361001
            }, {
              "value": "临川区",
              "label": "临川区",
              "id": 361002
            }, {
              "value": "南城县",
              "label": "南城县",
              "id": 361021
            }, {
              "value": "黎川县",
              "label": "黎川县",
              "id": 361022
            }, {
              "value": "南丰县",
              "label": "南丰县",
              "id": 361023
            }, {
              "value": "崇仁县",
              "label": "崇仁县",
              "id": 361024
            }, {
              "value": "乐安县",
              "label": "乐安县",
              "id": 361025
            }, {
              "value": "宜黄县",
              "label": "宜黄县",
              "id": 361026
            }, {
              "value": "金溪县",
              "label": "金溪县",
              "id": 361027
            }, {
              "value": "资溪县",
              "label": "资溪县",
              "id": 361028
            }, {
              "value": "东乡县",
              "label": "东乡县",
              "id": 361029
            }, {
              "value": "广昌县",
              "label": "广昌县",
              "id": 361030
            }]
          }, {
            "value": "上饶市",
            "label": "上饶市",
            "id": 361100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 361101
            }, {
              "value": "信州区",
              "label": "信州区",
              "id": 361102
            }, {
              "value": "广丰区",
              "label": "广丰区",
              "id": 361103
            }, {
              "value": "上饶县",
              "label": "上饶县",
              "id": 361121
            }, {
              "value": "玉山县",
              "label": "玉山县",
              "id": 361123
            }, {
              "value": "铅山县",
              "label": "铅山县",
              "id": 361124
            }, {
              "value": "横峰县",
              "label": "横峰县",
              "id": 361125
            }, {
              "value": "弋阳县",
              "label": "弋阳县",
              "id": 361126
            }, {
              "value": "余干县",
              "label": "余干县",
              "id": 361127
            }, {
              "value": "鄱阳县",
              "label": "鄱阳县",
              "id": 361128
            }, {
              "value": "万年县",
              "label": "万年县",
              "id": 361129
            }, {
              "value": "婺源县",
              "label": "婺源县",
              "id": 361130
            }, {
              "value": "德兴市",
              "label": "德兴市",
              "id": 361181
            }]
          }]
        }, {
          "value": "山东省",
          "label": "山东省",
          "id": 370000,
          "children": [{
            "value": "济南市",
            "label": "济南市",
            "id": 370100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370101
            }, {
              "value": "历下区",
              "label": "历下区",
              "id": 370102
            }, {
              "value": "市中区",
              "label": "市中区",
              "id": 370103
            }, {
              "value": "槐荫区",
              "label": "槐荫区",
              "id": 370104
            }, {
              "value": "天桥区",
              "label": "天桥区",
              "id": 370105
            }, {
              "value": "历城区",
              "label": "历城区",
              "id": 370112
            }, {
              "value": "长清区",
              "label": "长清区",
              "id": 370113
            }, {
              "value": "平阴县",
              "label": "平阴县",
              "id": 370124
            }, {
              "value": "济阳县",
              "label": "济阳县",
              "id": 370125
            }, {
              "value": "商河县",
              "label": "商河县",
              "id": 370126
            }, {
              "value": "章丘市",
              "label": "章丘市",
              "id": 370181
            }]
          }, {
            "value": "青岛市",
            "label": "青岛市",
            "id": 370200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370201
            }, {
              "value": "市南区",
              "label": "市南区",
              "id": 370202
            }, {
              "value": "市北区",
              "label": "市北区",
              "id": 370203
            }, {
              "value": "黄岛区",
              "label": "黄岛区",
              "id": 370211
            }, {
              "value": "崂山区",
              "label": "崂山区",
              "id": 370212
            }, {
              "value": "李沧区",
              "label": "李沧区",
              "id": 370213
            }, {
              "value": "城阳区",
              "label": "城阳区",
              "id": 370214
            }, {
              "value": "胶州市",
              "label": "胶州市",
              "id": 370281
            }, {
              "value": "即墨市",
              "label": "即墨市",
              "id": 370282
            }, {
              "value": "平度市",
              "label": "平度市",
              "id": 370283
            }, {
              "value": "莱西市",
              "label": "莱西市",
              "id": 370285
            }]
          }, {
            "value": "淄博市",
            "label": "淄博市",
            "id": 370300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370301
            }, {
              "value": "淄川区",
              "label": "淄川区",
              "id": 370302
            }, {
              "value": "张店区",
              "label": "张店区",
              "id": 370303
            }, {
              "value": "博山区",
              "label": "博山区",
              "id": 370304
            }, {
              "value": "临淄区",
              "label": "临淄区",
              "id": 370305
            }, {
              "value": "周村区",
              "label": "周村区",
              "id": 370306
            }, {
              "value": "桓台县",
              "label": "桓台县",
              "id": 370321
            }, {
              "value": "高青县",
              "label": "高青县",
              "id": 370322
            }, {
              "value": "沂源县",
              "label": "沂源县",
              "id": 370323
            }]
          }, {
            "value": "枣庄市",
            "label": "枣庄市",
            "id": 370400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370401
            }, {
              "value": "市中区",
              "label": "市中区",
              "id": 370402
            }, {
              "value": "薛城区",
              "label": "薛城区",
              "id": 370403
            }, {
              "value": "峄城区",
              "label": "峄城区",
              "id": 370404
            }, {
              "value": "台儿庄区",
              "label": "台儿庄区",
              "id": 370405
            }, {
              "value": "山亭区",
              "label": "山亭区",
              "id": 370406
            }, {
              "value": "滕州市",
              "label": "滕州市",
              "id": 370481
            }]
          }, {
            "value": "东营市",
            "label": "东营市",
            "id": 370500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370501
            }, {
              "value": "东营区",
              "label": "东营区",
              "id": 370502
            }, {
              "value": "河口区",
              "label": "河口区",
              "id": 370503
            }, {
              "value": "垦利区",
              "label": "垦利区",
              "id": 370505
            }, {
              "value": "利津县",
              "label": "利津县",
              "id": 370522
            }, {
              "value": "广饶县",
              "label": "广饶县",
              "id": 370523
            }]
          }, {
            "value": "烟台市",
            "label": "烟台市",
            "id": 370600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370601
            }, {
              "value": "芝罘区",
              "label": "芝罘区",
              "id": 370602
            }, {
              "value": "福山区",
              "label": "福山区",
              "id": 370611
            }, {
              "value": "牟平区",
              "label": "牟平区",
              "id": 370612
            }, {
              "value": "莱山区",
              "label": "莱山区",
              "id": 370613
            }, {
              "value": "长岛县",
              "label": "长岛县",
              "id": 370634
            }, {
              "value": "龙口市",
              "label": "龙口市",
              "id": 370681
            }, {
              "value": "莱阳市",
              "label": "莱阳市",
              "id": 370682
            }, {
              "value": "莱州市",
              "label": "莱州市",
              "id": 370683
            }, {
              "value": "蓬莱市",
              "label": "蓬莱市",
              "id": 370684
            }, {
              "value": "招远市",
              "label": "招远市",
              "id": 370685
            }, {
              "value": "栖霞市",
              "label": "栖霞市",
              "id": 370686
            }, {
              "value": "海阳市",
              "label": "海阳市",
              "id": 370687
            }]
          }, {
            "value": "潍坊市",
            "label": "潍坊市",
            "id": 370700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370701
            }, {
              "value": "潍城区",
              "label": "潍城区",
              "id": 370702
            }, {
              "value": "寒亭区",
              "label": "寒亭区",
              "id": 370703
            }, {
              "value": "坊子区",
              "label": "坊子区",
              "id": 370704
            }, {
              "value": "奎文区",
              "label": "奎文区",
              "id": 370705
            }, {
              "value": "临朐县",
              "label": "临朐县",
              "id": 370724
            }, {
              "value": "昌乐县",
              "label": "昌乐县",
              "id": 370725
            }, {
              "value": "青州市",
              "label": "青州市",
              "id": 370781
            }, {
              "value": "诸城市",
              "label": "诸城市",
              "id": 370782
            }, {
              "value": "寿光市",
              "label": "寿光市",
              "id": 370783
            }, {
              "value": "安丘市",
              "label": "安丘市",
              "id": 370784
            }, {
              "value": "高密市",
              "label": "高密市",
              "id": 370785
            }, {
              "value": "昌邑市",
              "label": "昌邑市",
              "id": 370786
            }]
          }, {
            "value": "济宁市",
            "label": "济宁市",
            "id": 370800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370801
            }, {
              "value": "任城区",
              "label": "任城区",
              "id": 370811
            }, {
              "value": "兖州区",
              "label": "兖州区",
              "id": 370812
            }, {
              "value": "微山县",
              "label": "微山县",
              "id": 370826
            }, {
              "value": "鱼台县",
              "label": "鱼台县",
              "id": 370827
            }, {
              "value": "金乡县",
              "label": "金乡县",
              "id": 370828
            }, {
              "value": "嘉祥县",
              "label": "嘉祥县",
              "id": 370829
            }, {
              "value": "汶上县",
              "label": "汶上县",
              "id": 370830
            }, {
              "value": "泗水县",
              "label": "泗水县",
              "id": 370831
            }, {
              "value": "梁山县",
              "label": "梁山县",
              "id": 370832
            }, {
              "value": "曲阜市",
              "label": "曲阜市",
              "id": 370881
            }, {
              "value": "邹城市",
              "label": "邹城市",
              "id": 370883
            }]
          }, {
            "value": "泰安市",
            "label": "泰安市",
            "id": 370900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 370901
            }, {
              "value": "泰山区",
              "label": "泰山区",
              "id": 370902
            }, {
              "value": "岱岳区",
              "label": "岱岳区",
              "id": 370911
            }, {
              "value": "宁阳县",
              "label": "宁阳县",
              "id": 370921
            }, {
              "value": "东平县",
              "label": "东平县",
              "id": 370923
            }, {
              "value": "新泰市",
              "label": "新泰市",
              "id": 370982
            }, {
              "value": "肥城市",
              "label": "肥城市",
              "id": 370983
            }]
          }, {
            "value": "威海市",
            "label": "威海市",
            "id": 371000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371001
            }, {
              "value": "环翠区",
              "label": "环翠区",
              "id": 371002
            }, {
              "value": "文登区",
              "label": "文登区",
              "id": 371003
            }, {
              "value": "荣成市",
              "label": "荣成市",
              "id": 371082
            }, {
              "value": "乳山市",
              "label": "乳山市",
              "id": 371083
            }]
          }, {
            "value": "日照市",
            "label": "日照市",
            "id": 371100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371101
            }, {
              "value": "东港区",
              "label": "东港区",
              "id": 371102
            }, {
              "value": "岚山区",
              "label": "岚山区",
              "id": 371103
            }, {
              "value": "五莲县",
              "label": "五莲县",
              "id": 371121
            }, {
              "value": "莒县",
              "label": "莒县",
              "id": 371122
            }]
          }, {
            "value": "莱芜市",
            "label": "莱芜市",
            "id": 371200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371201
            }, {
              "value": "莱城区",
              "label": "莱城区",
              "id": 371202
            }, {
              "value": "钢城区",
              "label": "钢城区",
              "id": 371203
            }]
          }, {
            "value": "临沂市",
            "label": "临沂市",
            "id": 371300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371301
            }, {
              "value": "兰山区",
              "label": "兰山区",
              "id": 371302
            }, {
              "value": "罗庄区",
              "label": "罗庄区",
              "id": 371311
            }, {
              "value": "河东区",
              "label": "河东区",
              "id": 371312
            }, {
              "value": "沂南县",
              "label": "沂南县",
              "id": 371321
            }, {
              "value": "郯城县",
              "label": "郯城县",
              "id": 371322
            }, {
              "value": "沂水县",
              "label": "沂水县",
              "id": 371323
            }, {
              "value": "兰陵县",
              "label": "兰陵县",
              "id": 371324
            }, {
              "value": "费县",
              "label": "费县",
              "id": 371325
            }, {
              "value": "平邑县",
              "label": "平邑县",
              "id": 371326
            }, {
              "value": "莒南县",
              "label": "莒南县",
              "id": 371327
            }, {
              "value": "蒙阴县",
              "label": "蒙阴县",
              "id": 371328
            }, {
              "value": "临沭县",
              "label": "临沭县",
              "id": 371329
            }]
          }, {
            "value": "德州市",
            "label": "德州市",
            "id": 371400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371401
            }, {
              "value": "德城区",
              "label": "德城区",
              "id": 371402
            }, {
              "value": "陵城区",
              "label": "陵城区",
              "id": 371403
            }, {
              "value": "宁津县",
              "label": "宁津县",
              "id": 371422
            }, {
              "value": "庆云县",
              "label": "庆云县",
              "id": 371423
            }, {
              "value": "临邑县",
              "label": "临邑县",
              "id": 371424
            }, {
              "value": "齐河县",
              "label": "齐河县",
              "id": 371425
            }, {
              "value": "平原县",
              "label": "平原县",
              "id": 371426
            }, {
              "value": "夏津县",
              "label": "夏津县",
              "id": 371427
            }, {
              "value": "武城县",
              "label": "武城县",
              "id": 371428
            }, {
              "value": "乐陵市",
              "label": "乐陵市",
              "id": 371481
            }, {
              "value": "禹城市",
              "label": "禹城市",
              "id": 371482
            }]
          }, {
            "value": "聊城市",
            "label": "聊城市",
            "id": 371500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371501
            }, {
              "value": "东昌府区",
              "label": "东昌府区",
              "id": 371502
            }, {
              "value": "阳谷县",
              "label": "阳谷县",
              "id": 371521
            }, {
              "value": "莘县",
              "label": "莘县",
              "id": 371522
            }, {
              "value": "茌平县",
              "label": "茌平县",
              "id": 371523
            }, {
              "value": "东阿县",
              "label": "东阿县",
              "id": 371524
            }, {
              "value": "冠县",
              "label": "冠县",
              "id": 371525
            }, {
              "value": "高唐县",
              "label": "高唐县",
              "id": 371526
            }, {
              "value": "临清市",
              "label": "临清市",
              "id": 371581
            }]
          }, {
            "value": "滨州市",
            "label": "滨州市",
            "id": 371600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371601
            }, {
              "value": "滨城区",
              "label": "滨城区",
              "id": 371602
            }, {
              "value": "沾化区",
              "label": "沾化区",
              "id": 371603
            }, {
              "value": "惠民县",
              "label": "惠民县",
              "id": 371621
            }, {
              "value": "阳信县",
              "label": "阳信县",
              "id": 371622
            }, {
              "value": "无棣县",
              "label": "无棣县",
              "id": 371623
            }, {
              "value": "博兴县",
              "label": "博兴县",
              "id": 371625
            }, {
              "value": "邹平县",
              "label": "邹平县",
              "id": 371626
            }]
          }, {
            "value": "菏泽市",
            "label": "菏泽市",
            "id": 371700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 371701
            }, {
              "value": "牡丹区",
              "label": "牡丹区",
              "id": 371702
            }, {
              "value": "定陶区",
              "label": "定陶区",
              "id": 371703
            }, {
              "value": "曹县",
              "label": "曹县",
              "id": 371721
            }, {
              "value": "单县",
              "label": "单县",
              "id": 371722
            }, {
              "value": "成武县",
              "label": "成武县",
              "id": 371723
            }, {
              "value": "巨野县",
              "label": "巨野县",
              "id": 371724
            }, {
              "value": "郓城县",
              "label": "郓城县",
              "id": 371725
            }, {
              "value": "鄄城县",
              "label": "鄄城县",
              "id": 371726
            }, {
              "value": "东明县",
              "label": "东明县",
              "id": 371728
            }]
          }]
        }, {
          "value": "河南省",
          "label": "河南省",
          "id": 410000,
          "children": [{
            "value": "郑州市",
            "label": "郑州市",
            "id": 410100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410101
            }, {
              "value": "中原区",
              "label": "中原区",
              "id": 410102
            }, {
              "value": "二七区",
              "label": "二七区",
              "id": 410103
            }, {
              "value": "管城回族区",
              "label": "管城回族区",
              "id": 410104
            }, {
              "value": "金水区",
              "label": "金水区",
              "id": 410105
            }, {
              "value": "上街区",
              "label": "上街区",
              "id": 410106
            }, {
              "value": "惠济区",
              "label": "惠济区",
              "id": 410108
            }, {
              "value": "中牟县",
              "label": "中牟县",
              "id": 410122
            }, {
              "value": "巩义市",
              "label": "巩义市",
              "id": 410181
            }, {
              "value": "荥阳市",
              "label": "荥阳市",
              "id": 410182
            }, {
              "value": "新密市",
              "label": "新密市",
              "id": 410183
            }, {
              "value": "新郑市",
              "label": "新郑市",
              "id": 410184
            }, {
              "value": "登封市",
              "label": "登封市",
              "id": 410185
            }]
          }, {
            "value": "开封市",
            "label": "开封市",
            "id": 410200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410201
            }, {
              "value": "龙亭区",
              "label": "龙亭区",
              "id": 410202
            }, {
              "value": "顺河回族区",
              "label": "顺河回族区",
              "id": 410203
            }, {
              "value": "鼓楼区",
              "label": "鼓楼区",
              "id": 410204
            }, {
              "value": "禹王台区",
              "label": "禹王台区",
              "id": 410205
            }, {
              "value": "金明区",
              "label": "金明区",
              "id": 410211
            }, {
              "value": "祥符区",
              "label": "祥符区",
              "id": 410212
            }, {
              "value": "杞县",
              "label": "杞县",
              "id": 410221
            }, {
              "value": "通许县",
              "label": "通许县",
              "id": 410222
            }, {
              "value": "尉氏县",
              "label": "尉氏县",
              "id": 410223
            }, {
              "value": "兰考县",
              "label": "兰考县",
              "id": 410225
            }]
          }, {
            "value": "洛阳市",
            "label": "洛阳市",
            "id": 410300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410301
            }, {
              "value": "老城区",
              "label": "老城区",
              "id": 410302
            }, {
              "value": "西工区",
              "label": "西工区",
              "id": 410303
            }, {
              "value": "瀍河回族区",
              "label": "瀍河回族区",
              "id": 410304
            }, {
              "value": "涧西区",
              "label": "涧西区",
              "id": 410305
            }, {
              "value": "吉利区",
              "label": "吉利区",
              "id": 410306
            }, {
              "value": "洛龙区",
              "label": "洛龙区",
              "id": 410311
            }, {
              "value": "孟津县",
              "label": "孟津县",
              "id": 410322
            }, {
              "value": "新安县",
              "label": "新安县",
              "id": 410323
            }, {
              "value": "栾川县",
              "label": "栾川县",
              "id": 410324
            }, {
              "value": "嵩县",
              "label": "嵩县",
              "id": 410325
            }, {
              "value": "汝阳县",
              "label": "汝阳县",
              "id": 410326
            }, {
              "value": "宜阳县",
              "label": "宜阳县",
              "id": 410327
            }, {
              "value": "洛宁县",
              "label": "洛宁县",
              "id": 410328
            }, {
              "value": "伊川县",
              "label": "伊川县",
              "id": 410329
            }, {
              "value": "偃师市",
              "label": "偃师市",
              "id": 410381
            }]
          }, {
            "value": "平顶山市",
            "label": "平顶山市",
            "id": 410400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410401
            }, {
              "value": "新华区",
              "label": "新华区",
              "id": 410402
            }, {
              "value": "卫东区",
              "label": "卫东区",
              "id": 410403
            }, {
              "value": "石龙区",
              "label": "石龙区",
              "id": 410404
            }, {
              "value": "湛河区",
              "label": "湛河区",
              "id": 410411
            }, {
              "value": "宝丰县",
              "label": "宝丰县",
              "id": 410421
            }, {
              "value": "叶县",
              "label": "叶县",
              "id": 410422
            }, {
              "value": "鲁山县",
              "label": "鲁山县",
              "id": 410423
            }, {
              "value": "郏县",
              "label": "郏县",
              "id": 410425
            }, {
              "value": "舞钢市",
              "label": "舞钢市",
              "id": 410481
            }, {
              "value": "汝州市",
              "label": "汝州市",
              "id": 410482
            }]
          }, {
            "value": "安阳市",
            "label": "安阳市",
            "id": 410500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410501
            }, {
              "value": "文峰区",
              "label": "文峰区",
              "id": 410502
            }, {
              "value": "北关区",
              "label": "北关区",
              "id": 410503
            }, {
              "value": "殷都区",
              "label": "殷都区",
              "id": 410505
            }, {
              "value": "龙安区",
              "label": "龙安区",
              "id": 410506
            }, {
              "value": "安阳县",
              "label": "安阳县",
              "id": 410522
            }, {
              "value": "汤阴县",
              "label": "汤阴县",
              "id": 410523
            }, {
              "value": "滑县",
              "label": "滑县",
              "id": 410526
            }, {
              "value": "内黄县",
              "label": "内黄县",
              "id": 410527
            }, {
              "value": "林州市",
              "label": "林州市",
              "id": 410581
            }]
          }, {
            "value": "鹤壁市",
            "label": "鹤壁市",
            "id": 410600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410601
            }, {
              "value": "鹤山区",
              "label": "鹤山区",
              "id": 410602
            }, {
              "value": "山城区",
              "label": "山城区",
              "id": 410603
            }, {
              "value": "淇滨区",
              "label": "淇滨区",
              "id": 410611
            }, {
              "value": "浚县",
              "label": "浚县",
              "id": 410621
            }, {
              "value": "淇县",
              "label": "淇县",
              "id": 410622
            }]
          }, {
            "value": "新乡市",
            "label": "新乡市",
            "id": 410700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410701
            }, {
              "value": "红旗区",
              "label": "红旗区",
              "id": 410702
            }, {
              "value": "卫滨区",
              "label": "卫滨区",
              "id": 410703
            }, {
              "value": "凤泉区",
              "label": "凤泉区",
              "id": 410704
            }, {
              "value": "牧野区",
              "label": "牧野区",
              "id": 410711
            }, {
              "value": "新乡县",
              "label": "新乡县",
              "id": 410721
            }, {
              "value": "获嘉县",
              "label": "获嘉县",
              "id": 410724
            }, {
              "value": "原阳县",
              "label": "原阳县",
              "id": 410725
            }, {
              "value": "延津县",
              "label": "延津县",
              "id": 410726
            }, {
              "value": "封丘县",
              "label": "封丘县",
              "id": 410727
            }, {
              "value": "长垣县",
              "label": "长垣县",
              "id": 410728
            }, {
              "value": "卫辉市",
              "label": "卫辉市",
              "id": 410781
            }, {
              "value": "辉县市",
              "label": "辉县市",
              "id": 410782
            }]
          }, {
            "value": "焦作市",
            "label": "焦作市",
            "id": 410800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410801
            }, {
              "value": "解放区",
              "label": "解放区",
              "id": 410802
            }, {
              "value": "中站区",
              "label": "中站区",
              "id": 410803
            }, {
              "value": "马村区",
              "label": "马村区",
              "id": 410804
            }, {
              "value": "山阳区",
              "label": "山阳区",
              "id": 410811
            }, {
              "value": "修武县",
              "label": "修武县",
              "id": 410821
            }, {
              "value": "博爱县",
              "label": "博爱县",
              "id": 410822
            }, {
              "value": "武陟县",
              "label": "武陟县",
              "id": 410823
            }, {
              "value": "温县",
              "label": "温县",
              "id": 410825
            }, {
              "value": "沁阳市",
              "label": "沁阳市",
              "id": 410882
            }, {
              "value": "孟州市",
              "label": "孟州市",
              "id": 410883
            }]
          }, {
            "value": "濮阳市",
            "label": "濮阳市",
            "id": 410900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 410901
            }, {
              "value": "华龙区",
              "label": "华龙区",
              "id": 410902
            }, {
              "value": "清丰县",
              "label": "清丰县",
              "id": 410922
            }, {
              "value": "南乐县",
              "label": "南乐县",
              "id": 410923
            }, {
              "value": "范县",
              "label": "范县",
              "id": 410926
            }, {
              "value": "台前县",
              "label": "台前县",
              "id": 410927
            }, {
              "value": "濮阳县",
              "label": "濮阳县",
              "id": 410928
            }]
          }, {
            "value": "许昌市",
            "label": "许昌市",
            "id": 411000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411001
            }, {
              "value": "魏都区",
              "label": "魏都区",
              "id": 411002
            }, {
              "value": "许昌县",
              "label": "许昌县",
              "id": 411023
            }, {
              "value": "鄢陵县",
              "label": "鄢陵县",
              "id": 411024
            }, {
              "value": "襄城县",
              "label": "襄城县",
              "id": 411025
            }, {
              "value": "禹州市",
              "label": "禹州市",
              "id": 411081
            }, {
              "value": "长葛市",
              "label": "长葛市",
              "id": 411082
            }]
          }, {
            "value": "漯河市",
            "label": "漯河市",
            "id": 411100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411101
            }, {
              "value": "源汇区",
              "label": "源汇区",
              "id": 411102
            }, {
              "value": "郾城区",
              "label": "郾城区",
              "id": 411103
            }, {
              "value": "召陵区",
              "label": "召陵区",
              "id": 411104
            }, {
              "value": "舞阳县",
              "label": "舞阳县",
              "id": 411121
            }, {
              "value": "临颍县",
              "label": "临颍县",
              "id": 411122
            }]
          }, {
            "value": "三门峡市",
            "label": "三门峡市",
            "id": 411200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411201
            }, {
              "value": "湖滨区",
              "label": "湖滨区",
              "id": 411202
            }, {
              "value": "陕州区",
              "label": "陕州区",
              "id": 411203
            }, {
              "value": "渑池县",
              "label": "渑池县",
              "id": 411221
            }, {
              "value": "卢氏县",
              "label": "卢氏县",
              "id": 411224
            }, {
              "value": "义马市",
              "label": "义马市",
              "id": 411281
            }, {
              "value": "灵宝市",
              "label": "灵宝市",
              "id": 411282
            }]
          }, {
            "value": "南阳市",
            "label": "南阳市",
            "id": 411300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411301
            }, {
              "value": "宛城区",
              "label": "宛城区",
              "id": 411302
            }, {
              "value": "卧龙区",
              "label": "卧龙区",
              "id": 411303
            }, {
              "value": "南召县",
              "label": "南召县",
              "id": 411321
            }, {
              "value": "方城县",
              "label": "方城县",
              "id": 411322
            }, {
              "value": "西峡县",
              "label": "西峡县",
              "id": 411323
            }, {
              "value": "镇平县",
              "label": "镇平县",
              "id": 411324
            }, {
              "value": "内乡县",
              "label": "内乡县",
              "id": 411325
            }, {
              "value": "淅川县",
              "label": "淅川县",
              "id": 411326
            }, {
              "value": "社旗县",
              "label": "社旗县",
              "id": 411327
            }, {
              "value": "唐河县",
              "label": "唐河县",
              "id": 411328
            }, {
              "value": "新野县",
              "label": "新野县",
              "id": 411329
            }, {
              "value": "桐柏县",
              "label": "桐柏县",
              "id": 411330
            }, {
              "value": "邓州市",
              "label": "邓州市",
              "id": 411381
            }]
          }, {
            "value": "商丘市",
            "label": "商丘市",
            "id": 411400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411401
            }, {
              "value": "梁园区",
              "label": "梁园区",
              "id": 411402
            }, {
              "value": "睢阳区",
              "label": "睢阳区",
              "id": 411403
            }, {
              "value": "民权县",
              "label": "民权县",
              "id": 411421
            }, {
              "value": "睢县",
              "label": "睢县",
              "id": 411422
            }, {
              "value": "宁陵县",
              "label": "宁陵县",
              "id": 411423
            }, {
              "value": "柘城县",
              "label": "柘城县",
              "id": 411424
            }, {
              "value": "虞城县",
              "label": "虞城县",
              "id": 411425
            }, {
              "value": "夏邑县",
              "label": "夏邑县",
              "id": 411426
            }, {
              "value": "永城市",
              "label": "永城市",
              "id": 411481
            }]
          }, {
            "value": "信阳市",
            "label": "信阳市",
            "id": 411500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411501
            }, {
              "value": "浉河区",
              "label": "浉河区",
              "id": 411502
            }, {
              "value": "平桥区",
              "label": "平桥区",
              "id": 411503
            }, {
              "value": "罗山县",
              "label": "罗山县",
              "id": 411521
            }, {
              "value": "光山县",
              "label": "光山县",
              "id": 411522
            }, {
              "value": "新县",
              "label": "新县",
              "id": 411523
            }, {
              "value": "商城县",
              "label": "商城县",
              "id": 411524
            }, {
              "value": "固始县",
              "label": "固始县",
              "id": 411525
            }, {
              "value": "潢川县",
              "label": "潢川县",
              "id": 411526
            }, {
              "value": "淮滨县",
              "label": "淮滨县",
              "id": 411527
            }, {
              "value": "息县",
              "label": "息县",
              "id": 411528
            }]
          }, {
            "value": "周口市",
            "label": "周口市",
            "id": 411600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411601
            }, {
              "value": "川汇区",
              "label": "川汇区",
              "id": 411602
            }, {
              "value": "扶沟县",
              "label": "扶沟县",
              "id": 411621
            }, {
              "value": "西华县",
              "label": "西华县",
              "id": 411622
            }, {
              "value": "商水县",
              "label": "商水县",
              "id": 411623
            }, {
              "value": "沈丘县",
              "label": "沈丘县",
              "id": 411624
            }, {
              "value": "郸城县",
              "label": "郸城县",
              "id": 411625
            }, {
              "value": "淮阳县",
              "label": "淮阳县",
              "id": 411626
            }, {
              "value": "太康县",
              "label": "太康县",
              "id": 411627
            }, {
              "value": "鹿邑县",
              "label": "鹿邑县",
              "id": 411628
            }, {
              "value": "项城市",
              "label": "项城市",
              "id": 411681
            }]
          }, {
            "value": "驻马店市",
            "label": "驻马店市",
            "id": 411700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 411701
            }, {
              "value": "驿城区",
              "label": "驿城区",
              "id": 411702
            }, {
              "value": "西平县",
              "label": "西平县",
              "id": 411721
            }, {
              "value": "上蔡县",
              "label": "上蔡县",
              "id": 411722
            }, {
              "value": "平舆县",
              "label": "平舆县",
              "id": 411723
            }, {
              "value": "正阳县",
              "label": "正阳县",
              "id": 411724
            }, {
              "value": "确山县",
              "label": "确山县",
              "id": 411725
            }, {
              "value": "泌阳县",
              "label": "泌阳县",
              "id": 411726
            }, {
              "value": "汝南县",
              "label": "汝南县",
              "id": 411727
            }, {
              "value": "遂平县",
              "label": "遂平县",
              "id": 411728
            }, {
              "value": "新蔡县",
              "label": "新蔡县",
              "id": 411729
            }]
          }, {
            "value": "省直辖县级行政区划",
            "label": "省直辖县级行政区划",
            "id": 419000,
            "children": [{
              "value": "济源市",
              "label": "济源市",
              "id": 419001
            }]
          }]
        }, {
          "value": "湖北省",
          "label": "湖北省",
          "id": 420000,
          "children": [{
            "value": "武汉市",
            "label": "武汉市",
            "id": 420100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420101
            }, {
              "value": "江岸区",
              "label": "江岸区",
              "id": 420102
            }, {
              "value": "江汉区",
              "label": "江汉区",
              "id": 420103
            }, {
              "value": "硚口区",
              "label": "硚口区",
              "id": 420104
            }, {
              "value": "汉阳区",
              "label": "汉阳区",
              "id": 420105
            }, {
              "value": "武昌区",
              "label": "武昌区",
              "id": 420106
            }, {
              "value": "青山区",
              "label": "青山区",
              "id": 420107
            }, {
              "value": "洪山区",
              "label": "洪山区",
              "id": 420111
            }, {
              "value": "东西湖区",
              "label": "东西湖区",
              "id": 420112
            }, {
              "value": "汉南区",
              "label": "汉南区",
              "id": 420113
            }, {
              "value": "蔡甸区",
              "label": "蔡甸区",
              "id": 420114
            }, {
              "value": "江夏区",
              "label": "江夏区",
              "id": 420115
            }, {
              "value": "黄陂区",
              "label": "黄陂区",
              "id": 420116
            }, {
              "value": "新洲区",
              "label": "新洲区",
              "id": 420117
            }]
          }, {
            "value": "黄石市",
            "label": "黄石市",
            "id": 420200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420201
            }, {
              "value": "黄石港区",
              "label": "黄石港区",
              "id": 420202
            }, {
              "value": "西塞山区",
              "label": "西塞山区",
              "id": 420203
            }, {
              "value": "下陆区",
              "label": "下陆区",
              "id": 420204
            }, {
              "value": "铁山区",
              "label": "铁山区",
              "id": 420205
            }, {
              "value": "阳新县",
              "label": "阳新县",
              "id": 420222
            }, {
              "value": "大冶市",
              "label": "大冶市",
              "id": 420281
            }]
          }, {
            "value": "十堰市",
            "label": "十堰市",
            "id": 420300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420301
            }, {
              "value": "茅箭区",
              "label": "茅箭区",
              "id": 420302
            }, {
              "value": "张湾区",
              "label": "张湾区",
              "id": 420303
            }, {
              "value": "郧阳区",
              "label": "郧阳区",
              "id": 420304
            }, {
              "value": "郧西县",
              "label": "郧西县",
              "id": 420322
            }, {
              "value": "竹山县",
              "label": "竹山县",
              "id": 420323
            }, {
              "value": "竹溪县",
              "label": "竹溪县",
              "id": 420324
            }, {
              "value": "房县",
              "label": "房县",
              "id": 420325
            }, {
              "value": "丹江口市",
              "label": "丹江口市",
              "id": 420381
            }]
          }, {
            "value": "宜昌市",
            "label": "宜昌市",
            "id": 420500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420501
            }, {
              "value": "西陵区",
              "label": "西陵区",
              "id": 420502
            }, {
              "value": "伍家岗区",
              "label": "伍家岗区",
              "id": 420503
            }, {
              "value": "点军区",
              "label": "点军区",
              "id": 420504
            }, {
              "value": "猇亭区",
              "label": "猇亭区",
              "id": 420505
            }, {
              "value": "夷陵区",
              "label": "夷陵区",
              "id": 420506
            }, {
              "value": "远安县",
              "label": "远安县",
              "id": 420525
            }, {
              "value": "兴山县",
              "label": "兴山县",
              "id": 420526
            }, {
              "value": "秭归县",
              "label": "秭归县",
              "id": 420527
            }, {
              "value": "长阳土家族自治县",
              "label": "长阳土家族自治县",
              "id": 420528
            }, {
              "value": "五峰土家族自治县",
              "label": "五峰土家族自治县",
              "id": 420529
            }, {
              "value": "宜都市",
              "label": "宜都市",
              "id": 420581
            }, {
              "value": "当阳市",
              "label": "当阳市",
              "id": 420582
            }, {
              "value": "枝江市",
              "label": "枝江市",
              "id": 420583
            }]
          }, {
            "value": "襄阳市",
            "label": "襄阳市",
            "id": 420600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420601
            }, {
              "value": "襄城区",
              "label": "襄城区",
              "id": 420602
            }, {
              "value": "樊城区",
              "label": "樊城区",
              "id": 420606
            }, {
              "value": "襄州区",
              "label": "襄州区",
              "id": 420607
            }, {
              "value": "南漳县",
              "label": "南漳县",
              "id": 420624
            }, {
              "value": "谷城县",
              "label": "谷城县",
              "id": 420625
            }, {
              "value": "保康县",
              "label": "保康县",
              "id": 420626
            }, {
              "value": "老河口市",
              "label": "老河口市",
              "id": 420682
            }, {
              "value": "枣阳市",
              "label": "枣阳市",
              "id": 420683
            }, {
              "value": "宜城市",
              "label": "宜城市",
              "id": 420684
            }]
          }, {
            "value": "鄂州市",
            "label": "鄂州市",
            "id": 420700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420701
            }, {
              "value": "梁子湖区",
              "label": "梁子湖区",
              "id": 420702
            }, {
              "value": "华容区",
              "label": "华容区",
              "id": 420703
            }, {
              "value": "鄂城区",
              "label": "鄂城区",
              "id": 420704
            }]
          }, {
            "value": "荆门市",
            "label": "荆门市",
            "id": 420800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420801
            }, {
              "value": "东宝区",
              "label": "东宝区",
              "id": 420802
            }, {
              "value": "掇刀区",
              "label": "掇刀区",
              "id": 420804
            }, {
              "value": "京山县",
              "label": "京山县",
              "id": 420821
            }, {
              "value": "沙洋县",
              "label": "沙洋县",
              "id": 420822
            }, {
              "value": "钟祥市",
              "label": "钟祥市",
              "id": 420881
            }]
          }, {
            "value": "孝感市",
            "label": "孝感市",
            "id": 420900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 420901
            }, {
              "value": "孝南区",
              "label": "孝南区",
              "id": 420902
            }, {
              "value": "孝昌县",
              "label": "孝昌县",
              "id": 420921
            }, {
              "value": "大悟县",
              "label": "大悟县",
              "id": 420922
            }, {
              "value": "云梦县",
              "label": "云梦县",
              "id": 420923
            }, {
              "value": "应城市",
              "label": "应城市",
              "id": 420981
            }, {
              "value": "安陆市",
              "label": "安陆市",
              "id": 420982
            }, {
              "value": "汉川市",
              "label": "汉川市",
              "id": 420984
            }]
          }, {
            "value": "荆州市",
            "label": "荆州市",
            "id": 421000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 421001
            }, {
              "value": "沙市区",
              "label": "沙市区",
              "id": 421002
            }, {
              "value": "荆州区",
              "label": "荆州区",
              "id": 421003
            }, {
              "value": "公安县",
              "label": "公安县",
              "id": 421022
            }, {
              "value": "监利县",
              "label": "监利县",
              "id": 421023
            }, {
              "value": "江陵县",
              "label": "江陵县",
              "id": 421024
            }, {
              "value": "石首市",
              "label": "石首市",
              "id": 421081
            }, {
              "value": "洪湖市",
              "label": "洪湖市",
              "id": 421083
            }, {
              "value": "松滋市",
              "label": "松滋市",
              "id": 421087
            }]
          }, {
            "value": "黄冈市",
            "label": "黄冈市",
            "id": 421100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 421101
            }, {
              "value": "黄州区",
              "label": "黄州区",
              "id": 421102
            }, {
              "value": "团风县",
              "label": "团风县",
              "id": 421121
            }, {
              "value": "红安县",
              "label": "红安县",
              "id": 421122
            }, {
              "value": "罗田县",
              "label": "罗田县",
              "id": 421123
            }, {
              "value": "英山县",
              "label": "英山县",
              "id": 421124
            }, {
              "value": "浠水县",
              "label": "浠水县",
              "id": 421125
            }, {
              "value": "蕲春县",
              "label": "蕲春县",
              "id": 421126
            }, {
              "value": "黄梅县",
              "label": "黄梅县",
              "id": 421127
            }, {
              "value": "麻城市",
              "label": "麻城市",
              "id": 421181
            }, {
              "value": "武穴市",
              "label": "武穴市",
              "id": 421182
            }]
          }, {
            "value": "咸宁市",
            "label": "咸宁市",
            "id": 421200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 421201
            }, {
              "value": "咸安区",
              "label": "咸安区",
              "id": 421202
            }, {
              "value": "嘉鱼县",
              "label": "嘉鱼县",
              "id": 421221
            }, {
              "value": "通城县",
              "label": "通城县",
              "id": 421222
            }, {
              "value": "崇阳县",
              "label": "崇阳县",
              "id": 421223
            }, {
              "value": "通山县",
              "label": "通山县",
              "id": 421224
            }, {
              "value": "赤壁市",
              "label": "赤壁市",
              "id": 421281
            }]
          }, {
            "value": "随州市",
            "label": "随州市",
            "id": 421300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 421301
            }, {
              "value": "曾都区",
              "label": "曾都区",
              "id": 421303
            }, {
              "value": "随县",
              "label": "随县",
              "id": 421321
            }, {
              "value": "广水市",
              "label": "广水市",
              "id": 421381
            }]
          }, {
            "value": "恩施土家族苗族自治州",
            "label": "恩施土家族苗族自治州",
            "id": 422800,
            "children": [{
              "value": "恩施市",
              "label": "恩施市",
              "id": 422801
            }, {
              "value": "利川市",
              "label": "利川市",
              "id": 422802
            }, {
              "value": "建始县",
              "label": "建始县",
              "id": 422822
            }, {
              "value": "巴东县",
              "label": "巴东县",
              "id": 422823
            }, {
              "value": "宣恩县",
              "label": "宣恩县",
              "id": 422825
            }, {
              "value": "咸丰县",
              "label": "咸丰县",
              "id": 422826
            }, {
              "value": "来凤县",
              "label": "来凤县",
              "id": 422827
            }, {
              "value": "鹤峰县",
              "label": "鹤峰县",
              "id": 422828
            }]
          }, {
            "value": "省直辖县级行政区划",
            "label": "省直辖县级行政区划",
            "id": 429000,
            "children": [{
              "value": "仙桃市",
              "label": "仙桃市",
              "id": 429004
            }, {
              "value": "潜江市",
              "label": "潜江市",
              "id": 429005
            }, {
              "value": "天门市",
              "label": "天门市",
              "id": 429006
            }, {
              "value": "神农架林区",
              "label": "神农架林区",
              "id": 429021
            }]
          }]
        }, {
          "value": "湖南省",
          "label": "湖南省",
          "id": 430000,
          "children": [{
            "value": "长沙市",
            "label": "长沙市",
            "id": 430100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430101
            }, {
              "value": "芙蓉区",
              "label": "芙蓉区",
              "id": 430102
            }, {
              "value": "天心区",
              "label": "天心区",
              "id": 430103
            }, {
              "value": "岳麓区",
              "label": "岳麓区",
              "id": 430104
            }, {
              "value": "开福区",
              "label": "开福区",
              "id": 430105
            }, {
              "value": "雨花区",
              "label": "雨花区",
              "id": 430111
            }, {
              "value": "望城区",
              "label": "望城区",
              "id": 430112
            }, {
              "value": "长沙县",
              "label": "长沙县",
              "id": 430121
            }, {
              "value": "宁乡县",
              "label": "宁乡县",
              "id": 430124
            }, {
              "value": "浏阳市",
              "label": "浏阳市",
              "id": 430181
            }]
          }, {
            "value": "株洲市",
            "label": "株洲市",
            "id": 430200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430201
            }, {
              "value": "荷塘区",
              "label": "荷塘区",
              "id": 430202
            }, {
              "value": "芦淞区",
              "label": "芦淞区",
              "id": 430203
            }, {
              "value": "石峰区",
              "label": "石峰区",
              "id": 430204
            }, {
              "value": "天元区",
              "label": "天元区",
              "id": 430211
            }, {
              "value": "株洲县",
              "label": "株洲县",
              "id": 430221
            }, {
              "value": "攸县",
              "label": "攸县",
              "id": 430223
            }, {
              "value": "茶陵县",
              "label": "茶陵县",
              "id": 430224
            }, {
              "value": "炎陵县",
              "label": "炎陵县",
              "id": 430225
            }, {
              "value": "醴陵市",
              "label": "醴陵市",
              "id": 430281
            }]
          }, {
            "value": "湘潭市",
            "label": "湘潭市",
            "id": 430300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430301
            }, {
              "value": "雨湖区",
              "label": "雨湖区",
              "id": 430302
            }, {
              "value": "岳塘区",
              "label": "岳塘区",
              "id": 430304
            }, {
              "value": "湘潭县",
              "label": "湘潭县",
              "id": 430321
            }, {
              "value": "湘乡市",
              "label": "湘乡市",
              "id": 430381
            }, {
              "value": "韶山市",
              "label": "韶山市",
              "id": 430382
            }]
          }, {
            "value": "衡阳市",
            "label": "衡阳市",
            "id": 430400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430401
            }, {
              "value": "珠晖区",
              "label": "珠晖区",
              "id": 430405
            }, {
              "value": "雁峰区",
              "label": "雁峰区",
              "id": 430406
            }, {
              "value": "石鼓区",
              "label": "石鼓区",
              "id": 430407
            }, {
              "value": "蒸湘区",
              "label": "蒸湘区",
              "id": 430408
            }, {
              "value": "南岳区",
              "label": "南岳区",
              "id": 430412
            }, {
              "value": "衡阳县",
              "label": "衡阳县",
              "id": 430421
            }, {
              "value": "衡南县",
              "label": "衡南县",
              "id": 430422
            }, {
              "value": "衡山县",
              "label": "衡山县",
              "id": 430423
            }, {
              "value": "衡东县",
              "label": "衡东县",
              "id": 430424
            }, {
              "value": "祁东县",
              "label": "祁东县",
              "id": 430426
            }, {
              "value": "耒阳市",
              "label": "耒阳市",
              "id": 430481
            }, {
              "value": "常宁市",
              "label": "常宁市",
              "id": 430482
            }]
          }, {
            "value": "邵阳市",
            "label": "邵阳市",
            "id": 430500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430501
            }, {
              "value": "双清区",
              "label": "双清区",
              "id": 430502
            }, {
              "value": "大祥区",
              "label": "大祥区",
              "id": 430503
            }, {
              "value": "北塔区",
              "label": "北塔区",
              "id": 430511
            }, {
              "value": "邵东县",
              "label": "邵东县",
              "id": 430521
            }, {
              "value": "新邵县",
              "label": "新邵县",
              "id": 430522
            }, {
              "value": "邵阳县",
              "label": "邵阳县",
              "id": 430523
            }, {
              "value": "隆回县",
              "label": "隆回县",
              "id": 430524
            }, {
              "value": "洞口县",
              "label": "洞口县",
              "id": 430525
            }, {
              "value": "绥宁县",
              "label": "绥宁县",
              "id": 430527
            }, {
              "value": "新宁县",
              "label": "新宁县",
              "id": 430528
            }, {
              "value": "城步苗族自治县",
              "label": "城步苗族自治县",
              "id": 430529
            }, {
              "value": "武冈市",
              "label": "武冈市",
              "id": 430581
            }]
          }, {
            "value": "岳阳市",
            "label": "岳阳市",
            "id": 430600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430601
            }, {
              "value": "岳阳楼区",
              "label": "岳阳楼区",
              "id": 430602
            }, {
              "value": "云溪区",
              "label": "云溪区",
              "id": 430603
            }, {
              "value": "君山区",
              "label": "君山区",
              "id": 430611
            }, {
              "value": "岳阳县",
              "label": "岳阳县",
              "id": 430621
            }, {
              "value": "华容县",
              "label": "华容县",
              "id": 430623
            }, {
              "value": "湘阴县",
              "label": "湘阴县",
              "id": 430624
            }, {
              "value": "平江县",
              "label": "平江县",
              "id": 430626
            }, {
              "value": "汨罗市",
              "label": "汨罗市",
              "id": 430681
            }, {
              "value": "临湘市",
              "label": "临湘市",
              "id": 430682
            }]
          }, {
            "value": "常德市",
            "label": "常德市",
            "id": 430700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430701
            }, {
              "value": "武陵区",
              "label": "武陵区",
              "id": 430702
            }, {
              "value": "鼎城区",
              "label": "鼎城区",
              "id": 430703
            }, {
              "value": "安乡县",
              "label": "安乡县",
              "id": 430721
            }, {
              "value": "汉寿县",
              "label": "汉寿县",
              "id": 430722
            }, {
              "value": "澧县",
              "label": "澧县",
              "id": 430723
            }, {
              "value": "临澧县",
              "label": "临澧县",
              "id": 430724
            }, {
              "value": "桃源县",
              "label": "桃源县",
              "id": 430725
            }, {
              "value": "石门县",
              "label": "石门县",
              "id": 430726
            }, {
              "value": "津市市",
              "label": "津市市",
              "id": 430781
            }]
          }, {
            "value": "张家界市",
            "label": "张家界市",
            "id": 430800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430801
            }, {
              "value": "永定区",
              "label": "永定区",
              "id": 430802
            }, {
              "value": "武陵源区",
              "label": "武陵源区",
              "id": 430811
            }, {
              "value": "慈利县",
              "label": "慈利县",
              "id": 430821
            }, {
              "value": "桑植县",
              "label": "桑植县",
              "id": 430822
            }]
          }, {
            "value": "益阳市",
            "label": "益阳市",
            "id": 430900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 430901
            }, {
              "value": "资阳区",
              "label": "资阳区",
              "id": 430902
            }, {
              "value": "赫山区",
              "label": "赫山区",
              "id": 430903
            }, {
              "value": "南县",
              "label": "南县",
              "id": 430921
            }, {
              "value": "桃江县",
              "label": "桃江县",
              "id": 430922
            }, {
              "value": "安化县",
              "label": "安化县",
              "id": 430923
            }, {
              "value": "沅江市",
              "label": "沅江市",
              "id": 430981
            }]
          }, {
            "value": "郴州市",
            "label": "郴州市",
            "id": 431000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 431001
            }, {
              "value": "北湖区",
              "label": "北湖区",
              "id": 431002
            }, {
              "value": "苏仙区",
              "label": "苏仙区",
              "id": 431003
            }, {
              "value": "桂阳县",
              "label": "桂阳县",
              "id": 431021
            }, {
              "value": "宜章县",
              "label": "宜章县",
              "id": 431022
            }, {
              "value": "永兴县",
              "label": "永兴县",
              "id": 431023
            }, {
              "value": "嘉禾县",
              "label": "嘉禾县",
              "id": 431024
            }, {
              "value": "临武县",
              "label": "临武县",
              "id": 431025
            }, {
              "value": "汝城县",
              "label": "汝城县",
              "id": 431026
            }, {
              "value": "桂东县",
              "label": "桂东县",
              "id": 431027
            }, {
              "value": "安仁县",
              "label": "安仁县",
              "id": 431028
            }, {
              "value": "资兴市",
              "label": "资兴市",
              "id": 431081
            }]
          }, {
            "value": "永州市",
            "label": "永州市",
            "id": 431100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 431101
            }, {
              "value": "零陵区",
              "label": "零陵区",
              "id": 431102
            }, {
              "value": "冷水滩区",
              "label": "冷水滩区",
              "id": 431103
            }, {
              "value": "祁阳县",
              "label": "祁阳县",
              "id": 431121
            }, {
              "value": "东安县",
              "label": "东安县",
              "id": 431122
            }, {
              "value": "双牌县",
              "label": "双牌县",
              "id": 431123
            }, {
              "value": "道县",
              "label": "道县",
              "id": 431124
            }, {
              "value": "江永县",
              "label": "江永县",
              "id": 431125
            }, {
              "value": "宁远县",
              "label": "宁远县",
              "id": 431126
            }, {
              "value": "蓝山县",
              "label": "蓝山县",
              "id": 431127
            }, {
              "value": "新田县",
              "label": "新田县",
              "id": 431128
            }, {
              "value": "江华瑶族自治县",
              "label": "江华瑶族自治县",
              "id": 431129
            }]
          }, {
            "value": "怀化市",
            "label": "怀化市",
            "id": 431200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 431201
            }, {
              "value": "鹤城区",
              "label": "鹤城区",
              "id": 431202
            }, {
              "value": "中方县",
              "label": "中方县",
              "id": 431221
            }, {
              "value": "沅陵县",
              "label": "沅陵县",
              "id": 431222
            }, {
              "value": "辰溪县",
              "label": "辰溪县",
              "id": 431223
            }, {
              "value": "溆浦县",
              "label": "溆浦县",
              "id": 431224
            }, {
              "value": "会同县",
              "label": "会同县",
              "id": 431225
            }, {
              "value": "麻阳苗族自治县",
              "label": "麻阳苗族自治县",
              "id": 431226
            }, {
              "value": "新晃侗族自治县",
              "label": "新晃侗族自治县",
              "id": 431227
            }, {
              "value": "芷江侗族自治县",
              "label": "芷江侗族自治县",
              "id": 431228
            }, {
              "value": "靖州苗族侗族自治县",
              "label": "靖州苗族侗族自治县",
              "id": 431229
            }, {
              "value": "通道侗族自治县",
              "label": "通道侗族自治县",
              "id": 431230
            }, {
              "value": "洪江市",
              "label": "洪江市",
              "id": 431281
            }]
          }, {
            "value": "娄底市",
            "label": "娄底市",
            "id": 431300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 431301
            }, {
              "value": "娄星区",
              "label": "娄星区",
              "id": 431302
            }, {
              "value": "双峰县",
              "label": "双峰县",
              "id": 431321
            }, {
              "value": "新化县",
              "label": "新化县",
              "id": 431322
            }, {
              "value": "冷水江市",
              "label": "冷水江市",
              "id": 431381
            }, {
              "value": "涟源市",
              "label": "涟源市",
              "id": 431382
            }]
          }, {
            "value": "湘西土家族苗族自治州",
            "label": "湘西土家族苗族自治州",
            "id": 433100,
            "children": [{
              "value": "吉首市",
              "label": "吉首市",
              "id": 433101
            }, {
              "value": "泸溪县",
              "label": "泸溪县",
              "id": 433122
            }, {
              "value": "凤凰县",
              "label": "凤凰县",
              "id": 433123
            }, {
              "value": "花垣县",
              "label": "花垣县",
              "id": 433124
            }, {
              "value": "保靖县",
              "label": "保靖县",
              "id": 433125
            }, {
              "value": "古丈县",
              "label": "古丈县",
              "id": 433126
            }, {
              "value": "永顺县",
              "label": "永顺县",
              "id": 433127
            }, {
              "value": "龙山县",
              "label": "龙山县",
              "id": 433130
            }]
          }]
        }, {
          "value": "广东省",
          "label": "广东省",
          "id": 440000,
          "children": [{
            "value": "广州市",
            "label": "广州市",
            "id": 440100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440101
            }, {
              "value": "荔湾区",
              "label": "荔湾区",
              "id": 440103
            }, {
              "value": "越秀区",
              "label": "越秀区",
              "id": 440104
            }, {
              "value": "海珠区",
              "label": "海珠区",
              "id": 440105
            }, {
              "value": "天河区",
              "label": "天河区",
              "id": 440106
            }, {
              "value": "白云区",
              "label": "白云区",
              "id": 440111
            }, {
              "value": "黄埔区",
              "label": "黄埔区",
              "id": 440112
            }, {
              "value": "番禺区",
              "label": "番禺区",
              "id": 440113
            }, {
              "value": "花都区",
              "label": "花都区",
              "id": 440114
            }, {
              "value": "南沙区",
              "label": "南沙区",
              "id": 440115
            }, {
              "value": "从化区",
              "label": "从化区",
              "id": 440117
            }, {
              "value": "增城区",
              "label": "增城区",
              "id": 440118
            }]
          }, {
            "value": "韶关市",
            "label": "韶关市",
            "id": 440200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440201
            }, {
              "value": "武江区",
              "label": "武江区",
              "id": 440203
            }, {
              "value": "浈江区",
              "label": "浈江区",
              "id": 440204
            }, {
              "value": "曲江区",
              "label": "曲江区",
              "id": 440205
            }, {
              "value": "始兴县",
              "label": "始兴县",
              "id": 440222
            }, {
              "value": "仁化县",
              "label": "仁化县",
              "id": 440224
            }, {
              "value": "翁源县",
              "label": "翁源县",
              "id": 440229
            }, {
              "value": "乳源瑶族自治县",
              "label": "乳源瑶族自治县",
              "id": 440232
            }, {
              "value": "新丰县",
              "label": "新丰县",
              "id": 440233
            }, {
              "value": "乐昌市",
              "label": "乐昌市",
              "id": 440281
            }, {
              "value": "南雄市",
              "label": "南雄市",
              "id": 440282
            }]
          }, {
            "value": "深圳市",
            "label": "深圳市",
            "id": 440300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440301
            }, {
              "value": "罗湖区",
              "label": "罗湖区",
              "id": 440303
            }, {
              "value": "福田区",
              "label": "福田区",
              "id": 440304
            }, {
              "value": "南山区",
              "label": "南山区",
              "id": 440305
            }, {
              "value": "宝安区",
              "label": "宝安区",
              "id": 440306
            }, {
              "value": "龙岗区",
              "label": "龙岗区",
              "id": 440307
            }, {
              "value": "盐田区",
              "label": "盐田区",
              "id": 440308
            }]
          }, {
            "value": "珠海市",
            "label": "珠海市",
            "id": 440400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440401
            }, {
              "value": "香洲区",
              "label": "香洲区",
              "id": 440402
            }, {
              "value": "斗门区",
              "label": "斗门区",
              "id": 440403
            }, {
              "value": "金湾区",
              "label": "金湾区",
              "id": 440404
            }]
          }, {
            "value": "汕头市",
            "label": "汕头市",
            "id": 440500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440501
            }, {
              "value": "龙湖区",
              "label": "龙湖区",
              "id": 440507
            }, {
              "value": "金平区",
              "label": "金平区",
              "id": 440511
            }, {
              "value": "濠江区",
              "label": "濠江区",
              "id": 440512
            }, {
              "value": "潮阳区",
              "label": "潮阳区",
              "id": 440513
            }, {
              "value": "潮南区",
              "label": "潮南区",
              "id": 440514
            }, {
              "value": "澄海区",
              "label": "澄海区",
              "id": 440515
            }, {
              "value": "南澳县",
              "label": "南澳县",
              "id": 440523
            }]
          }, {
            "value": "佛山市",
            "label": "佛山市",
            "id": 440600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440601
            }, {
              "value": "禅城区",
              "label": "禅城区",
              "id": 440604
            }, {
              "value": "南海区",
              "label": "南海区",
              "id": 440605
            }, {
              "value": "顺德区",
              "label": "顺德区",
              "id": 440606
            }, {
              "value": "三水区",
              "label": "三水区",
              "id": 440607
            }, {
              "value": "高明区",
              "label": "高明区",
              "id": 440608
            }]
          }, {
            "value": "江门市",
            "label": "江门市",
            "id": 440700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440701
            }, {
              "value": "蓬江区",
              "label": "蓬江区",
              "id": 440703
            }, {
              "value": "江海区",
              "label": "江海区",
              "id": 440704
            }, {
              "value": "新会区",
              "label": "新会区",
              "id": 440705
            }, {
              "value": "台山市",
              "label": "台山市",
              "id": 440781
            }, {
              "value": "开平市",
              "label": "开平市",
              "id": 440783
            }, {
              "value": "鹤山市",
              "label": "鹤山市",
              "id": 440784
            }, {
              "value": "恩平市",
              "label": "恩平市",
              "id": 440785
            }]
          }, {
            "value": "湛江市",
            "label": "湛江市",
            "id": 440800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440801
            }, {
              "value": "赤坎区",
              "label": "赤坎区",
              "id": 440802
            }, {
              "value": "霞山区",
              "label": "霞山区",
              "id": 440803
            }, {
              "value": "坡头区",
              "label": "坡头区",
              "id": 440804
            }, {
              "value": "麻章区",
              "label": "麻章区",
              "id": 440811
            }, {
              "value": "遂溪县",
              "label": "遂溪县",
              "id": 440823
            }, {
              "value": "徐闻县",
              "label": "徐闻县",
              "id": 440825
            }, {
              "value": "廉江市",
              "label": "廉江市",
              "id": 440881
            }, {
              "value": "雷州市",
              "label": "雷州市",
              "id": 440882
            }, {
              "value": "吴川市",
              "label": "吴川市",
              "id": 440883
            }]
          }, {
            "value": "茂名市",
            "label": "茂名市",
            "id": 440900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 440901
            }, {
              "value": "茂南区",
              "label": "茂南区",
              "id": 440902
            }, {
              "value": "电白区",
              "label": "电白区",
              "id": 440904
            }, {
              "value": "高州市",
              "label": "高州市",
              "id": 440981
            }, {
              "value": "化州市",
              "label": "化州市",
              "id": 440982
            }, {
              "value": "信宜市",
              "label": "信宜市",
              "id": 440983
            }]
          }, {
            "value": "肇庆市",
            "label": "肇庆市",
            "id": 441200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441201
            }, {
              "value": "端州区",
              "label": "端州区",
              "id": 441202
            }, {
              "value": "鼎湖区",
              "label": "鼎湖区",
              "id": 441203
            }, {
              "value": "高要区",
              "label": "高要区",
              "id": 441204
            }, {
              "value": "广宁县",
              "label": "广宁县",
              "id": 441223
            }, {
              "value": "怀集县",
              "label": "怀集县",
              "id": 441224
            }, {
              "value": "封开县",
              "label": "封开县",
              "id": 441225
            }, {
              "value": "德庆县",
              "label": "德庆县",
              "id": 441226
            }, {
              "value": "四会市",
              "label": "四会市",
              "id": 441284
            }]
          }, {
            "value": "惠州市",
            "label": "惠州市",
            "id": 441300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441301
            }, {
              "value": "惠城区",
              "label": "惠城区",
              "id": 441302
            }, {
              "value": "惠阳区",
              "label": "惠阳区",
              "id": 441303
            }, {
              "value": "博罗县",
              "label": "博罗县",
              "id": 441322
            }, {
              "value": "惠东县",
              "label": "惠东县",
              "id": 441323
            }, {
              "value": "龙门县",
              "label": "龙门县",
              "id": 441324
            }]
          }, {
            "value": "梅州市",
            "label": "梅州市",
            "id": 441400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441401
            }, {
              "value": "梅江区",
              "label": "梅江区",
              "id": 441402
            }, {
              "value": "梅县区",
              "label": "梅县区",
              "id": 441403
            }, {
              "value": "大埔县",
              "label": "大埔县",
              "id": 441422
            }, {
              "value": "丰顺县",
              "label": "丰顺县",
              "id": 441423
            }, {
              "value": "五华县",
              "label": "五华县",
              "id": 441424
            }, {
              "value": "平远县",
              "label": "平远县",
              "id": 441426
            }, {
              "value": "蕉岭县",
              "label": "蕉岭县",
              "id": 441427
            }, {
              "value": "兴宁市",
              "label": "兴宁市",
              "id": 441481
            }]
          }, {
            "value": "汕尾市",
            "label": "汕尾市",
            "id": 441500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441501
            }, {
              "value": "城区",
              "label": "城区",
              "id": 441502
            }, {
              "value": "海丰县",
              "label": "海丰县",
              "id": 441521
            }, {
              "value": "陆河县",
              "label": "陆河县",
              "id": 441523
            }, {
              "value": "陆丰市",
              "label": "陆丰市",
              "id": 441581
            }]
          }, {
            "value": "河源市",
            "label": "河源市",
            "id": 441600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441601
            }, {
              "value": "源城区",
              "label": "源城区",
              "id": 441602
            }, {
              "value": "紫金县",
              "label": "紫金县",
              "id": 441621
            }, {
              "value": "龙川县",
              "label": "龙川县",
              "id": 441622
            }, {
              "value": "连平县",
              "label": "连平县",
              "id": 441623
            }, {
              "value": "和平县",
              "label": "和平县",
              "id": 441624
            }, {
              "value": "东源县",
              "label": "东源县",
              "id": 441625
            }]
          }, {
            "value": "阳江市",
            "label": "阳江市",
            "id": 441700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441701
            }, {
              "value": "江城区",
              "label": "江城区",
              "id": 441702
            }, {
              "value": "阳东区",
              "label": "阳东区",
              "id": 441704
            }, {
              "value": "阳西县",
              "label": "阳西县",
              "id": 441721
            }, {
              "value": "阳春市",
              "label": "阳春市",
              "id": 441781
            }]
          }, {
            "value": "清远市",
            "label": "清远市",
            "id": 441800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 441801
            }, {
              "value": "清城区",
              "label": "清城区",
              "id": 441802
            }, {
              "value": "清新区",
              "label": "清新区",
              "id": 441803
            }, {
              "value": "佛冈县",
              "label": "佛冈县",
              "id": 441821
            }, {
              "value": "阳山县",
              "label": "阳山县",
              "id": 441823
            }, {
              "value": "连山壮族瑶族自治县",
              "label": "连山壮族瑶族自治县",
              "id": 441825
            }, {
              "value": "连南瑶族自治县",
              "label": "连南瑶族自治县",
              "id": 441826
            }, {
              "value": "英德市",
              "label": "英德市",
              "id": 441881
            }, {
              "value": "连州市",
              "label": "连州市",
              "id": 441882
            }]
          }, {
            "value": "中山市",
            "label": "中山市",
            "id": 442000,
            "children": [{
              "value": "中山市",
              "label": "中山市",
              "id": 442001
            }]
          }, {
            "value": "潮州市",
            "label": "潮州市",
            "id": 445100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 445101
            }, {
              "value": "湘桥区",
              "label": "湘桥区",
              "id": 445102
            }, {
              "value": "潮安区",
              "label": "潮安区",
              "id": 445103
            }, {
              "value": "饶平县",
              "label": "饶平县",
              "id": 445122
            }]
          }, {
            "value": "揭阳市",
            "label": "揭阳市",
            "id": 445200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 445201
            }, {
              "value": "榕城区",
              "label": "榕城区",
              "id": 445202
            }, {
              "value": "揭东区",
              "label": "揭东区",
              "id": 445203
            }, {
              "value": "揭西县",
              "label": "揭西县",
              "id": 445222
            }, {
              "value": "惠来县",
              "label": "惠来县",
              "id": 445224
            }, {
              "value": "普宁市",
              "label": "普宁市",
              "id": 445281
            }]
          }, {
            "value": "云浮市",
            "label": "云浮市",
            "id": 445300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 445301
            }, {
              "value": "云城区",
              "label": "云城区",
              "id": 445302
            }, {
              "value": "云安区",
              "label": "云安区",
              "id": 445303
            }, {
              "value": "新兴县",
              "label": "新兴县",
              "id": 445321
            }, {
              "value": "郁南县",
              "label": "郁南县",
              "id": 445322
            }, {
              "value": "罗定市",
              "label": "罗定市",
              "id": 445381
            }]
          }, {
            "value": "东莞市",
            "label": "东莞市",
            "id": 441900,
            "children": [{
              "value": "东莞市",
              "label": "东莞市",
              "id": 441901
            }]
          }]
        }, {
          "value": "广西壮族自治区",
          "label": "广西壮族自治区",
          "id": 450000,
          "children": [{
            "value": "南宁市",
            "label": "南宁市",
            "id": 450100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450101
            }, {
              "value": "兴宁区",
              "label": "兴宁区",
              "id": 450102
            }, {
              "value": "青秀区",
              "label": "青秀区",
              "id": 450103
            }, {
              "value": "江南区",
              "label": "江南区",
              "id": 450105
            }, {
              "value": "西乡塘区",
              "label": "西乡塘区",
              "id": 450107
            }, {
              "value": "良庆区",
              "label": "良庆区",
              "id": 450108
            }, {
              "value": "邕宁区",
              "label": "邕宁区",
              "id": 450109
            }, {
              "value": "武鸣区",
              "label": "武鸣区",
              "id": 450110
            }, {
              "value": "隆安县",
              "label": "隆安县",
              "id": 450123
            }, {
              "value": "马山县",
              "label": "马山县",
              "id": 450124
            }, {
              "value": "上林县",
              "label": "上林县",
              "id": 450125
            }, {
              "value": "宾阳县",
              "label": "宾阳县",
              "id": 450126
            }, {
              "value": "横县",
              "label": "横县",
              "id": 450127
            }]
          }, {
            "value": "柳州市",
            "label": "柳州市",
            "id": 450200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450201
            }, {
              "value": "城中区",
              "label": "城中区",
              "id": 450202
            }, {
              "value": "鱼峰区",
              "label": "鱼峰区",
              "id": 450203
            }, {
              "value": "柳南区",
              "label": "柳南区",
              "id": 450204
            }, {
              "value": "柳北区",
              "label": "柳北区",
              "id": 450205
            }, {
              "value": "柳江区",
              "label": "柳江区",
              "id": 450206
            }, {
              "value": "柳城县",
              "label": "柳城县",
              "id": 450222
            }, {
              "value": "鹿寨县",
              "label": "鹿寨县",
              "id": 450223
            }, {
              "value": "融安县",
              "label": "融安县",
              "id": 450224
            }, {
              "value": "融水苗族自治县",
              "label": "融水苗族自治县",
              "id": 450225
            }, {
              "value": "三江侗族自治县",
              "label": "三江侗族自治县",
              "id": 450226
            }]
          }, {
            "value": "桂林市",
            "label": "桂林市",
            "id": 450300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450301
            }, {
              "value": "秀峰区",
              "label": "秀峰区",
              "id": 450302
            }, {
              "value": "叠彩区",
              "label": "叠彩区",
              "id": 450303
            }, {
              "value": "象山区",
              "label": "象山区",
              "id": 450304
            }, {
              "value": "七星区",
              "label": "七星区",
              "id": 450305
            }, {
              "value": "雁山区",
              "label": "雁山区",
              "id": 450311
            }, {
              "value": "临桂区",
              "label": "临桂区",
              "id": 450312
            }, {
              "value": "阳朔县",
              "label": "阳朔县",
              "id": 450321
            }, {
              "value": "灵川县",
              "label": "灵川县",
              "id": 450323
            }, {
              "value": "全州县",
              "label": "全州县",
              "id": 450324
            }, {
              "value": "兴安县",
              "label": "兴安县",
              "id": 450325
            }, {
              "value": "永福县",
              "label": "永福县",
              "id": 450326
            }, {
              "value": "灌阳县",
              "label": "灌阳县",
              "id": 450327
            }, {
              "value": "龙胜各族自治县",
              "label": "龙胜各族自治县",
              "id": 450328
            }, {
              "value": "资源县",
              "label": "资源县",
              "id": 450329
            }, {
              "value": "平乐县",
              "label": "平乐县",
              "id": 450330
            }, {
              "value": "荔浦县",
              "label": "荔浦县",
              "id": 450331
            }, {
              "value": "恭城瑶族自治县",
              "label": "恭城瑶族自治县",
              "id": 450332
            }]
          }, {
            "value": "梧州市",
            "label": "梧州市",
            "id": 450400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450401
            }, {
              "value": "万秀区",
              "label": "万秀区",
              "id": 450403
            }, {
              "value": "长洲区",
              "label": "长洲区",
              "id": 450405
            }, {
              "value": "龙圩区",
              "label": "龙圩区",
              "id": 450406
            }, {
              "value": "苍梧县",
              "label": "苍梧县",
              "id": 450421
            }, {
              "value": "藤县",
              "label": "藤县",
              "id": 450422
            }, {
              "value": "蒙山县",
              "label": "蒙山县",
              "id": 450423
            }, {
              "value": "岑溪市",
              "label": "岑溪市",
              "id": 450481
            }]
          }, {
            "value": "北海市",
            "label": "北海市",
            "id": 450500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450501
            }, {
              "value": "海城区",
              "label": "海城区",
              "id": 450502
            }, {
              "value": "银海区",
              "label": "银海区",
              "id": 450503
            }, {
              "value": "铁山港区",
              "label": "铁山港区",
              "id": 450512
            }, {
              "value": "合浦县",
              "label": "合浦县",
              "id": 450521
            }]
          }, {
            "value": "防城港市",
            "label": "防城港市",
            "id": 450600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450601
            }, {
              "value": "港口区",
              "label": "港口区",
              "id": 450602
            }, {
              "value": "防城区",
              "label": "防城区",
              "id": 450603
            }, {
              "value": "上思县",
              "label": "上思县",
              "id": 450621
            }, {
              "value": "东兴市",
              "label": "东兴市",
              "id": 450681
            }]
          }, {
            "value": "钦州市",
            "label": "钦州市",
            "id": 450700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450701
            }, {
              "value": "钦南区",
              "label": "钦南区",
              "id": 450702
            }, {
              "value": "钦北区",
              "label": "钦北区",
              "id": 450703
            }, {
              "value": "灵山县",
              "label": "灵山县",
              "id": 450721
            }, {
              "value": "浦北县",
              "label": "浦北县",
              "id": 450722
            }]
          }, {
            "value": "贵港市",
            "label": "贵港市",
            "id": 450800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450801
            }, {
              "value": "港北区",
              "label": "港北区",
              "id": 450802
            }, {
              "value": "港南区",
              "label": "港南区",
              "id": 450803
            }, {
              "value": "覃塘区",
              "label": "覃塘区",
              "id": 450804
            }, {
              "value": "平南县",
              "label": "平南县",
              "id": 450821
            }, {
              "value": "桂平市",
              "label": "桂平市",
              "id": 450881
            }]
          }, {
            "value": "玉林市",
            "label": "玉林市",
            "id": 450900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 450901
            }, {
              "value": "玉州区",
              "label": "玉州区",
              "id": 450902
            }, {
              "value": "福绵区",
              "label": "福绵区",
              "id": 450903
            }, {
              "value": "容县",
              "label": "容县",
              "id": 450921
            }, {
              "value": "陆川县",
              "label": "陆川县",
              "id": 450922
            }, {
              "value": "博白县",
              "label": "博白县",
              "id": 450923
            }, {
              "value": "兴业县",
              "label": "兴业县",
              "id": 450924
            }, {
              "value": "北流市",
              "label": "北流市",
              "id": 450981
            }]
          }, {
            "value": "百色市",
            "label": "百色市",
            "id": 451000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 451001
            }, {
              "value": "右江区",
              "label": "右江区",
              "id": 451002
            }, {
              "value": "田阳县",
              "label": "田阳县",
              "id": 451021
            }, {
              "value": "田东县",
              "label": "田东县",
              "id": 451022
            }, {
              "value": "平果县",
              "label": "平果县",
              "id": 451023
            }, {
              "value": "德保县",
              "label": "德保县",
              "id": 451024
            }, {
              "value": "那坡县",
              "label": "那坡县",
              "id": 451026
            }, {
              "value": "凌云县",
              "label": "凌云县",
              "id": 451027
            }, {
              "value": "乐业县",
              "label": "乐业县",
              "id": 451028
            }, {
              "value": "田林县",
              "label": "田林县",
              "id": 451029
            }, {
              "value": "西林县",
              "label": "西林县",
              "id": 451030
            }, {
              "value": "隆林各族自治县",
              "label": "隆林各族自治县",
              "id": 451031
            }, {
              "value": "靖西市",
              "label": "靖西市",
              "id": 451081
            }]
          }, {
            "value": "贺州市",
            "label": "贺州市",
            "id": 451100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 451101
            }, {
              "value": "八步区",
              "label": "八步区",
              "id": 451102
            }, {
              "value": "平桂区",
              "label": "平桂区",
              "id": 451103
            }, {
              "value": "昭平县",
              "label": "昭平县",
              "id": 451121
            }, {
              "value": "钟山县",
              "label": "钟山县",
              "id": 451122
            }, {
              "value": "富川瑶族自治县",
              "label": "富川瑶族自治县",
              "id": 451123
            }]
          }, {
            "value": "河池市",
            "label": "河池市",
            "id": 451200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 451201
            }, {
              "value": "金城江区",
              "label": "金城江区",
              "id": 451202
            }, {
              "value": "南丹县",
              "label": "南丹县",
              "id": 451221
            }, {
              "value": "天峨县",
              "label": "天峨县",
              "id": 451222
            }, {
              "value": "凤山县",
              "label": "凤山县",
              "id": 451223
            }, {
              "value": "东兰县",
              "label": "东兰县",
              "id": 451224
            }, {
              "value": "罗城仫佬族自治县",
              "label": "罗城仫佬族自治县",
              "id": 451225
            }, {
              "value": "环江毛南族自治县",
              "label": "环江毛南族自治县",
              "id": 451226
            }, {
              "value": "巴马瑶族自治县",
              "label": "巴马瑶族自治县",
              "id": 451227
            }, {
              "value": "都安瑶族自治县",
              "label": "都安瑶族自治县",
              "id": 451228
            }, {
              "value": "大化瑶族自治县",
              "label": "大化瑶族自治县",
              "id": 451229
            }, {
              "value": "宜州市",
              "label": "宜州市",
              "id": 451281
            }]
          }, {
            "value": "来宾市",
            "label": "来宾市",
            "id": 451300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 451301
            }, {
              "value": "兴宾区",
              "label": "兴宾区",
              "id": 451302
            }, {
              "value": "忻城县",
              "label": "忻城县",
              "id": 451321
            }, {
              "value": "象州县",
              "label": "象州县",
              "id": 451322
            }, {
              "value": "武宣县",
              "label": "武宣县",
              "id": 451323
            }, {
              "value": "金秀瑶族自治县",
              "label": "金秀瑶族自治县",
              "id": 451324
            }, {
              "value": "合山市",
              "label": "合山市",
              "id": 451381
            }]
          }, {
            "value": "崇左市",
            "label": "崇左市",
            "id": 451400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 451401
            }, {
              "value": "江州区",
              "label": "江州区",
              "id": 451402
            }, {
              "value": "扶绥县",
              "label": "扶绥县",
              "id": 451421
            }, {
              "value": "宁明县",
              "label": "宁明县",
              "id": 451422
            }, {
              "value": "龙州县",
              "label": "龙州县",
              "id": 451423
            }, {
              "value": "大新县",
              "label": "大新县",
              "id": 451424
            }, {
              "value": "天等县",
              "label": "天等县",
              "id": 451425
            }, {
              "value": "凭祥市",
              "label": "凭祥市",
              "id": 451481
            }]
          }]
        }, {
          "value": "海南省",
          "label": "海南省",
          "id": 460000,
          "children": [{
            "value": "海口市",
            "label": "海口市",
            "id": 460100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 460101
            }, {
              "value": "秀英区",
              "label": "秀英区",
              "id": 460105
            }, {
              "value": "龙华区",
              "label": "龙华区",
              "id": 460106
            }, {
              "value": "琼山区",
              "label": "琼山区",
              "id": 460107
            }, {
              "value": "美兰区",
              "label": "美兰区",
              "id": 460108
            }]
          }, {
            "value": "三亚市",
            "label": "三亚市",
            "id": 460200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 460201
            }, {
              "value": "海棠区",
              "label": "海棠区",
              "id": 460202
            }, {
              "value": "吉阳区",
              "label": "吉阳区",
              "id": 460203
            }, {
              "value": "天涯区",
              "label": "天涯区",
              "id": 460204
            }, {
              "value": "崖州区",
              "label": "崖州区",
              "id": 460205
            }]
          }, {
            "value": "三沙市",
            "label": "三沙市",
            "id": 460300,
            "children": [{
              "value": "西沙群岛",
              "label": "西沙群岛",
              "id": 460321
            }, {
              "value": "南沙群岛",
              "label": "南沙群岛",
              "id": 460322
            }, {
              "value": "中沙群岛",
              "label": "中沙群岛",
              "id": 460323
            }, {
              "value": "永乐群岛",
              "label": "永乐群岛",
              "id": 460324
            }]
          }, {
            "value": "儋州市",
            "label": "儋州市",
            "id": 460400,
            "children": [{
              "value": "儋州市",
              "label": "儋州市",
              "id": 460401
            }]
          }, {
            "value": "省直辖县级行政区划",
            "label": "省直辖县级行政区划",
            "id": 469000,
            "children": [{
              "value": "五指山市",
              "label": "五指山市",
              "id": 469001
            }, {
              "value": "琼海市",
              "label": "琼海市",
              "id": 469002
            }, {
              "value": "文昌市",
              "label": "文昌市",
              "id": 469005
            }, {
              "value": "万宁市",
              "label": "万宁市",
              "id": 469006
            }, {
              "value": "东方市",
              "label": "东方市",
              "id": 469007
            }, {
              "value": "定安县",
              "label": "定安县",
              "id": 469021
            }, {
              "value": "屯昌县",
              "label": "屯昌县",
              "id": 469022
            }, {
              "value": "澄迈县",
              "label": "澄迈县",
              "id": 469023
            }, {
              "value": "临高县",
              "label": "临高县",
              "id": 469024
            }, {
              "value": "白沙黎族自治县",
              "label": "白沙黎族自治县",
              "id": 469025
            }, {
              "value": "昌江黎族自治县",
              "label": "昌江黎族自治县",
              "id": 469026
            }, {
              "value": "乐东黎族自治县",
              "label": "乐东黎族自治县",
              "id": 469027
            }, {
              "value": "陵水黎族自治县",
              "label": "陵水黎族自治县",
              "id": 469028
            }, {
              "value": "保亭黎族苗族自治县",
              "label": "保亭黎族苗族自治县",
              "id": 469029
            }, {
              "value": "琼中黎族苗族自治县",
              "label": "琼中黎族苗族自治县",
              "id": 469030
            }]
          }]
        }, {
          "value": "重庆市",
          "label": "重庆市",
          "id": 500000,
          "children": [{
            "value": "市辖区",
            "label": "市辖区",
            "id": 500100,
            "children": [{
              "value": "万州区",
              "label": "万州区",
              "id": 500101
            }, {
              "value": "涪陵区",
              "label": "涪陵区",
              "id": 500102
            }, {
              "value": "渝中区",
              "label": "渝中区",
              "id": 500103
            }, {
              "value": "大渡口区",
              "label": "大渡口区",
              "id": 500104
            }, {
              "value": "江北区",
              "label": "江北区",
              "id": 500105
            }, {
              "value": "沙坪坝区",
              "label": "沙坪坝区",
              "id": 500106
            }, {
              "value": "九龙坡区",
              "label": "九龙坡区",
              "id": 500107
            }, {
              "value": "南岸区",
              "label": "南岸区",
              "id": 500108
            }, {
              "value": "北碚区",
              "label": "北碚区",
              "id": 500109
            }, {
              "value": "綦江区",
              "label": "綦江区",
              "id": 500110
            }, {
              "value": "大足区",
              "label": "大足区",
              "id": 500111
            }, {
              "value": "渝北区",
              "label": "渝北区",
              "id": 500112
            }, {
              "value": "巴南区",
              "label": "巴南区",
              "id": 500113
            }, {
              "value": "黔江区",
              "label": "黔江区",
              "id": 500114
            }, {
              "value": "长寿区",
              "label": "长寿区",
              "id": 500115
            }, {
              "value": "江津区",
              "label": "江津区",
              "id": 500116
            }, {
              "value": "合川区",
              "label": "合川区",
              "id": 500117
            }, {
              "value": "永川区",
              "label": "永川区",
              "id": 500118
            }, {
              "value": "南川区",
              "label": "南川区",
              "id": 500119
            }, {
              "value": "璧山区",
              "label": "璧山区",
              "id": 500120
            }, {
              "value": "铜梁区",
              "label": "铜梁区",
              "id": 500151
            }, {
              "value": "潼南区",
              "label": "潼南区",
              "id": 500152
            }, {
              "value": "荣昌区",
              "label": "荣昌区",
              "id": 500153
            }, {
              "value": "开州区",
              "label": "开州区",
              "id": 500154
            }]
          }, {
            "value": "县",
            "label": "县",
            "id": 500200,
            "children": [{
              "value": "梁平县",
              "label": "梁平县",
              "id": 500228
            }, {
              "value": "城口县",
              "label": "城口县",
              "id": 500229
            }, {
              "value": "丰都县",
              "label": "丰都县",
              "id": 500230
            }, {
              "value": "垫江县",
              "label": "垫江县",
              "id": 500231
            }, {
              "value": "武隆县",
              "label": "武隆县",
              "id": 500232
            }, {
              "value": "忠县",
              "label": "忠县",
              "id": 500233
            }, {
              "value": "云阳县",
              "label": "云阳县",
              "id": 500235
            }, {
              "value": "奉节县",
              "label": "奉节县",
              "id": 500236
            }, {
              "value": "巫山县",
              "label": "巫山县",
              "id": 500237
            }, {
              "value": "巫溪县",
              "label": "巫溪县",
              "id": 500238
            }, {
              "value": "石柱土家族自治县",
              "label": "石柱土家族自治县",
              "id": 500240
            }, {
              "value": "秀山土家族苗族自治县",
              "label": "秀山土家族苗族自治县",
              "id": 500241
            }, {
              "value": "酉阳土家族苗族自治县",
              "label": "酉阳土家族苗族自治县",
              "id": 500242
            }, {
              "value": "彭水苗族土家族自治县",
              "label": "彭水苗族土家族自治县",
              "id": 500243
            }]
          }]
        }, {
          "value": "四川省",
          "label": "四川省",
          "id": 510000,
          "children": [{
            "value": "成都市",
            "label": "成都市",
            "id": 510100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510101
            }, {
              "value": "锦江区",
              "label": "锦江区",
              "id": 510104
            }, {
              "value": "青羊区",
              "label": "青羊区",
              "id": 510105
            }, {
              "value": "金牛区",
              "label": "金牛区",
              "id": 510106
            }, {
              "value": "武侯区",
              "label": "武侯区",
              "id": 510107
            }, {
              "value": "成华区",
              "label": "成华区",
              "id": 510108
            }, {
              "value": "龙泉驿区",
              "label": "龙泉驿区",
              "id": 510112
            }, {
              "value": "青白江区",
              "label": "青白江区",
              "id": 510113
            }, {
              "value": "新都区",
              "label": "新都区",
              "id": 510114
            }, {
              "value": "温江区",
              "label": "温江区",
              "id": 510115
            }, {
              "value": "双流区",
              "label": "双流区",
              "id": 510116
            }, {
              "value": "金堂县",
              "label": "金堂县",
              "id": 510121
            }, {
              "value": "郫县",
              "label": "郫县",
              "id": 510124
            }, {
              "value": "大邑县",
              "label": "大邑县",
              "id": 510129
            }, {
              "value": "蒲江县",
              "label": "蒲江县",
              "id": 510131
            }, {
              "value": "新津县",
              "label": "新津县",
              "id": 510132
            }, {
              "value": "都江堰市",
              "label": "都江堰市",
              "id": 510181
            }, {
              "value": "彭州市",
              "label": "彭州市",
              "id": 510182
            }, {
              "value": "邛崃市",
              "label": "邛崃市",
              "id": 510183
            }, {
              "value": "崇州市",
              "label": "崇州市",
              "id": 510184
            }, {
              "value": "简阳市",
              "label": "简阳市",
              "id": 510185
            }]
          }, {
            "value": "自贡市",
            "label": "自贡市",
            "id": 510300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510301
            }, {
              "value": "自流井区",
              "label": "自流井区",
              "id": 510302
            }, {
              "value": "贡井区",
              "label": "贡井区",
              "id": 510303
            }, {
              "value": "大安区",
              "label": "大安区",
              "id": 510304
            }, {
              "value": "沿滩区",
              "label": "沿滩区",
              "id": 510311
            }, {
              "value": "荣县",
              "label": "荣县",
              "id": 510321
            }, {
              "value": "富顺县",
              "label": "富顺县",
              "id": 510322
            }]
          }, {
            "value": "攀枝花市",
            "label": "攀枝花市",
            "id": 510400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510401
            }, {
              "value": "东区",
              "label": "东区",
              "id": 510402
            }, {
              "value": "西区",
              "label": "西区",
              "id": 510403
            }, {
              "value": "仁和区",
              "label": "仁和区",
              "id": 510411
            }, {
              "value": "米易县",
              "label": "米易县",
              "id": 510421
            }, {
              "value": "盐边县",
              "label": "盐边县",
              "id": 510422
            }]
          }, {
            "value": "泸州市",
            "label": "泸州市",
            "id": 510500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510501
            }, {
              "value": "江阳区",
              "label": "江阳区",
              "id": 510502
            }, {
              "value": "纳溪区",
              "label": "纳溪区",
              "id": 510503
            }, {
              "value": "龙马潭区",
              "label": "龙马潭区",
              "id": 510504
            }, {
              "value": "泸县",
              "label": "泸县",
              "id": 510521
            }, {
              "value": "合江县",
              "label": "合江县",
              "id": 510522
            }, {
              "value": "叙永县",
              "label": "叙永县",
              "id": 510524
            }, {
              "value": "古蔺县",
              "label": "古蔺县",
              "id": 510525
            }]
          }, {
            "value": "德阳市",
            "label": "德阳市",
            "id": 510600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510601
            }, {
              "value": "旌阳区",
              "label": "旌阳区",
              "id": 510603
            }, {
              "value": "中江县",
              "label": "中江县",
              "id": 510623
            }, {
              "value": "罗江县",
              "label": "罗江县",
              "id": 510626
            }, {
              "value": "广汉市",
              "label": "广汉市",
              "id": 510681
            }, {
              "value": "什邡市",
              "label": "什邡市",
              "id": 510682
            }, {
              "value": "绵竹市",
              "label": "绵竹市",
              "id": 510683
            }]
          }, {
            "value": "绵阳市",
            "label": "绵阳市",
            "id": 510700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510701
            }, {
              "value": "涪城区",
              "label": "涪城区",
              "id": 510703
            }, {
              "value": "游仙区",
              "label": "游仙区",
              "id": 510704
            }, {
              "value": "安州区",
              "label": "安州区",
              "id": 510705
            }, {
              "value": "三台县",
              "label": "三台县",
              "id": 510722
            }, {
              "value": "盐亭县",
              "label": "盐亭县",
              "id": 510723
            }, {
              "value": "梓潼县",
              "label": "梓潼县",
              "id": 510725
            }, {
              "value": "北川羌族自治县",
              "label": "北川羌族自治县",
              "id": 510726
            }, {
              "value": "平武县",
              "label": "平武县",
              "id": 510727
            }, {
              "value": "江油市",
              "label": "江油市",
              "id": 510781
            }]
          }, {
            "value": "广元市",
            "label": "广元市",
            "id": 510800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510801
            }, {
              "value": "利州区",
              "label": "利州区",
              "id": 510802
            }, {
              "value": "昭化区",
              "label": "昭化区",
              "id": 510811
            }, {
              "value": "朝天区",
              "label": "朝天区",
              "id": 510812
            }, {
              "value": "旺苍县",
              "label": "旺苍县",
              "id": 510821
            }, {
              "value": "青川县",
              "label": "青川县",
              "id": 510822
            }, {
              "value": "剑阁县",
              "label": "剑阁县",
              "id": 510823
            }, {
              "value": "苍溪县",
              "label": "苍溪县",
              "id": 510824
            }]
          }, {
            "value": "遂宁市",
            "label": "遂宁市",
            "id": 510900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 510901
            }, {
              "value": "船山区",
              "label": "船山区",
              "id": 510903
            }, {
              "value": "安居区",
              "label": "安居区",
              "id": 510904
            }, {
              "value": "蓬溪县",
              "label": "蓬溪县",
              "id": 510921
            }, {
              "value": "射洪县",
              "label": "射洪县",
              "id": 510922
            }, {
              "value": "大英县",
              "label": "大英县",
              "id": 510923
            }]
          }, {
            "value": "内江市",
            "label": "内江市",
            "id": 511000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511001
            }, {
              "value": "市中区",
              "label": "市中区",
              "id": 511002
            }, {
              "value": "东兴区",
              "label": "东兴区",
              "id": 511011
            }, {
              "value": "威远县",
              "label": "威远县",
              "id": 511024
            }, {
              "value": "资中县",
              "label": "资中县",
              "id": 511025
            }, {
              "value": "隆昌县",
              "label": "隆昌县",
              "id": 511028
            }]
          }, {
            "value": "乐山市",
            "label": "乐山市",
            "id": 511100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511101
            }, {
              "value": "市中区",
              "label": "市中区",
              "id": 511102
            }, {
              "value": "沙湾区",
              "label": "沙湾区",
              "id": 511111
            }, {
              "value": "五通桥区",
              "label": "五通桥区",
              "id": 511112
            }, {
              "value": "金口河区",
              "label": "金口河区",
              "id": 511113
            }, {
              "value": "犍为县",
              "label": "犍为县",
              "id": 511123
            }, {
              "value": "井研县",
              "label": "井研县",
              "id": 511124
            }, {
              "value": "夹江县",
              "label": "夹江县",
              "id": 511126
            }, {
              "value": "沐川县",
              "label": "沐川县",
              "id": 511129
            }, {
              "value": "峨边彝族自治县",
              "label": "峨边彝族自治县",
              "id": 511132
            }, {
              "value": "马边彝族自治县",
              "label": "马边彝族自治县",
              "id": 511133
            }, {
              "value": "峨眉山市",
              "label": "峨眉山市",
              "id": 511181
            }]
          }, {
            "value": "南充市",
            "label": "南充市",
            "id": 511300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511301
            }, {
              "value": "顺庆区",
              "label": "顺庆区",
              "id": 511302
            }, {
              "value": "高坪区",
              "label": "高坪区",
              "id": 511303
            }, {
              "value": "嘉陵区",
              "label": "嘉陵区",
              "id": 511304
            }, {
              "value": "南部县",
              "label": "南部县",
              "id": 511321
            }, {
              "value": "营山县",
              "label": "营山县",
              "id": 511322
            }, {
              "value": "蓬安县",
              "label": "蓬安县",
              "id": 511323
            }, {
              "value": "仪陇县",
              "label": "仪陇县",
              "id": 511324
            }, {
              "value": "西充县",
              "label": "西充县",
              "id": 511325
            }, {
              "value": "阆中市",
              "label": "阆中市",
              "id": 511381
            }]
          }, {
            "value": "眉山市",
            "label": "眉山市",
            "id": 511400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511401
            }, {
              "value": "东坡区",
              "label": "东坡区",
              "id": 511402
            }, {
              "value": "彭山区",
              "label": "彭山区",
              "id": 511403
            }, {
              "value": "仁寿县",
              "label": "仁寿县",
              "id": 511421
            }, {
              "value": "洪雅县",
              "label": "洪雅县",
              "id": 511423
            }, {
              "value": "丹棱县",
              "label": "丹棱县",
              "id": 511424
            }, {
              "value": "青神县",
              "label": "青神县",
              "id": 511425
            }]
          }, {
            "value": "宜宾市",
            "label": "宜宾市",
            "id": 511500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511501
            }, {
              "value": "翠屏区",
              "label": "翠屏区",
              "id": 511502
            }, {
              "value": "南溪区",
              "label": "南溪区",
              "id": 511503
            }, {
              "value": "宜宾县",
              "label": "宜宾县",
              "id": 511521
            }, {
              "value": "江安县",
              "label": "江安县",
              "id": 511523
            }, {
              "value": "长宁县",
              "label": "长宁县",
              "id": 511524
            }, {
              "value": "高县",
              "label": "高县",
              "id": 511525
            }, {
              "value": "珙县",
              "label": "珙县",
              "id": 511526
            }, {
              "value": "筠连县",
              "label": "筠连县",
              "id": 511527
            }, {
              "value": "兴文县",
              "label": "兴文县",
              "id": 511528
            }, {
              "value": "屏山县",
              "label": "屏山县",
              "id": 511529
            }]
          }, {
            "value": "广安市",
            "label": "广安市",
            "id": 511600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511601
            }, {
              "value": "广安区",
              "label": "广安区",
              "id": 511602
            }, {
              "value": "前锋区",
              "label": "前锋区",
              "id": 511603
            }, {
              "value": "岳池县",
              "label": "岳池县",
              "id": 511621
            }, {
              "value": "武胜县",
              "label": "武胜县",
              "id": 511622
            }, {
              "value": "邻水县",
              "label": "邻水县",
              "id": 511623
            }, {
              "value": "华蓥市",
              "label": "华蓥市",
              "id": 511681
            }]
          }, {
            "value": "达州市",
            "label": "达州市",
            "id": 511700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511701
            }, {
              "value": "通川区",
              "label": "通川区",
              "id": 511702
            }, {
              "value": "达川区",
              "label": "达川区",
              "id": 511703
            }, {
              "value": "宣汉县",
              "label": "宣汉县",
              "id": 511722
            }, {
              "value": "开江县",
              "label": "开江县",
              "id": 511723
            }, {
              "value": "大竹县",
              "label": "大竹县",
              "id": 511724
            }, {
              "value": "渠县",
              "label": "渠县",
              "id": 511725
            }, {
              "value": "万源市",
              "label": "万源市",
              "id": 511781
            }]
          }, {
            "value": "雅安市",
            "label": "雅安市",
            "id": 511800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511801
            }, {
              "value": "雨城区",
              "label": "雨城区",
              "id": 511802
            }, {
              "value": "名山区",
              "label": "名山区",
              "id": 511803
            }, {
              "value": "荥经县",
              "label": "荥经县",
              "id": 511822
            }, {
              "value": "汉源县",
              "label": "汉源县",
              "id": 511823
            }, {
              "value": "石棉县",
              "label": "石棉县",
              "id": 511824
            }, {
              "value": "天全县",
              "label": "天全县",
              "id": 511825
            }, {
              "value": "芦山县",
              "label": "芦山县",
              "id": 511826
            }, {
              "value": "宝兴县",
              "label": "宝兴县",
              "id": 511827
            }]
          }, {
            "value": "巴中市",
            "label": "巴中市",
            "id": 511900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 511901
            }, {
              "value": "巴州区",
              "label": "巴州区",
              "id": 511902
            }, {
              "value": "恩阳区",
              "label": "恩阳区",
              "id": 511903
            }, {
              "value": "通江县",
              "label": "通江县",
              "id": 511921
            }, {
              "value": "南江县",
              "label": "南江县",
              "id": 511922
            }, {
              "value": "平昌县",
              "label": "平昌县",
              "id": 511923
            }]
          }, {
            "value": "资阳市",
            "label": "资阳市",
            "id": 512000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 512001
            }, {
              "value": "雁江区",
              "label": "雁江区",
              "id": 512002
            }, {
              "value": "安岳县",
              "label": "安岳县",
              "id": 512021
            }, {
              "value": "乐至县",
              "label": "乐至县",
              "id": 512022
            }]
          }, {
            "value": "阿坝藏族羌族自治州",
            "label": "阿坝藏族羌族自治州",
            "id": 513200,
            "children": [{
              "value": "马尔康市",
              "label": "马尔康市",
              "id": 513201
            }, {
              "value": "汶川县",
              "label": "汶川县",
              "id": 513221
            }, {
              "value": "理县",
              "label": "理县",
              "id": 513222
            }, {
              "value": "茂县",
              "label": "茂县",
              "id": 513223
            }, {
              "value": "松潘县",
              "label": "松潘县",
              "id": 513224
            }, {
              "value": "九寨沟县",
              "label": "九寨沟县",
              "id": 513225
            }, {
              "value": "金川县",
              "label": "金川县",
              "id": 513226
            }, {
              "value": "小金县",
              "label": "小金县",
              "id": 513227
            }, {
              "value": "黑水县",
              "label": "黑水县",
              "id": 513228
            }, {
              "value": "壤塘县",
              "label": "壤塘县",
              "id": 513230
            }, {
              "value": "阿坝县",
              "label": "阿坝县",
              "id": 513231
            }, {
              "value": "若尔盖县",
              "label": "若尔盖县",
              "id": 513232
            }, {
              "value": "红原县",
              "label": "红原县",
              "id": 513233
            }]
          }, {
            "value": "甘孜藏族自治州",
            "label": "甘孜藏族自治州",
            "id": 513300,
            "children": [{
              "value": "康定市",
              "label": "康定市",
              "id": 513301
            }, {
              "value": "泸定县",
              "label": "泸定县",
              "id": 513322
            }, {
              "value": "丹巴县",
              "label": "丹巴县",
              "id": 513323
            }, {
              "value": "九龙县",
              "label": "九龙县",
              "id": 513324
            }, {
              "value": "雅江县",
              "label": "雅江县",
              "id": 513325
            }, {
              "value": "道孚县",
              "label": "道孚县",
              "id": 513326
            }, {
              "value": "炉霍县",
              "label": "炉霍县",
              "id": 513327
            }, {
              "value": "甘孜县",
              "label": "甘孜县",
              "id": 513328
            }, {
              "value": "新龙县",
              "label": "新龙县",
              "id": 513329
            }, {
              "value": "德格县",
              "label": "德格县",
              "id": 513330
            }, {
              "value": "白玉县",
              "label": "白玉县",
              "id": 513331
            }, {
              "value": "石渠县",
              "label": "石渠县",
              "id": 513332
            }, {
              "value": "色达县",
              "label": "色达县",
              "id": 513333
            }, {
              "value": "理塘县",
              "label": "理塘县",
              "id": 513334
            }, {
              "value": "巴塘县",
              "label": "巴塘县",
              "id": 513335
            }, {
              "value": "乡城县",
              "label": "乡城县",
              "id": 513336
            }, {
              "value": "稻城县",
              "label": "稻城县",
              "id": 513337
            }, {
              "value": "得荣县",
              "label": "得荣县",
              "id": 513338
            }]
          }, {
            "value": "凉山彝族自治州",
            "label": "凉山彝族自治州",
            "id": 513400,
            "children": [{
              "value": "西昌市",
              "label": "西昌市",
              "id": 513401
            }, {
              "value": "木里藏族自治县",
              "label": "木里藏族自治县",
              "id": 513422
            }, {
              "value": "盐源县",
              "label": "盐源县",
              "id": 513423
            }, {
              "value": "德昌县",
              "label": "德昌县",
              "id": 513424
            }, {
              "value": "会理县",
              "label": "会理县",
              "id": 513425
            }, {
              "value": "会东县",
              "label": "会东县",
              "id": 513426
            }, {
              "value": "宁南县",
              "label": "宁南县",
              "id": 513427
            }, {
              "value": "普格县",
              "label": "普格县",
              "id": 513428
            }, {
              "value": "布拖县",
              "label": "布拖县",
              "id": 513429
            }, {
              "value": "金阳县",
              "label": "金阳县",
              "id": 513430
            }, {
              "value": "昭觉县",
              "label": "昭觉县",
              "id": 513431
            }, {
              "value": "喜德县",
              "label": "喜德县",
              "id": 513432
            }, {
              "value": "冕宁县",
              "label": "冕宁县",
              "id": 513433
            }, {
              "value": "越西县",
              "label": "越西县",
              "id": 513434
            }, {
              "value": "甘洛县",
              "label": "甘洛县",
              "id": 513435
            }, {
              "value": "美姑县",
              "label": "美姑县",
              "id": 513436
            }, {
              "value": "雷波县",
              "label": "雷波县",
              "id": 513437
            }]
          }]
        }, {
          "value": "贵州省",
          "label": "贵州省",
          "id": 520000,
          "children": [{
            "value": "贵阳市",
            "label": "贵阳市",
            "id": 520100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 520101
            }, {
              "value": "南明区",
              "label": "南明区",
              "id": 520102
            }, {
              "value": "云岩区",
              "label": "云岩区",
              "id": 520103
            }, {
              "value": "花溪区",
              "label": "花溪区",
              "id": 520111
            }, {
              "value": "乌当区",
              "label": "乌当区",
              "id": 520112
            }, {
              "value": "白云区",
              "label": "白云区",
              "id": 520113
            }, {
              "value": "观山湖区",
              "label": "观山湖区",
              "id": 520115
            }, {
              "value": "开阳县",
              "label": "开阳县",
              "id": 520121
            }, {
              "value": "息烽县",
              "label": "息烽县",
              "id": 520122
            }, {
              "value": "修文县",
              "label": "修文县",
              "id": 520123
            }, {
              "value": "清镇市",
              "label": "清镇市",
              "id": 520181
            }]
          }, {
            "value": "六盘水市",
            "label": "六盘水市",
            "id": 520200,
            "children": [{
              "value": "钟山区",
              "label": "钟山区",
              "id": 520201
            }, {
              "value": "六枝特区",
              "label": "六枝特区",
              "id": 520203
            }, {
              "value": "水城县",
              "label": "水城县",
              "id": 520221
            }, {
              "value": "盘县",
              "label": "盘县",
              "id": 520222
            }]
          }, {
            "value": "遵义市",
            "label": "遵义市",
            "id": 520300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 520301
            }, {
              "value": "红花岗区",
              "label": "红花岗区",
              "id": 520302
            }, {
              "value": "汇川区",
              "label": "汇川区",
              "id": 520303
            }, {
              "value": "播州区",
              "label": "播州区",
              "id": 520304
            }, {
              "value": "桐梓县",
              "label": "桐梓县",
              "id": 520322
            }, {
              "value": "绥阳县",
              "label": "绥阳县",
              "id": 520323
            }, {
              "value": "正安县",
              "label": "正安县",
              "id": 520324
            }, {
              "value": "道真仡佬族苗族自治县",
              "label": "道真仡佬族苗族自治县",
              "id": 520325
            }, {
              "value": "务川仡佬族苗族自治县",
              "label": "务川仡佬族苗族自治县",
              "id": 520326
            }, {
              "value": "凤冈县",
              "label": "凤冈县",
              "id": 520327
            }, {
              "value": "湄潭县",
              "label": "湄潭县",
              "id": 520328
            }, {
              "value": "余庆县",
              "label": "余庆县",
              "id": 520329
            }, {
              "value": "习水县",
              "label": "习水县",
              "id": 520330
            }, {
              "value": "赤水市",
              "label": "赤水市",
              "id": 520381
            }, {
              "value": "仁怀市",
              "label": "仁怀市",
              "id": 520382
            }]
          }, {
            "value": "安顺市",
            "label": "安顺市",
            "id": 520400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 520401
            }, {
              "value": "西秀区",
              "label": "西秀区",
              "id": 520402
            }, {
              "value": "平坝区",
              "label": "平坝区",
              "id": 520403
            }, {
              "value": "普定县",
              "label": "普定县",
              "id": 520422
            }, {
              "value": "镇宁布依族苗族自治县",
              "label": "镇宁布依族苗族自治县",
              "id": 520423
            }, {
              "value": "关岭布依族苗族自治县",
              "label": "关岭布依族苗族自治县",
              "id": 520424
            }, {
              "value": "紫云苗族布依族自治县",
              "label": "紫云苗族布依族自治县",
              "id": 520425
            }]
          }, {
            "value": "毕节市",
            "label": "毕节市",
            "id": 520500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 520501
            }, {
              "value": "七星关区",
              "label": "七星关区",
              "id": 520502
            }, {
              "value": "大方县",
              "label": "大方县",
              "id": 520521
            }, {
              "value": "黔西县",
              "label": "黔西县",
              "id": 520522
            }, {
              "value": "金沙县",
              "label": "金沙县",
              "id": 520523
            }, {
              "value": "织金县",
              "label": "织金县",
              "id": 520524
            }, {
              "value": "纳雍县",
              "label": "纳雍县",
              "id": 520525
            }, {
              "value": "威宁彝族回族苗族自治县",
              "label": "威宁彝族回族苗族自治县",
              "id": 520526
            }, {
              "value": "赫章县",
              "label": "赫章县",
              "id": 520527
            }]
          }, {
            "value": "铜仁市",
            "label": "铜仁市",
            "id": 520600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 520601
            }, {
              "value": "碧江区",
              "label": "碧江区",
              "id": 520602
            }, {
              "value": "万山区",
              "label": "万山区",
              "id": 520603
            }, {
              "value": "江口县",
              "label": "江口县",
              "id": 520621
            }, {
              "value": "玉屏侗族自治县",
              "label": "玉屏侗族自治县",
              "id": 520622
            }, {
              "value": "石阡县",
              "label": "石阡县",
              "id": 520623
            }, {
              "value": "思南县",
              "label": "思南县",
              "id": 520624
            }, {
              "value": "印江土家族苗族自治县",
              "label": "印江土家族苗族自治县",
              "id": 520625
            }, {
              "value": "德江县",
              "label": "德江县",
              "id": 520626
            }, {
              "value": "沿河土家族自治县",
              "label": "沿河土家族自治县",
              "id": 520627
            }, {
              "value": "松桃苗族自治县",
              "label": "松桃苗族自治县",
              "id": 520628
            }]
          }, {
            "value": "黔西南布依族苗族自治州",
            "label": "黔西南布依族苗族自治州",
            "id": 522300,
            "children": [{
              "value": "兴义市",
              "label": "兴义市",
              "id": 522301
            }, {
              "value": "兴仁县",
              "label": "兴仁县",
              "id": 522322
            }, {
              "value": "普安县",
              "label": "普安县",
              "id": 522323
            }, {
              "value": "晴隆县",
              "label": "晴隆县",
              "id": 522324
            }, {
              "value": "贞丰县",
              "label": "贞丰县",
              "id": 522325
            }, {
              "value": "望谟县",
              "label": "望谟县",
              "id": 522326
            }, {
              "value": "册亨县",
              "label": "册亨县",
              "id": 522327
            }, {
              "value": "安龙县",
              "label": "安龙县",
              "id": 522328
            }]
          }, {
            "value": "黔东南苗族侗族自治州",
            "label": "黔东南苗族侗族自治州",
            "id": 522600,
            "children": [{
              "value": "凯里市",
              "label": "凯里市",
              "id": 522601
            }, {
              "value": "黄平县",
              "label": "黄平县",
              "id": 522622
            }, {
              "value": "施秉县",
              "label": "施秉县",
              "id": 522623
            }, {
              "value": "三穗县",
              "label": "三穗县",
              "id": 522624
            }, {
              "value": "镇远县",
              "label": "镇远县",
              "id": 522625
            }, {
              "value": "岑巩县",
              "label": "岑巩县",
              "id": 522626
            }, {
              "value": "天柱县",
              "label": "天柱县",
              "id": 522627
            }, {
              "value": "锦屏县",
              "label": "锦屏县",
              "id": 522628
            }, {
              "value": "剑河县",
              "label": "剑河县",
              "id": 522629
            }, {
              "value": "台江县",
              "label": "台江县",
              "id": 522630
            }, {
              "value": "黎平县",
              "label": "黎平县",
              "id": 522631
            }, {
              "value": "榕江县",
              "label": "榕江县",
              "id": 522632
            }, {
              "value": "从江县",
              "label": "从江县",
              "id": 522633
            }, {
              "value": "雷山县",
              "label": "雷山县",
              "id": 522634
            }, {
              "value": "麻江县",
              "label": "麻江县",
              "id": 522635
            }, {
              "value": "丹寨县",
              "label": "丹寨县",
              "id": 522636
            }]
          }, {
            "value": "黔南布依族苗族自治州",
            "label": "黔南布依族苗族自治州",
            "id": 522700,
            "children": [{
              "value": "都匀市",
              "label": "都匀市",
              "id": 522701
            }, {
              "value": "福泉市",
              "label": "福泉市",
              "id": 522702
            }, {
              "value": "荔波县",
              "label": "荔波县",
              "id": 522722
            }, {
              "value": "贵定县",
              "label": "贵定县",
              "id": 522723
            }, {
              "value": "瓮安县",
              "label": "瓮安县",
              "id": 522725
            }, {
              "value": "独山县",
              "label": "独山县",
              "id": 522726
            }, {
              "value": "平塘县",
              "label": "平塘县",
              "id": 522727
            }, {
              "value": "罗甸县",
              "label": "罗甸县",
              "id": 522728
            }, {
              "value": "长顺县",
              "label": "长顺县",
              "id": 522729
            }, {
              "value": "龙里县",
              "label": "龙里县",
              "id": 522730
            }, {
              "value": "惠水县",
              "label": "惠水县",
              "id": 522731
            }, {
              "value": "三都水族自治县",
              "label": "三都水族自治县",
              "id": 522732
            }]
          }]
        }, {
          "value": "云南省",
          "label": "云南省",
          "id": 530000,
          "children": [{
            "value": "昆明市",
            "label": "昆明市",
            "id": 530100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530101
            }, {
              "value": "五华区",
              "label": "五华区",
              "id": 530102
            }, {
              "value": "盘龙区",
              "label": "盘龙区",
              "id": 530103
            }, {
              "value": "官渡区",
              "label": "官渡区",
              "id": 530111
            }, {
              "value": "西山区",
              "label": "西山区",
              "id": 530112
            }, {
              "value": "东川区",
              "label": "东川区",
              "id": 530113
            }, {
              "value": "呈贡区",
              "label": "呈贡区",
              "id": 530114
            }, {
              "value": "晋宁县",
              "label": "晋宁县",
              "id": 530122
            }, {
              "value": "富民县",
              "label": "富民县",
              "id": 530124
            }, {
              "value": "宜良县",
              "label": "宜良县",
              "id": 530125
            }, {
              "value": "石林彝族自治县",
              "label": "石林彝族自治县",
              "id": 530126
            }, {
              "value": "嵩明县",
              "label": "嵩明县",
              "id": 530127
            }, {
              "value": "禄劝彝族苗族自治县",
              "label": "禄劝彝族苗族自治县",
              "id": 530128
            }, {
              "value": "寻甸回族彝族自治县",
              "label": "寻甸回族彝族自治县",
              "id": 530129
            }, {
              "value": "安宁市",
              "label": "安宁市",
              "id": 530181
            }]
          }, {
            "value": "曲靖市",
            "label": "曲靖市",
            "id": 530300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530301
            }, {
              "value": "麒麟区",
              "label": "麒麟区",
              "id": 530302
            }, {
              "value": "沾益区",
              "label": "沾益区",
              "id": 530303
            }, {
              "value": "马龙县",
              "label": "马龙县",
              "id": 530321
            }, {
              "value": "陆良县",
              "label": "陆良县",
              "id": 530322
            }, {
              "value": "师宗县",
              "label": "师宗县",
              "id": 530323
            }, {
              "value": "罗平县",
              "label": "罗平县",
              "id": 530324
            }, {
              "value": "富源县",
              "label": "富源县",
              "id": 530325
            }, {
              "value": "会泽县",
              "label": "会泽县",
              "id": 530326
            }, {
              "value": "宣威市",
              "label": "宣威市",
              "id": 530381
            }]
          }, {
            "value": "玉溪市",
            "label": "玉溪市",
            "id": 530400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530401
            }, {
              "value": "红塔区",
              "label": "红塔区",
              "id": 530402
            }, {
              "value": "江川区",
              "label": "江川区",
              "id": 530403
            }, {
              "value": "澄江县",
              "label": "澄江县",
              "id": 530422
            }, {
              "value": "通海县",
              "label": "通海县",
              "id": 530423
            }, {
              "value": "华宁县",
              "label": "华宁县",
              "id": 530424
            }, {
              "value": "易门县",
              "label": "易门县",
              "id": 530425
            }, {
              "value": "峨山彝族自治县",
              "label": "峨山彝族自治县",
              "id": 530426
            }, {
              "value": "新平彝族傣族自治县",
              "label": "新平彝族傣族自治县",
              "id": 530427
            }, {
              "value": "元江哈尼族彝族傣族自治县",
              "label": "元江哈尼族彝族傣族自治县",
              "id": 530428
            }]
          }, {
            "value": "保山市",
            "label": "保山市",
            "id": 530500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530501
            }, {
              "value": "隆阳区",
              "label": "隆阳区",
              "id": 530502
            }, {
              "value": "施甸县",
              "label": "施甸县",
              "id": 530521
            }, {
              "value": "龙陵县",
              "label": "龙陵县",
              "id": 530523
            }, {
              "value": "昌宁县",
              "label": "昌宁县",
              "id": 530524
            }, {
              "value": "腾冲市",
              "label": "腾冲市",
              "id": 530581
            }]
          }, {
            "value": "昭通市",
            "label": "昭通市",
            "id": 530600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530601
            }, {
              "value": "昭阳区",
              "label": "昭阳区",
              "id": 530602
            }, {
              "value": "鲁甸县",
              "label": "鲁甸县",
              "id": 530621
            }, {
              "value": "巧家县",
              "label": "巧家县",
              "id": 530622
            }, {
              "value": "盐津县",
              "label": "盐津县",
              "id": 530623
            }, {
              "value": "大关县",
              "label": "大关县",
              "id": 530624
            }, {
              "value": "永善县",
              "label": "永善县",
              "id": 530625
            }, {
              "value": "绥江县",
              "label": "绥江县",
              "id": 530626
            }, {
              "value": "镇雄县",
              "label": "镇雄县",
              "id": 530627
            }, {
              "value": "彝良县",
              "label": "彝良县",
              "id": 530628
            }, {
              "value": "威信县",
              "label": "威信县",
              "id": 530629
            }, {
              "value": "水富县",
              "label": "水富县",
              "id": 530630
            }]
          }, {
            "value": "丽江市",
            "label": "丽江市",
            "id": 530700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530701
            }, {
              "value": "古城区",
              "label": "古城区",
              "id": 530702
            }, {
              "value": "玉龙纳西族自治县",
              "label": "玉龙纳西族自治县",
              "id": 530721
            }, {
              "value": "永胜县",
              "label": "永胜县",
              "id": 530722
            }, {
              "value": "华坪县",
              "label": "华坪县",
              "id": 530723
            }, {
              "value": "宁蒗彝族自治县",
              "label": "宁蒗彝族自治县",
              "id": 530724
            }]
          }, {
            "value": "普洱市",
            "label": "普洱市",
            "id": 530800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530801
            }, {
              "value": "思茅区",
              "label": "思茅区",
              "id": 530802
            }, {
              "value": "宁洱哈尼族彝族自治县",
              "label": "宁洱哈尼族彝族自治县",
              "id": 530821
            }, {
              "value": "墨江哈尼族自治县",
              "label": "墨江哈尼族自治县",
              "id": 530822
            }, {
              "value": "景东彝族自治县",
              "label": "景东彝族自治县",
              "id": 530823
            }, {
              "value": "景谷傣族彝族自治县",
              "label": "景谷傣族彝族自治县",
              "id": 530824
            }, {
              "value": "镇沅彝族哈尼族拉祜族自治县",
              "label": "镇沅彝族哈尼族拉祜族自治县",
              "id": 530825
            }, {
              "value": "江城哈尼族彝族自治县",
              "label": "江城哈尼族彝族自治县",
              "id": 530826
            }, {
              "value": "孟连傣族拉祜族佤族自治县",
              "label": "孟连傣族拉祜族佤族自治县",
              "id": 530827
            }, {
              "value": "澜沧拉祜族自治县",
              "label": "澜沧拉祜族自治县",
              "id": 530828
            }, {
              "value": "西盟佤族自治县",
              "label": "西盟佤族自治县",
              "id": 530829
            }]
          }, {
            "value": "临沧市",
            "label": "临沧市",
            "id": 530900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 530901
            }, {
              "value": "临翔区",
              "label": "临翔区",
              "id": 530902
            }, {
              "value": "凤庆县",
              "label": "凤庆县",
              "id": 530921
            }, {
              "value": "云县",
              "label": "云县",
              "id": 530922
            }, {
              "value": "永德县",
              "label": "永德县",
              "id": 530923
            }, {
              "value": "镇康县",
              "label": "镇康县",
              "id": 530924
            }, {
              "value": "双江拉祜族佤族布朗族傣族自治县",
              "label": "双江拉祜族佤族布朗族傣族自治县",
              "id": 530925
            }, {
              "value": "耿马傣族佤族自治县",
              "label": "耿马傣族佤族自治县",
              "id": 530926
            }, {
              "value": "沧源佤族自治县",
              "label": "沧源佤族自治县",
              "id": 530927
            }]
          }, {
            "value": "楚雄彝族自治州",
            "label": "楚雄彝族自治州",
            "id": 532300,
            "children": [{
              "value": "楚雄市",
              "label": "楚雄市",
              "id": 532301
            }, {
              "value": "双柏县",
              "label": "双柏县",
              "id": 532322
            }, {
              "value": "牟定县",
              "label": "牟定县",
              "id": 532323
            }, {
              "value": "南华县",
              "label": "南华县",
              "id": 532324
            }, {
              "value": "姚安县",
              "label": "姚安县",
              "id": 532325
            }, {
              "value": "大姚县",
              "label": "大姚县",
              "id": 532326
            }, {
              "value": "永仁县",
              "label": "永仁县",
              "id": 532327
            }, {
              "value": "元谋县",
              "label": "元谋县",
              "id": 532328
            }, {
              "value": "武定县",
              "label": "武定县",
              "id": 532329
            }, {
              "value": "禄丰县",
              "label": "禄丰县",
              "id": 532331
            }]
          }, {
            "value": "红河哈尼族彝族自治州",
            "label": "红河哈尼族彝族自治州",
            "id": 532500,
            "children": [{
              "value": "个旧市",
              "label": "个旧市",
              "id": 532501
            }, {
              "value": "开远市",
              "label": "开远市",
              "id": 532502
            }, {
              "value": "蒙自市",
              "label": "蒙自市",
              "id": 532503
            }, {
              "value": "弥勒市",
              "label": "弥勒市",
              "id": 532504
            }, {
              "value": "屏边苗族自治县",
              "label": "屏边苗族自治县",
              "id": 532523
            }, {
              "value": "建水县",
              "label": "建水县",
              "id": 532524
            }, {
              "value": "石屏县",
              "label": "石屏县",
              "id": 532525
            }, {
              "value": "泸西县",
              "label": "泸西县",
              "id": 532527
            }, {
              "value": "元阳县",
              "label": "元阳县",
              "id": 532528
            }, {
              "value": "红河县",
              "label": "红河县",
              "id": 532529
            }, {
              "value": "金平苗族瑶族傣族自治县",
              "label": "金平苗族瑶族傣族自治县",
              "id": 532530
            }, {
              "value": "绿春县",
              "label": "绿春县",
              "id": 532531
            }, {
              "value": "河口瑶族自治县",
              "label": "河口瑶族自治县",
              "id": 532532
            }]
          }, {
            "value": "文山壮族苗族自治州",
            "label": "文山壮族苗族自治州",
            "id": 532600,
            "children": [{
              "value": "文山市",
              "label": "文山市",
              "id": 532601
            }, {
              "value": "砚山县",
              "label": "砚山县",
              "id": 532622
            }, {
              "value": "西畴县",
              "label": "西畴县",
              "id": 532623
            }, {
              "value": "麻栗坡县",
              "label": "麻栗坡县",
              "id": 532624
            }, {
              "value": "马关县",
              "label": "马关县",
              "id": 532625
            }, {
              "value": "丘北县",
              "label": "丘北县",
              "id": 532626
            }, {
              "value": "广南县",
              "label": "广南县",
              "id": 532627
            }, {
              "value": "富宁县",
              "label": "富宁县",
              "id": 532628
            }]
          }, {
            "value": "西双版纳傣族自治州",
            "label": "西双版纳傣族自治州",
            "id": 532800,
            "children": [{
              "value": "景洪市",
              "label": "景洪市",
              "id": 532801
            }, {
              "value": "勐海县",
              "label": "勐海县",
              "id": 532822
            }, {
              "value": "勐腊县",
              "label": "勐腊县",
              "id": 532823
            }]
          }, {
            "value": "大理白族自治州",
            "label": "大理白族自治州",
            "id": 532900,
            "children": [{
              "value": "大理市",
              "label": "大理市",
              "id": 532901
            }, {
              "value": "漾濞彝族自治县",
              "label": "漾濞彝族自治县",
              "id": 532922
            }, {
              "value": "祥云县",
              "label": "祥云县",
              "id": 532923
            }, {
              "value": "宾川县",
              "label": "宾川县",
              "id": 532924
            }, {
              "value": "弥渡县",
              "label": "弥渡县",
              "id": 532925
            }, {
              "value": "南涧彝族自治县",
              "label": "南涧彝族自治县",
              "id": 532926
            }, {
              "value": "巍山彝族回族自治县",
              "label": "巍山彝族回族自治县",
              "id": 532927
            }, {
              "value": "永平县",
              "label": "永平县",
              "id": 532928
            }, {
              "value": "云龙县",
              "label": "云龙县",
              "id": 532929
            }, {
              "value": "洱源县",
              "label": "洱源县",
              "id": 532930
            }, {
              "value": "剑川县",
              "label": "剑川县",
              "id": 532931
            }, {
              "value": "鹤庆县",
              "label": "鹤庆县",
              "id": 532932
            }]
          }, {
            "value": "德宏傣族景颇族自治州",
            "label": "德宏傣族景颇族自治州",
            "id": 533100,
            "children": [{
              "value": "瑞丽市",
              "label": "瑞丽市",
              "id": 533102
            }, {
              "value": "芒市",
              "label": "芒市",
              "id": 533103
            }, {
              "value": "梁河县",
              "label": "梁河县",
              "id": 533122
            }, {
              "value": "盈江县",
              "label": "盈江县",
              "id": 533123
            }, {
              "value": "陇川县",
              "label": "陇川县",
              "id": 533124
            }]
          }, {
            "value": "怒江傈僳族自治州",
            "label": "怒江傈僳族自治州",
            "id": 533300,
            "children": [{
              "value": "泸水市",
              "label": "泸水市",
              "id": 533301
            }, {
              "value": "福贡县",
              "label": "福贡县",
              "id": 533323
            }, {
              "value": "贡山独龙族怒族自治县",
              "label": "贡山独龙族怒族自治县",
              "id": 533324
            }, {
              "value": "兰坪白族普米族自治县",
              "label": "兰坪白族普米族自治县",
              "id": 533325
            }]
          }, {
            "value": "迪庆藏族自治州",
            "label": "迪庆藏族自治州",
            "id": 533400,
            "children": [{
              "value": "香格里拉市",
              "label": "香格里拉市",
              "id": 533401
            }, {
              "value": "德钦县",
              "label": "德钦县",
              "id": 533422
            }, {
              "value": "维西傈僳族自治县",
              "label": "维西傈僳族自治县",
              "id": 533423
            }]
          }]
        }, {
          "value": "西藏自治区",
          "label": "西藏自治区",
          "id": 540000,
          "children": [{
            "value": "拉萨市",
            "label": "拉萨市",
            "id": 540100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 540101
            }, {
              "value": "城关区",
              "label": "城关区",
              "id": 540102
            }, {
              "value": "堆龙德庆区",
              "label": "堆龙德庆区",
              "id": 540103
            }, {
              "value": "林周县",
              "label": "林周县",
              "id": 540121
            }, {
              "value": "当雄县",
              "label": "当雄县",
              "id": 540122
            }, {
              "value": "尼木县",
              "label": "尼木县",
              "id": 540123
            }, {
              "value": "曲水县",
              "label": "曲水县",
              "id": 540124
            }, {
              "value": "达孜县",
              "label": "达孜县",
              "id": 540126
            }, {
              "value": "墨竹工卡县",
              "label": "墨竹工卡县",
              "id": 540127
            }]
          }, {
            "value": "日喀则市",
            "label": "日喀则市",
            "id": 540200,
            "children": [{
              "value": "桑珠孜区",
              "label": "桑珠孜区",
              "id": 540202
            }, {
              "value": "南木林县",
              "label": "南木林县",
              "id": 540221
            }, {
              "value": "江孜县",
              "label": "江孜县",
              "id": 540222
            }, {
              "value": "定日县",
              "label": "定日县",
              "id": 540223
            }, {
              "value": "萨迦县",
              "label": "萨迦县",
              "id": 540224
            }, {
              "value": "拉孜县",
              "label": "拉孜县",
              "id": 540225
            }, {
              "value": "昂仁县",
              "label": "昂仁县",
              "id": 540226
            }, {
              "value": "谢通门县",
              "label": "谢通门县",
              "id": 540227
            }, {
              "value": "白朗县",
              "label": "白朗县",
              "id": 540228
            }, {
              "value": "仁布县",
              "label": "仁布县",
              "id": 540229
            }, {
              "value": "康马县",
              "label": "康马县",
              "id": 540230
            }, {
              "value": "定结县",
              "label": "定结县",
              "id": 540231
            }, {
              "value": "仲巴县",
              "label": "仲巴县",
              "id": 540232
            }, {
              "value": "亚东县",
              "label": "亚东县",
              "id": 540233
            }, {
              "value": "吉隆县",
              "label": "吉隆县",
              "id": 540234
            }, {
              "value": "聂拉木县",
              "label": "聂拉木县",
              "id": 540235
            }, {
              "value": "萨嘎县",
              "label": "萨嘎县",
              "id": 540236
            }, {
              "value": "岗巴县",
              "label": "岗巴县",
              "id": 540237
            }]
          }, {
            "value": "昌都市",
            "label": "昌都市",
            "id": 540300,
            "children": [{
              "value": "卡若区",
              "label": "卡若区",
              "id": 540302
            }, {
              "value": "江达县",
              "label": "江达县",
              "id": 540321
            }, {
              "value": "贡觉县",
              "label": "贡觉县",
              "id": 540322
            }, {
              "value": "类乌齐县",
              "label": "类乌齐县",
              "id": 540323
            }, {
              "value": "丁青县",
              "label": "丁青县",
              "id": 540324
            }, {
              "value": "察雅县",
              "label": "察雅县",
              "id": 540325
            }, {
              "value": "八宿县",
              "label": "八宿县",
              "id": 540326
            }, {
              "value": "左贡县",
              "label": "左贡县",
              "id": 540327
            }, {
              "value": "芒康县",
              "label": "芒康县",
              "id": 540328
            }, {
              "value": "洛隆县",
              "label": "洛隆县",
              "id": 540329
            }, {
              "value": "边坝县",
              "label": "边坝县",
              "id": 540330
            }]
          }, {
            "value": "林芝市",
            "label": "林芝市",
            "id": 540400,
            "children": [{
              "value": "巴宜区",
              "label": "巴宜区",
              "id": 540402
            }, {
              "value": "工布江达县",
              "label": "工布江达县",
              "id": 540421
            }, {
              "value": "米林县",
              "label": "米林县",
              "id": 540422
            }, {
              "value": "墨脱县",
              "label": "墨脱县",
              "id": 540423
            }, {
              "value": "波密县",
              "label": "波密县",
              "id": 540424
            }, {
              "value": "察隅县",
              "label": "察隅县",
              "id": 540425
            }, {
              "value": "朗县",
              "label": "朗县",
              "id": 540426
            }]
          }, {
            "value": "山南市",
            "label": "山南市",
            "id": 540500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 540501
            }, {
              "value": "乃东区",
              "label": "乃东区",
              "id": 540502
            }, {
              "value": "扎囊县",
              "label": "扎囊县",
              "id": 540521
            }, {
              "value": "贡嘎县",
              "label": "贡嘎县",
              "id": 540522
            }, {
              "value": "桑日县",
              "label": "桑日县",
              "id": 540523
            }, {
              "value": "琼结县",
              "label": "琼结县",
              "id": 540524
            }, {
              "value": "曲松县",
              "label": "曲松县",
              "id": 540525
            }, {
              "value": "措美县",
              "label": "措美县",
              "id": 540526
            }, {
              "value": "洛扎县",
              "label": "洛扎县",
              "id": 540527
            }, {
              "value": "加查县",
              "label": "加查县",
              "id": 540528
            }, {
              "value": "隆子县",
              "label": "隆子县",
              "id": 540529
            }, {
              "value": "错那县",
              "label": "错那县",
              "id": 540530
            }, {
              "value": "浪卡子县",
              "label": "浪卡子县",
              "id": 540531
            }]
          }, {
            "value": "那曲地区",
            "label": "那曲地区",
            "id": 542400,
            "children": [{
              "value": "那曲县",
              "label": "那曲县",
              "id": 542421
            }, {
              "value": "嘉黎县",
              "label": "嘉黎县",
              "id": 542422
            }, {
              "value": "比如县",
              "label": "比如县",
              "id": 542423
            }, {
              "value": "聂荣县",
              "label": "聂荣县",
              "id": 542424
            }, {
              "value": "安多县",
              "label": "安多县",
              "id": 542425
            }, {
              "value": "申扎县",
              "label": "申扎县",
              "id": 542426
            }, {
              "value": "索县",
              "label": "索县",
              "id": 542427
            }, {
              "value": "班戈县",
              "label": "班戈县",
              "id": 542428
            }, {
              "value": "巴青县",
              "label": "巴青县",
              "id": 542429
            }, {
              "value": "尼玛县",
              "label": "尼玛县",
              "id": 542430
            }, {
              "value": "双湖县",
              "label": "双湖县",
              "id": 542431
            }]
          }, {
            "value": "阿里地区",
            "label": "阿里地区",
            "id": 542500,
            "children": [{
              "value": "普兰县",
              "label": "普兰县",
              "id": 542521
            }, {
              "value": "札达县",
              "label": "札达县",
              "id": 542522
            }, {
              "value": "噶尔县",
              "label": "噶尔县",
              "id": 542523
            }, {
              "value": "日土县",
              "label": "日土县",
              "id": 542524
            }, {
              "value": "革吉县",
              "label": "革吉县",
              "id": 542525
            }, {
              "value": "改则县",
              "label": "改则县",
              "id": 542526
            }, {
              "value": "措勤县",
              "label": "措勤县",
              "id": 542527
            }]
          }]
        }, {
          "value": "陕西省",
          "label": "陕西省",
          "id": 610000,
          "children": [{
            "value": "西安市",
            "label": "西安市",
            "id": 610100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610101
            }, {
              "value": "新城区",
              "label": "新城区",
              "id": 610102
            }, {
              "value": "碑林区",
              "label": "碑林区",
              "id": 610103
            }, {
              "value": "莲湖区",
              "label": "莲湖区",
              "id": 610104
            }, {
              "value": "灞桥区",
              "label": "灞桥区",
              "id": 610111
            }, {
              "value": "未央区",
              "label": "未央区",
              "id": 610112
            }, {
              "value": "雁塔区",
              "label": "雁塔区",
              "id": 610113
            }, {
              "value": "阎良区",
              "label": "阎良区",
              "id": 610114
            }, {
              "value": "临潼区",
              "label": "临潼区",
              "id": 610115
            }, {
              "value": "长安区",
              "label": "长安区",
              "id": 610116
            }, {
              "value": "高陵区",
              "label": "高陵区",
              "id": 610117
            }, {
              "value": "蓝田县",
              "label": "蓝田县",
              "id": 610122
            }, {
              "value": "周至县",
              "label": "周至县",
              "id": 610124
            }, {
              "value": "户县",
              "label": "户县",
              "id": 610125
            }]
          }, {
            "value": "铜川市",
            "label": "铜川市",
            "id": 610200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610201
            }, {
              "value": "王益区",
              "label": "王益区",
              "id": 610202
            }, {
              "value": "印台区",
              "label": "印台区",
              "id": 610203
            }, {
              "value": "耀州区",
              "label": "耀州区",
              "id": 610204
            }, {
              "value": "宜君县",
              "label": "宜君县",
              "id": 610222
            }]
          }, {
            "value": "宝鸡市",
            "label": "宝鸡市",
            "id": 610300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610301
            }, {
              "value": "渭滨区",
              "label": "渭滨区",
              "id": 610302
            }, {
              "value": "金台区",
              "label": "金台区",
              "id": 610303
            }, {
              "value": "陈仓区",
              "label": "陈仓区",
              "id": 610304
            }, {
              "value": "凤翔县",
              "label": "凤翔县",
              "id": 610322
            }, {
              "value": "岐山县",
              "label": "岐山县",
              "id": 610323
            }, {
              "value": "扶风县",
              "label": "扶风县",
              "id": 610324
            }, {
              "value": "眉县",
              "label": "眉县",
              "id": 610326
            }, {
              "value": "陇县",
              "label": "陇县",
              "id": 610327
            }, {
              "value": "千阳县",
              "label": "千阳县",
              "id": 610328
            }, {
              "value": "麟游县",
              "label": "麟游县",
              "id": 610329
            }, {
              "value": "凤县",
              "label": "凤县",
              "id": 610330
            }, {
              "value": "太白县",
              "label": "太白县",
              "id": 610331
            }]
          }, {
            "value": "咸阳市",
            "label": "咸阳市",
            "id": 610400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610401
            }, {
              "value": "秦都区",
              "label": "秦都区",
              "id": 610402
            }, {
              "value": "杨陵区",
              "label": "杨陵区",
              "id": 610403
            }, {
              "value": "渭城区",
              "label": "渭城区",
              "id": 610404
            }, {
              "value": "三原县",
              "label": "三原县",
              "id": 610422
            }, {
              "value": "泾阳县",
              "label": "泾阳县",
              "id": 610423
            }, {
              "value": "乾县",
              "label": "乾县",
              "id": 610424
            }, {
              "value": "礼泉县",
              "label": "礼泉县",
              "id": 610425
            }, {
              "value": "永寿县",
              "label": "永寿县",
              "id": 610426
            }, {
              "value": "彬县",
              "label": "彬县",
              "id": 610427
            }, {
              "value": "长武县",
              "label": "长武县",
              "id": 610428
            }, {
              "value": "旬邑县",
              "label": "旬邑县",
              "id": 610429
            }, {
              "value": "淳化县",
              "label": "淳化县",
              "id": 610430
            }, {
              "value": "武功县",
              "label": "武功县",
              "id": 610431
            }, {
              "value": "兴平市",
              "label": "兴平市",
              "id": 610481
            }]
          }, {
            "value": "渭南市",
            "label": "渭南市",
            "id": 610500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610501
            }, {
              "value": "临渭区",
              "label": "临渭区",
              "id": 610502
            }, {
              "value": "华州区",
              "label": "华州区",
              "id": 610503
            }, {
              "value": "潼关县",
              "label": "潼关县",
              "id": 610522
            }, {
              "value": "大荔县",
              "label": "大荔县",
              "id": 610523
            }, {
              "value": "合阳县",
              "label": "合阳县",
              "id": 610524
            }, {
              "value": "澄城县",
              "label": "澄城县",
              "id": 610525
            }, {
              "value": "蒲城县",
              "label": "蒲城县",
              "id": 610526
            }, {
              "value": "白水县",
              "label": "白水县",
              "id": 610527
            }, {
              "value": "富平县",
              "label": "富平县",
              "id": 610528
            }, {
              "value": "韩城市",
              "label": "韩城市",
              "id": 610581
            }, {
              "value": "华阴市",
              "label": "华阴市",
              "id": 610582
            }]
          }, {
            "value": "延安市",
            "label": "延安市",
            "id": 610600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610601
            }, {
              "value": "宝塔区",
              "label": "宝塔区",
              "id": 610602
            }, {
              "value": "安塞区",
              "label": "安塞区",
              "id": 610603
            }, {
              "value": "延长县",
              "label": "延长县",
              "id": 610621
            }, {
              "value": "延川县",
              "label": "延川县",
              "id": 610622
            }, {
              "value": "子长县",
              "label": "子长县",
              "id": 610623
            }, {
              "value": "志丹县",
              "label": "志丹县",
              "id": 610625
            }, {
              "value": "吴起县",
              "label": "吴起县",
              "id": 610626
            }, {
              "value": "甘泉县",
              "label": "甘泉县",
              "id": 610627
            }, {
              "value": "富县",
              "label": "富县",
              "id": 610628
            }, {
              "value": "洛川县",
              "label": "洛川县",
              "id": 610629
            }, {
              "value": "宜川县",
              "label": "宜川县",
              "id": 610630
            }, {
              "value": "黄龙县",
              "label": "黄龙县",
              "id": 610631
            }, {
              "value": "黄陵县",
              "label": "黄陵县",
              "id": 610632
            }]
          }, {
            "value": "汉中市",
            "label": "汉中市",
            "id": 610700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610701
            }, {
              "value": "汉台区",
              "label": "汉台区",
              "id": 610702
            }, {
              "value": "南郑县",
              "label": "南郑县",
              "id": 610721
            }, {
              "value": "城固县",
              "label": "城固县",
              "id": 610722
            }, {
              "value": "洋县",
              "label": "洋县",
              "id": 610723
            }, {
              "value": "西乡县",
              "label": "西乡县",
              "id": 610724
            }, {
              "value": "勉县",
              "label": "勉县",
              "id": 610725
            }, {
              "value": "宁强县",
              "label": "宁强县",
              "id": 610726
            }, {
              "value": "略阳县",
              "label": "略阳县",
              "id": 610727
            }, {
              "value": "镇巴县",
              "label": "镇巴县",
              "id": 610728
            }, {
              "value": "留坝县",
              "label": "留坝县",
              "id": 610729
            }, {
              "value": "佛坪县",
              "label": "佛坪县",
              "id": 610730
            }]
          }, {
            "value": "榆林市",
            "label": "榆林市",
            "id": 610800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610801
            }, {
              "value": "榆阳区",
              "label": "榆阳区",
              "id": 610802
            }, {
              "value": "横山区",
              "label": "横山区",
              "id": 610803
            }, {
              "value": "神木县",
              "label": "神木县",
              "id": 610821
            }, {
              "value": "府谷县",
              "label": "府谷县",
              "id": 610822
            }, {
              "value": "靖边县",
              "label": "靖边县",
              "id": 610824
            }, {
              "value": "定边县",
              "label": "定边县",
              "id": 610825
            }, {
              "value": "绥德县",
              "label": "绥德县",
              "id": 610826
            }, {
              "value": "米脂县",
              "label": "米脂县",
              "id": 610827
            }, {
              "value": "佳县",
              "label": "佳县",
              "id": 610828
            }, {
              "value": "吴堡县",
              "label": "吴堡县",
              "id": 610829
            }, {
              "value": "清涧县",
              "label": "清涧县",
              "id": 610830
            }, {
              "value": "子洲县",
              "label": "子洲县",
              "id": 610831
            }]
          }, {
            "value": "安康市",
            "label": "安康市",
            "id": 610900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 610901
            }, {
              "value": "汉滨区",
              "label": "汉滨区",
              "id": 610902
            }, {
              "value": "汉阴县",
              "label": "汉阴县",
              "id": 610921
            }, {
              "value": "石泉县",
              "label": "石泉县",
              "id": 610922
            }, {
              "value": "宁陕县",
              "label": "宁陕县",
              "id": 610923
            }, {
              "value": "紫阳县",
              "label": "紫阳县",
              "id": 610924
            }, {
              "value": "岚皋县",
              "label": "岚皋县",
              "id": 610925
            }, {
              "value": "平利县",
              "label": "平利县",
              "id": 610926
            }, {
              "value": "镇坪县",
              "label": "镇坪县",
              "id": 610927
            }, {
              "value": "旬阳县",
              "label": "旬阳县",
              "id": 610928
            }, {
              "value": "白河县",
              "label": "白河县",
              "id": 610929
            }]
          }, {
            "value": "商洛市",
            "label": "商洛市",
            "id": 611000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 611001
            }, {
              "value": "商州区",
              "label": "商州区",
              "id": 611002
            }, {
              "value": "洛南县",
              "label": "洛南县",
              "id": 611021
            }, {
              "value": "丹凤县",
              "label": "丹凤县",
              "id": 611022
            }, {
              "value": "商南县",
              "label": "商南县",
              "id": 611023
            }, {
              "value": "山阳县",
              "label": "山阳县",
              "id": 611024
            }, {
              "value": "镇安县",
              "label": "镇安县",
              "id": 611025
            }, {
              "value": "柞水县",
              "label": "柞水县",
              "id": 611026
            }]
          }]
        }, {
          "value": "甘肃省",
          "label": "甘肃省",
          "id": 620000,
          "children": [{
            "value": "兰州市",
            "label": "兰州市",
            "id": 620100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620101
            }, {
              "value": "城关区",
              "label": "城关区",
              "id": 620102
            }, {
              "value": "七里河区",
              "label": "七里河区",
              "id": 620103
            }, {
              "value": "西固区",
              "label": "西固区",
              "id": 620104
            }, {
              "value": "安宁区",
              "label": "安宁区",
              "id": 620105
            }, {
              "value": "红古区",
              "label": "红古区",
              "id": 620111
            }, {
              "value": "永登县",
              "label": "永登县",
              "id": 620121
            }, {
              "value": "皋兰县",
              "label": "皋兰县",
              "id": 620122
            }, {
              "value": "榆中县",
              "label": "榆中县",
              "id": 620123
            }]
          }, {
            "value": "嘉峪关市",
            "label": "嘉峪关市",
            "id": 620200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620201
            }]
          }, {
            "value": "金昌市",
            "label": "金昌市",
            "id": 620300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620301
            }, {
              "value": "金川区",
              "label": "金川区",
              "id": 620302
            }, {
              "value": "永昌县",
              "label": "永昌县",
              "id": 620321
            }]
          }, {
            "value": "白银市",
            "label": "白银市",
            "id": 620400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620401
            }, {
              "value": "白银区",
              "label": "白银区",
              "id": 620402
            }, {
              "value": "平川区",
              "label": "平川区",
              "id": 620403
            }, {
              "value": "靖远县",
              "label": "靖远县",
              "id": 620421
            }, {
              "value": "会宁县",
              "label": "会宁县",
              "id": 620422
            }, {
              "value": "景泰县",
              "label": "景泰县",
              "id": 620423
            }]
          }, {
            "value": "天水市",
            "label": "天水市",
            "id": 620500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620501
            }, {
              "value": "秦州区",
              "label": "秦州区",
              "id": 620502
            }, {
              "value": "麦积区",
              "label": "麦积区",
              "id": 620503
            }, {
              "value": "清水县",
              "label": "清水县",
              "id": 620521
            }, {
              "value": "秦安县",
              "label": "秦安县",
              "id": 620522
            }, {
              "value": "甘谷县",
              "label": "甘谷县",
              "id": 620523
            }, {
              "value": "武山县",
              "label": "武山县",
              "id": 620524
            }, {
              "value": "张家川回族自治县",
              "label": "张家川回族自治县",
              "id": 620525
            }]
          }, {
            "value": "武威市",
            "label": "武威市",
            "id": 620600,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620601
            }, {
              "value": "凉州区",
              "label": "凉州区",
              "id": 620602
            }, {
              "value": "民勤县",
              "label": "民勤县",
              "id": 620621
            }, {
              "value": "古浪县",
              "label": "古浪县",
              "id": 620622
            }, {
              "value": "天祝藏族自治县",
              "label": "天祝藏族自治县",
              "id": 620623
            }]
          }, {
            "value": "张掖市",
            "label": "张掖市",
            "id": 620700,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620701
            }, {
              "value": "甘州区",
              "label": "甘州区",
              "id": 620702
            }, {
              "value": "肃南裕固族自治县",
              "label": "肃南裕固族自治县",
              "id": 620721
            }, {
              "value": "民乐县",
              "label": "民乐县",
              "id": 620722
            }, {
              "value": "临泽县",
              "label": "临泽县",
              "id": 620723
            }, {
              "value": "高台县",
              "label": "高台县",
              "id": 620724
            }, {
              "value": "山丹县",
              "label": "山丹县",
              "id": 620725
            }]
          }, {
            "value": "平凉市",
            "label": "平凉市",
            "id": 620800,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620801
            }, {
              "value": "崆峒区",
              "label": "崆峒区",
              "id": 620802
            }, {
              "value": "泾川县",
              "label": "泾川县",
              "id": 620821
            }, {
              "value": "灵台县",
              "label": "灵台县",
              "id": 620822
            }, {
              "value": "崇信县",
              "label": "崇信县",
              "id": 620823
            }, {
              "value": "华亭县",
              "label": "华亭县",
              "id": 620824
            }, {
              "value": "庄浪县",
              "label": "庄浪县",
              "id": 620825
            }, {
              "value": "静宁县",
              "label": "静宁县",
              "id": 620826
            }]
          }, {
            "value": "酒泉市",
            "label": "酒泉市",
            "id": 620900,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 620901
            }, {
              "value": "肃州区",
              "label": "肃州区",
              "id": 620902
            }, {
              "value": "金塔县",
              "label": "金塔县",
              "id": 620921
            }, {
              "value": "瓜州县",
              "label": "瓜州县",
              "id": 620922
            }, {
              "value": "肃北蒙古族自治县",
              "label": "肃北蒙古族自治县",
              "id": 620923
            }, {
              "value": "阿克塞哈萨克族自治县",
              "label": "阿克塞哈萨克族自治县",
              "id": 620924
            }, {
              "value": "玉门市",
              "label": "玉门市",
              "id": 620981
            }, {
              "value": "敦煌市",
              "label": "敦煌市",
              "id": 620982
            }]
          }, {
            "value": "庆阳市",
            "label": "庆阳市",
            "id": 621000,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 621001
            }, {
              "value": "西峰区",
              "label": "西峰区",
              "id": 621002
            }, {
              "value": "庆城县",
              "label": "庆城县",
              "id": 621021
            }, {
              "value": "环县",
              "label": "环县",
              "id": 621022
            }, {
              "value": "华池县",
              "label": "华池县",
              "id": 621023
            }, {
              "value": "合水县",
              "label": "合水县",
              "id": 621024
            }, {
              "value": "正宁县",
              "label": "正宁县",
              "id": 621025
            }, {
              "value": "宁县",
              "label": "宁县",
              "id": 621026
            }, {
              "value": "镇原县",
              "label": "镇原县",
              "id": 621027
            }]
          }, {
            "value": "定西市",
            "label": "定西市",
            "id": 621100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 621101
            }, {
              "value": "安定区",
              "label": "安定区",
              "id": 621102
            }, {
              "value": "通渭县",
              "label": "通渭县",
              "id": 621121
            }, {
              "value": "陇西县",
              "label": "陇西县",
              "id": 621122
            }, {
              "value": "渭源县",
              "label": "渭源县",
              "id": 621123
            }, {
              "value": "临洮县",
              "label": "临洮县",
              "id": 621124
            }, {
              "value": "漳县",
              "label": "漳县",
              "id": 621125
            }, {
              "value": "岷县",
              "label": "岷县",
              "id": 621126
            }]
          }, {
            "value": "陇南市",
            "label": "陇南市",
            "id": 621200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 621201
            }, {
              "value": "武都区",
              "label": "武都区",
              "id": 621202
            }, {
              "value": "成县",
              "label": "成县",
              "id": 621221
            }, {
              "value": "文县",
              "label": "文县",
              "id": 621222
            }, {
              "value": "宕昌县",
              "label": "宕昌县",
              "id": 621223
            }, {
              "value": "康县",
              "label": "康县",
              "id": 621224
            }, {
              "value": "西和县",
              "label": "西和县",
              "id": 621225
            }, {
              "value": "礼县",
              "label": "礼县",
              "id": 621226
            }, {
              "value": "徽县",
              "label": "徽县",
              "id": 621227
            }, {
              "value": "两当县",
              "label": "两当县",
              "id": 621228
            }]
          }, {
            "value": "临夏回族自治州",
            "label": "临夏回族自治州",
            "id": 622900,
            "children": [{
              "value": "临夏市",
              "label": "临夏市",
              "id": 622901
            }, {
              "value": "临夏县",
              "label": "临夏县",
              "id": 622921
            }, {
              "value": "康乐县",
              "label": "康乐县",
              "id": 622922
            }, {
              "value": "永靖县",
              "label": "永靖县",
              "id": 622923
            }, {
              "value": "广河县",
              "label": "广河县",
              "id": 622924
            }, {
              "value": "和政县",
              "label": "和政县",
              "id": 622925
            }, {
              "value": "东乡族自治县",
              "label": "东乡族自治县",
              "id": 622926
            }, {
              "value": "积石山保安族东乡族撒拉族自治县",
              "label": "积石山保安族东乡族撒拉族自治县",
              "id": 622927
            }]
          }, {
            "value": "甘南藏族自治州",
            "label": "甘南藏族自治州",
            "id": 623000,
            "children": [{
              "value": "合作市",
              "label": "合作市",
              "id": 623001
            }, {
              "value": "临潭县",
              "label": "临潭县",
              "id": 623021
            }, {
              "value": "卓尼县",
              "label": "卓尼县",
              "id": 623022
            }, {
              "value": "舟曲县",
              "label": "舟曲县",
              "id": 623023
            }, {
              "value": "迭部县",
              "label": "迭部县",
              "id": 623024
            }, {
              "value": "玛曲县",
              "label": "玛曲县",
              "id": 623025
            }, {
              "value": "碌曲县",
              "label": "碌曲县",
              "id": 623026
            }, {
              "value": "夏河县",
              "label": "夏河县",
              "id": 623027
            }]
          }]
        }, {
          "value": "青海省",
          "label": "青海省",
          "id": 630000,
          "children": [{
            "value": "西宁市",
            "label": "西宁市",
            "id": 630100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 630101
            }, {
              "value": "城东区",
              "label": "城东区",
              "id": 630102
            }, {
              "value": "城中区",
              "label": "城中区",
              "id": 630103
            }, {
              "value": "城西区",
              "label": "城西区",
              "id": 630104
            }, {
              "value": "城北区",
              "label": "城北区",
              "id": 630105
            }, {
              "value": "大通回族土族自治县",
              "label": "大通回族土族自治县",
              "id": 630121
            }, {
              "value": "湟中县",
              "label": "湟中县",
              "id": 630122
            }, {
              "value": "湟源县",
              "label": "湟源县",
              "id": 630123
            }]
          }, {
            "value": "海东市",
            "label": "海东市",
            "id": 630200,
            "children": [{
              "value": "乐都区",
              "label": "乐都区",
              "id": 630202
            }, {
              "value": "平安区",
              "label": "平安区",
              "id": 630203
            }, {
              "value": "民和回族土族自治县",
              "label": "民和回族土族自治县",
              "id": 630222
            }, {
              "value": "互助土族自治县",
              "label": "互助土族自治县",
              "id": 630223
            }, {
              "value": "化隆回族自治县",
              "label": "化隆回族自治县",
              "id": 630224
            }, {
              "value": "循化撒拉族自治县",
              "label": "循化撒拉族自治县",
              "id": 630225
            }]
          }, {
            "value": "海北藏族自治州",
            "label": "海北藏族自治州",
            "id": 632200,
            "children": [{
              "value": "门源回族自治县",
              "label": "门源回族自治县",
              "id": 632221
            }, {
              "value": "祁连县",
              "label": "祁连县",
              "id": 632222
            }, {
              "value": "海晏县",
              "label": "海晏县",
              "id": 632223
            }, {
              "value": "刚察县",
              "label": "刚察县",
              "id": 632224
            }]
          }, {
            "value": "黄南藏族自治州",
            "label": "黄南藏族自治州",
            "id": 632300,
            "children": [{
              "value": "同仁县",
              "label": "同仁县",
              "id": 632321
            }, {
              "value": "尖扎县",
              "label": "尖扎县",
              "id": 632322
            }, {
              "value": "泽库县",
              "label": "泽库县",
              "id": 632323
            }, {
              "value": "河南蒙古族自治县",
              "label": "河南蒙古族自治县",
              "id": 632324
            }]
          }, {
            "value": "海南藏族自治州",
            "label": "海南藏族自治州",
            "id": 632500,
            "children": [{
              "value": "共和县",
              "label": "共和县",
              "id": 632521
            }, {
              "value": "同德县",
              "label": "同德县",
              "id": 632522
            }, {
              "value": "贵德县",
              "label": "贵德县",
              "id": 632523
            }, {
              "value": "兴海县",
              "label": "兴海县",
              "id": 632524
            }, {
              "value": "贵南县",
              "label": "贵南县",
              "id": 632525
            }]
          }, {
            "value": "果洛藏族自治州",
            "label": "果洛藏族自治州",
            "id": 632600,
            "children": [{
              "value": "玛沁县",
              "label": "玛沁县",
              "id": 632621
            }, {
              "value": "班玛县",
              "label": "班玛县",
              "id": 632622
            }, {
              "value": "甘德县",
              "label": "甘德县",
              "id": 632623
            }, {
              "value": "达日县",
              "label": "达日县",
              "id": 632624
            }, {
              "value": "久治县",
              "label": "久治县",
              "id": 632625
            }, {
              "value": "玛多县",
              "label": "玛多县",
              "id": 632626
            }]
          }, {
            "value": "玉树藏族自治州",
            "label": "玉树藏族自治州",
            "id": 632700,
            "children": [{
              "value": "玉树市",
              "label": "玉树市",
              "id": 632701
            }, {
              "value": "杂多县",
              "label": "杂多县",
              "id": 632722
            }, {
              "value": "称多县",
              "label": "称多县",
              "id": 632723
            }, {
              "value": "治多县",
              "label": "治多县",
              "id": 632724
            }, {
              "value": "囊谦县",
              "label": "囊谦县",
              "id": 632725
            }, {
              "value": "曲麻莱县",
              "label": "曲麻莱县",
              "id": 632726
            }]
          }, {
            "value": "海西蒙古族藏族自治州",
            "label": "海西蒙古族藏族自治州",
            "id": 632800,
            "children": [{
              "value": "格尔木市",
              "label": "格尔木市",
              "id": 632801
            }, {
              "value": "德令哈市",
              "label": "德令哈市",
              "id": 632802
            }, {
              "value": "乌兰县",
              "label": "乌兰县",
              "id": 632821
            }, {
              "value": "都兰县",
              "label": "都兰县",
              "id": 632822
            }, {
              "value": "天峻县",
              "label": "天峻县",
              "id": 632823
            }]
          }]
        }, {
          "value": "宁夏回族自治区",
          "label": "宁夏回族自治区",
          "id": 640000,
          "children": [{
            "value": "银川市",
            "label": "银川市",
            "id": 640100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 640101
            }, {
              "value": "兴庆区",
              "label": "兴庆区",
              "id": 640104
            }, {
              "value": "西夏区",
              "label": "西夏区",
              "id": 640105
            }, {
              "value": "金凤区",
              "label": "金凤区",
              "id": 640106
            }, {
              "value": "永宁县",
              "label": "永宁县",
              "id": 640121
            }, {
              "value": "贺兰县",
              "label": "贺兰县",
              "id": 640122
            }, {
              "value": "灵武市",
              "label": "灵武市",
              "id": 640181
            }]
          }, {
            "value": "石嘴山市",
            "label": "石嘴山市",
            "id": 640200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 640201
            }, {
              "value": "大武口区",
              "label": "大武口区",
              "id": 640202
            }, {
              "value": "惠农区",
              "label": "惠农区",
              "id": 640205
            }, {
              "value": "平罗县",
              "label": "平罗县",
              "id": 640221
            }]
          }, {
            "value": "吴忠市",
            "label": "吴忠市",
            "id": 640300,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 640301
            }, {
              "value": "利通区",
              "label": "利通区",
              "id": 640302
            }, {
              "value": "红寺堡区",
              "label": "红寺堡区",
              "id": 640303
            }, {
              "value": "盐池县",
              "label": "盐池县",
              "id": 640323
            }, {
              "value": "同心县",
              "label": "同心县",
              "id": 640324
            }, {
              "value": "青铜峡市",
              "label": "青铜峡市",
              "id": 640381
            }]
          }, {
            "value": "固原市",
            "label": "固原市",
            "id": 640400,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 640401
            }, {
              "value": "原州区",
              "label": "原州区",
              "id": 640402
            }, {
              "value": "西吉县",
              "label": "西吉县",
              "id": 640422
            }, {
              "value": "隆德县",
              "label": "隆德县",
              "id": 640423
            }, {
              "value": "泾源县",
              "label": "泾源县",
              "id": 640424
            }, {
              "value": "彭阳县",
              "label": "彭阳县",
              "id": 640425
            }]
          }, {
            "value": "中卫市",
            "label": "中卫市",
            "id": 640500,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 640501
            }, {
              "value": "沙坡头区",
              "label": "沙坡头区",
              "id": 640502
            }, {
              "value": "中宁县",
              "label": "中宁县",
              "id": 640521
            }, {
              "value": "海原县",
              "label": "海原县",
              "id": 640522
            }]
          }]
        }, {
          "value": "新疆维吾尔自治区",
          "label": "新疆维吾尔自治区",
          "id": 650000,
          "children": [{
            "value": "乌鲁木齐市",
            "label": "乌鲁木齐市",
            "id": 650100,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 650101
            }, {
              "value": "天山区",
              "label": "天山区",
              "id": 650102
            }, {
              "value": "沙依巴克区",
              "label": "沙依巴克区",
              "id": 650103
            }, {
              "value": "新市区",
              "label": "新市区",
              "id": 650104
            }, {
              "value": "水磨沟区",
              "label": "水磨沟区",
              "id": 650105
            }, {
              "value": "头屯河区",
              "label": "头屯河区",
              "id": 650106
            }, {
              "value": "达坂城区",
              "label": "达坂城区",
              "id": 650107
            }, {
              "value": "米东区",
              "label": "米东区",
              "id": 650109
            }, {
              "value": "乌鲁木齐县",
              "label": "乌鲁木齐县",
              "id": 650121
            }]
          }, {
            "value": "克拉玛依市",
            "label": "克拉玛依市",
            "id": 650200,
            "children": [{
              "value": "市辖区",
              "label": "市辖区",
              "id": 650201
            }, {
              "value": "独山子区",
              "label": "独山子区",
              "id": 650202
            }, {
              "value": "克拉玛依区",
              "label": "克拉玛依区",
              "id": 650203
            }, {
              "value": "白碱滩区",
              "label": "白碱滩区",
              "id": 650204
            }, {
              "value": "乌尔禾区",
              "label": "乌尔禾区",
              "id": 650205
            }]
          }, {
            "value": "吐鲁番市",
            "label": "吐鲁番市",
            "id": 650400,
            "children": [{
              "value": "高昌区",
              "label": "高昌区",
              "id": 650402
            }, {
              "value": "鄯善县",
              "label": "鄯善县",
              "id": 650421
            }, {
              "value": "托克逊县",
              "label": "托克逊县",
              "id": 650422
            }]
          }, {
            "value": "哈密市",
            "label": "哈密市",
            "id": 650500,
            "children": [{
              "value": "伊州区",
              "label": "伊州区",
              "id": 650502
            }, {
              "value": "巴里坤哈萨克自治县",
              "label": "巴里坤哈萨克自治县",
              "id": 650521
            }, {
              "value": "伊吾县",
              "label": "伊吾县",
              "id": 650522
            }]
          }, {
            "value": "昌吉回族自治州",
            "label": "昌吉回族自治州",
            "id": 652300,
            "children": [{
              "value": "昌吉市",
              "label": "昌吉市",
              "id": 652301
            }, {
              "value": "阜康市",
              "label": "阜康市",
              "id": 652302
            }, {
              "value": "呼图壁县",
              "label": "呼图壁县",
              "id": 652323
            }, {
              "value": "玛纳斯县",
              "label": "玛纳斯县",
              "id": 652324
            }, {
              "value": "奇台县",
              "label": "奇台县",
              "id": 652325
            }, {
              "value": "吉木萨尔县",
              "label": "吉木萨尔县",
              "id": 652327
            }, {
              "value": "木垒哈萨克自治县",
              "label": "木垒哈萨克自治县",
              "id": 652328
            }]
          }, {
            "value": "博尔塔拉蒙古自治州",
            "label": "博尔塔拉蒙古自治州",
            "id": 652700,
            "children": [{
              "value": "博乐市",
              "label": "博乐市",
              "id": 652701
            }, {
              "value": "阿拉山口市",
              "label": "阿拉山口市",
              "id": 652702
            }, {
              "value": "精河县",
              "label": "精河县",
              "id": 652722
            }, {
              "value": "温泉县",
              "label": "温泉县",
              "id": 652723
            }]
          }, {
            "value": "巴音郭楞蒙古自治州",
            "label": "巴音郭楞蒙古自治州",
            "id": 652800,
            "children": [{
              "value": "库尔勒市",
              "label": "库尔勒市",
              "id": 652801
            }, {
              "value": "轮台县",
              "label": "轮台县",
              "id": 652822
            }, {
              "value": "尉犁县",
              "label": "尉犁县",
              "id": 652823
            }, {
              "value": "若羌县",
              "label": "若羌县",
              "id": 652824
            }, {
              "value": "且末县",
              "label": "且末县",
              "id": 652825
            }, {
              "value": "焉耆回族自治县",
              "label": "焉耆回族自治县",
              "id": 652826
            }, {
              "value": "和静县",
              "label": "和静县",
              "id": 652827
            }, {
              "value": "和硕县",
              "label": "和硕县",
              "id": 652828
            }, {
              "value": "博湖县",
              "label": "博湖县",
              "id": 652829
            }]
          }, {
            "value": "阿克苏地区",
            "label": "阿克苏地区",
            "id": 652900,
            "children": [{
              "value": "阿克苏市",
              "label": "阿克苏市",
              "id": 652901
            }, {
              "value": "温宿县",
              "label": "温宿县",
              "id": 652922
            }, {
              "value": "库车县",
              "label": "库车县",
              "id": 652923
            }, {
              "value": "沙雅县",
              "label": "沙雅县",
              "id": 652924
            }, {
              "value": "新和县",
              "label": "新和县",
              "id": 652925
            }, {
              "value": "拜城县",
              "label": "拜城县",
              "id": 652926
            }, {
              "value": "乌什县",
              "label": "乌什县",
              "id": 652927
            }, {
              "value": "阿瓦提县",
              "label": "阿瓦提县",
              "id": 652928
            }, {
              "value": "柯坪县",
              "label": "柯坪县",
              "id": 652929
            }]
          }, {
            "value": "克孜勒苏柯尔克孜自治州",
            "label": "克孜勒苏柯尔克孜自治州",
            "id": 653000,
            "children": [{
              "value": "阿图什市",
              "label": "阿图什市",
              "id": 653001
            }, {
              "value": "阿克陶县",
              "label": "阿克陶县",
              "id": 653022
            }, {
              "value": "阿合奇县",
              "label": "阿合奇县",
              "id": 653023
            }, {
              "value": "乌恰县",
              "label": "乌恰县",
              "id": 653024
            }]
          }, {
            "value": "喀什地区",
            "label": "喀什地区",
            "id": 653100,
            "children": [{
              "value": "喀什市",
              "label": "喀什市",
              "id": 653101
            }, {
              "value": "疏附县",
              "label": "疏附县",
              "id": 653121
            }, {
              "value": "疏勒县",
              "label": "疏勒县",
              "id": 653122
            }, {
              "value": "英吉沙县",
              "label": "英吉沙县",
              "id": 653123
            }, {
              "value": "泽普县",
              "label": "泽普县",
              "id": 653124
            }, {
              "value": "莎车县",
              "label": "莎车县",
              "id": 653125
            }, {
              "value": "叶城县",
              "label": "叶城县",
              "id": 653126
            }, {
              "value": "麦盖提县",
              "label": "麦盖提县",
              "id": 653127
            }, {
              "value": "岳普湖县",
              "label": "岳普湖县",
              "id": 653128
            }, {
              "value": "伽师县",
              "label": "伽师县",
              "id": 653129
            }, {
              "value": "巴楚县",
              "label": "巴楚县",
              "id": 653130
            }, {
              "value": "塔什库尔干塔吉克自治县",
              "label": "塔什库尔干塔吉克自治县",
              "id": 653131
            }]
          }, {
            "value": "和田地区",
            "label": "和田地区",
            "id": 653200,
            "children": [{
              "value": "和田市",
              "label": "和田市",
              "id": 653201
            }, {
              "value": "和田县",
              "label": "和田县",
              "id": 653221
            }, {
              "value": "墨玉县",
              "label": "墨玉县",
              "id": 653222
            }, {
              "value": "皮山县",
              "label": "皮山县",
              "id": 653223
            }, {
              "value": "洛浦县",
              "label": "洛浦县",
              "id": 653224
            }, {
              "value": "策勒县",
              "label": "策勒县",
              "id": 653225
            }, {
              "value": "于田县",
              "label": "于田县",
              "id": 653226
            }, {
              "value": "民丰县",
              "label": "民丰县",
              "id": 653227
            }]
          }, {
            "value": "伊犁哈萨克自治州",
            "label": "伊犁哈萨克自治州",
            "id": 654000,
            "children": [{
              "value": "伊宁市",
              "label": "伊宁市",
              "id": 654002
            }, {
              "value": "奎屯市",
              "label": "奎屯市",
              "id": 654003
            }, {
              "value": "霍尔果斯市",
              "label": "霍尔果斯市",
              "id": 654004
            }, {
              "value": "伊宁县",
              "label": "伊宁县",
              "id": 654021
            }, {
              "value": "察布查尔锡伯自治县",
              "label": "察布查尔锡伯自治县",
              "id": 654022
            }, {
              "value": "霍城县",
              "label": "霍城县",
              "id": 654023
            }, {
              "value": "巩留县",
              "label": "巩留县",
              "id": 654024
            }, {
              "value": "新源县",
              "label": "新源县",
              "id": 654025
            }, {
              "value": "昭苏县",
              "label": "昭苏县",
              "id": 654026
            }, {
              "value": "特克斯县",
              "label": "特克斯县",
              "id": 654027
            }, {
              "value": "尼勒克县",
              "label": "尼勒克县",
              "id": 654028
            }]
          }, {
            "value": "塔城地区",
            "label": "塔城地区",
            "id": 654200,
            "children": [{
              "value": "塔城市",
              "label": "塔城市",
              "id": 654201
            }, {
              "value": "乌苏市",
              "label": "乌苏市",
              "id": 654202
            }, {
              "value": "额敏县",
              "label": "额敏县",
              "id": 654221
            }, {
              "value": "沙湾县",
              "label": "沙湾县",
              "id": 654223
            }, {
              "value": "托里县",
              "label": "托里县",
              "id": 654224
            }, {
              "value": "裕民县",
              "label": "裕民县",
              "id": 654225
            }, {
              "value": "和布克赛尔蒙古自治县",
              "label": "和布克赛尔蒙古自治县",
              "id": 654226
            }]
          }, {
            "value": "阿勒泰地区",
            "label": "阿勒泰地区",
            "id": 654300,
            "children": [{
              "value": "阿勒泰市",
              "label": "阿勒泰市",
              "id": 654301
            }, {
              "value": "布尔津县",
              "label": "布尔津县",
              "id": 654321
            }, {
              "value": "富蕴县",
              "label": "富蕴县",
              "id": 654322
            }, {
              "value": "福海县",
              "label": "福海县",
              "id": 654323
            }, {
              "value": "哈巴河县",
              "label": "哈巴河县",
              "id": 654324
            }, {
              "value": "青河县",
              "label": "青河县",
              "id": 654325
            }, {
              "value": "吉木乃县",
              "label": "吉木乃县",
              "id": 654326
            }]
          }, {
            "value": "自治区直辖县级行政区划",
            "label": "自治区直辖县级行政区划",
            "id": 659000,
            "children": [{
              "value": "石河子市",
              "label": "石河子市",
              "id": 659001
            }, {
              "value": "阿拉尔市",
              "label": "阿拉尔市",
              "id": 659002
            }, {
              "value": "图木舒克市",
              "label": "图木舒克市",
              "id": 659003
            }, {
              "value": "五家渠市",
              "label": "五家渠市",
              "id": 659004
            }, {
              "value": "铁门关市",
              "label": "铁门关市",
              "id": 659006
            }]
          }]
        }, {
          "value": "台湾省",
          "label": "台湾省",
          "id": 710000,
          "children": [{
            "value": "台北市",
            "label": "台北市",
            "id": 710100,
            "children": [{
              "value": "中正区",
              "label": "中正区",
              "id": 710101
            }, {
              "value": "大同区",
              "label": "大同区",
              "id": 710102
            }, {
              "value": "中山区",
              "label": "中山区",
              "id": 710103
            }, {
              "value": "万华区",
              "label": "万华区",
              "id": 710104
            }, {
              "value": "信义区",
              "label": "信义区",
              "id": 710105
            }, {
              "value": "松山区",
              "label": "松山区",
              "id": 710106
            }, {
              "value": "大安区",
              "label": "大安区",
              "id": 710107
            }, {
              "value": "南港区",
              "label": "南港区",
              "id": 710108
            }, {
              "value": "北投区",
              "label": "北投区",
              "id": 710109
            }, {
              "value": "内湖区",
              "label": "内湖区",
              "id": 710110
            }, {
              "value": "士林区",
              "label": "士林区",
              "id": 710111
            }, {
              "value": "文山区",
              "label": "文山区",
              "id": 710112
            }]
          }, {
            "value": "新北市",
            "label": "新北市",
            "id": 710200,
            "children": [{
              "value": "板桥区",
              "label": "板桥区",
              "id": 710201
            }, {
              "value": "土城区",
              "label": "土城区",
              "id": 710202
            }, {
              "value": "新庄区",
              "label": "新庄区",
              "id": 710203
            }, {
              "value": "新店区",
              "label": "新店区",
              "id": 710204
            }, {
              "value": "深坑区",
              "label": "深坑区",
              "id": 710205
            }, {
              "value": "石碇区",
              "label": "石碇区",
              "id": 710206
            }, {
              "value": "坪林区",
              "label": "坪林区",
              "id": 710207
            }, {
              "value": "乌来区",
              "label": "乌来区",
              "id": 710208
            }, {
              "value": "五股区",
              "label": "五股区",
              "id": 710209
            }, {
              "value": "八里区",
              "label": "八里区",
              "id": 710210
            }, {
              "value": "林口区",
              "label": "林口区",
              "id": 710211
            }, {
              "value": "淡水区",
              "label": "淡水区",
              "id": 710212
            }, {
              "value": "中和区",
              "label": "中和区",
              "id": 710213
            }, {
              "value": "永和区",
              "label": "永和区",
              "id": 710214
            }, {
              "value": "三重区",
              "label": "三重区",
              "id": 710215
            }, {
              "value": "芦洲区",
              "label": "芦洲区",
              "id": 710216
            }, {
              "value": "泰山区",
              "label": "泰山区",
              "id": 710217
            }, {
              "value": "树林区",
              "label": "树林区",
              "id": 710218
            }, {
              "value": "莺歌区",
              "label": "莺歌区",
              "id": 710219
            }, {
              "value": "三峡区",
              "label": "三峡区",
              "id": 710220
            }, {
              "value": "汐止区",
              "label": "汐止区",
              "id": 710221
            }, {
              "value": "金山区",
              "label": "金山区",
              "id": 710222
            }, {
              "value": "万里区",
              "label": "万里区",
              "id": 710223
            }, {
              "value": "三芝区",
              "label": "三芝区",
              "id": 710224
            }, {
              "value": "石门区",
              "label": "石门区",
              "id": 710225
            }, {
              "value": "瑞芳区",
              "label": "瑞芳区",
              "id": 710226
            }, {
              "value": "贡寮区",
              "label": "贡寮区",
              "id": 710227
            }, {
              "value": "双溪区",
              "label": "双溪区",
              "id": 710228
            }, {
              "value": "平溪区",
              "label": "平溪区",
              "id": 710229
            }]
          }, {
            "value": "桃园市",
            "label": "桃园市",
            "id": 710300,
            "children": [{
              "value": "桃园区",
              "label": "桃园区",
              "id": 710301
            }, {
              "value": "中坜区",
              "label": "中坜区",
              "id": 710302
            }, {
              "value": "平镇区",
              "label": "平镇区",
              "id": 710303
            }, {
              "value": "八德区",
              "label": "八德区",
              "id": 710304
            }, {
              "value": "杨梅区",
              "label": "杨梅区",
              "id": 710305
            }, {
              "value": "芦竹区",
              "label": "芦竹区",
              "id": 710306
            }, {
              "value": "大溪区",
              "label": "大溪区",
              "id": 710307
            }, {
              "value": "龙潭区",
              "label": "龙潭区",
              "id": 710308
            }, {
              "value": "龟山区",
              "label": "龟山区",
              "id": 710309
            }, {
              "value": "大园区",
              "label": "大园区",
              "id": 710310
            }, {
              "value": "观音区",
              "label": "观音区",
              "id": 710311
            }, {
              "value": "新屋区",
              "label": "新屋区",
              "id": 710312
            }, {
              "value": "复兴区",
              "label": "复兴区",
              "id": 710313
            }]
          }, {
            "value": "台中市",
            "label": "台中市",
            "id": 710400,
            "children": [{
              "value": "中区",
              "label": "中区",
              "id": 710401
            }, {
              "value": "东区",
              "label": "东区",
              "id": 710402
            }, {
              "value": "西区",
              "label": "西区",
              "id": 710403
            }, {
              "value": "南区",
              "label": "南区",
              "id": 710404
            }, {
              "value": "北区",
              "label": "北区",
              "id": 710405
            }, {
              "value": "西屯区",
              "label": "西屯区",
              "id": 710406
            }, {
              "value": "南屯区",
              "label": "南屯区",
              "id": 710407
            }, {
              "value": "北屯区",
              "label": "北屯区",
              "id": 710408
            }, {
              "value": "丰原区",
              "label": "丰原区",
              "id": 710409
            }, {
              "value": "大里区",
              "label": "大里区",
              "id": 710410
            }, {
              "value": "太平区",
              "label": "太平区",
              "id": 710411
            }, {
              "value": "东势区",
              "label": "东势区",
              "id": 710412
            }, {
              "value": "大甲区",
              "label": "大甲区",
              "id": 710413
            }, {
              "value": "清水区",
              "label": "清水区",
              "id": 710414
            }, {
              "value": "沙鹿区",
              "label": "沙鹿区",
              "id": 710415
            }, {
              "value": "梧栖区",
              "label": "梧栖区",
              "id": 710416
            }, {
              "value": "后里区",
              "label": "后里区",
              "id": 710417
            }, {
              "value": "神冈区",
              "label": "神冈区",
              "id": 710418
            }, {
              "value": "潭子区",
              "label": "潭子区",
              "id": 710419
            }, {
              "value": "大雅区",
              "label": "大雅区",
              "id": 710420
            }, {
              "value": "新小区",
              "label": "新小区",
              "id": 710421
            }, {
              "value": "石冈区",
              "label": "石冈区",
              "id": 710422
            }, {
              "value": "外埔区",
              "label": "外埔区",
              "id": 710423
            }, {
              "value": "大安区",
              "label": "大安区",
              "id": 710424
            }, {
              "value": "乌日区",
              "label": "乌日区",
              "id": 710425
            }, {
              "value": "大肚区",
              "label": "大肚区",
              "id": 710426
            }, {
              "value": "龙井区",
              "label": "龙井区",
              "id": 710427
            }, {
              "value": "雾峰区",
              "label": "雾峰区",
              "id": 710428
            }, {
              "value": "和平区",
              "label": "和平区",
              "id": 710429
            }]
          }, {
            "value": "台南市",
            "label": "台南市",
            "id": 710500,
            "children": [{
              "value": "中西区",
              "label": "中西区",
              "id": 710501
            }, {
              "value": "东区",
              "label": "东区",
              "id": 710502
            }, {
              "value": "南区",
              "label": "南区",
              "id": 710503
            }, {
              "value": "北区",
              "label": "北区",
              "id": 710504
            }, {
              "value": "安平区",
              "label": "安平区",
              "id": 710505
            }, {
              "value": "安南区",
              "label": "安南区",
              "id": 710506
            }, {
              "value": "永康区",
              "label": "永康区",
              "id": 710507
            }, {
              "value": "归仁区",
              "label": "归仁区",
              "id": 710508
            }, {
              "value": "新化区",
              "label": "新化区",
              "id": 710509
            }, {
              "value": "左镇区",
              "label": "左镇区",
              "id": 710510
            }, {
              "value": "玉井区",
              "label": "玉井区",
              "id": 710511
            }, {
              "value": "楠西区",
              "label": "楠西区",
              "id": 710512
            }, {
              "value": "南化区",
              "label": "南化区",
              "id": 710513
            }, {
              "value": "仁德区",
              "label": "仁德区",
              "id": 710514
            }, {
              "value": "关庙区",
              "label": "关庙区",
              "id": 710515
            }, {
              "value": "龙崎区",
              "label": "龙崎区",
              "id": 710516
            }, {
              "value": "官田区",
              "label": "官田区",
              "id": 710517
            }, {
              "value": "麻豆区",
              "label": "麻豆区",
              "id": 710518
            }, {
              "value": "佳里区",
              "label": "佳里区",
              "id": 710519
            }, {
              "value": "西港区",
              "label": "西港区",
              "id": 710520
            }, {
              "value": "七股区",
              "label": "七股区",
              "id": 710521
            }, {
              "value": "将军区",
              "label": "将军区",
              "id": 710522
            }, {
              "value": "学甲区",
              "label": "学甲区",
              "id": 710523
            }, {
              "value": "北门区",
              "label": "北门区",
              "id": 710524
            }, {
              "value": "新营区",
              "label": "新营区",
              "id": 710525
            }, {
              "value": "后壁区",
              "label": "后壁区",
              "id": 710526
            }, {
              "value": "白河区",
              "label": "白河区",
              "id": 710527
            }, {
              "value": "东山区",
              "label": "东山区",
              "id": 710528
            }, {
              "value": "六甲区",
              "label": "六甲区",
              "id": 710529
            }, {
              "value": "下营区",
              "label": "下营区",
              "id": 710530
            }, {
              "value": "柳营区",
              "label": "柳营区",
              "id": 710531
            }, {
              "value": "盐水区",
              "label": "盐水区",
              "id": 710532
            }, {
              "value": "善化区",
              "label": "善化区",
              "id": 710533
            }, {
              "value": "大内区",
              "label": "大内区",
              "id": 710534
            }, {
              "value": "山上区",
              "label": "山上区",
              "id": 710535
            }, {
              "value": "新市区",
              "label": "新市区",
              "id": 710536
            }, {
              "value": "安定区",
              "label": "安定区",
              "id": 710537
            }]
          }, {
            "value": "高雄市",
            "label": "高雄市",
            "id": 710600,
            "children": [{
              "value": "楠梓区",
              "label": "楠梓区",
              "id": 710601
            }, {
              "value": "左营区",
              "label": "左营区",
              "id": 710602
            }, {
              "value": "鼓山区",
              "label": "鼓山区",
              "id": 710603
            }, {
              "value": "三民区",
              "label": "三民区",
              "id": 710604
            }, {
              "value": "盐埕区",
              "label": "盐埕区",
              "id": 710605
            }, {
              "value": "前金区",
              "label": "前金区",
              "id": 710606
            }, {
              "value": "新兴区",
              "label": "新兴区",
              "id": 710607
            }, {
              "value": "苓雅区",
              "label": "苓雅区",
              "id": 710608
            }, {
              "value": "前镇区",
              "label": "前镇区",
              "id": 710609
            }, {
              "value": "旗津区",
              "label": "旗津区",
              "id": 710610
            }, {
              "value": "小港区",
              "label": "小港区",
              "id": 710611
            }, {
              "value": "凤山区",
              "label": "凤山区",
              "id": 710612
            }, {
              "value": "大寮区",
              "label": "大寮区",
              "id": 710613
            }, {
              "value": "鸟松区",
              "label": "鸟松区",
              "id": 710614
            }, {
              "value": "林园区",
              "label": "林园区",
              "id": 710615
            }, {
              "value": "仁武区",
              "label": "仁武区",
              "id": 710616
            }, {
              "value": "大树区",
              "label": "大树区",
              "id": 710617
            }, {
              "value": "大社区",
              "label": "大社区",
              "id": 710618
            }, {
              "value": "冈山区",
              "label": "冈山区",
              "id": 710619
            }, {
              "value": "路竹区",
              "label": "路竹区",
              "id": 710620
            }, {
              "value": "桥头区",
              "label": "桥头区",
              "id": 710621
            }, {
              "value": "梓官区",
              "label": "梓官区",
              "id": 710622
            }, {
              "value": "弥陀区",
              "label": "弥陀区",
              "id": 710623
            }, {
              "value": "永安区",
              "label": "永安区",
              "id": 710624
            }, {
              "value": "燕巢区",
              "label": "燕巢区",
              "id": 710625
            }, {
              "value": "阿莲区",
              "label": "阿莲区",
              "id": 710626
            }, {
              "value": "茄萣区",
              "label": "茄萣区",
              "id": 710627
            }, {
              "value": "湖内区",
              "label": "湖内区",
              "id": 710628
            }, {
              "value": "旗山区",
              "label": "旗山区",
              "id": 710629
            }, {
              "value": "美浓区",
              "label": "美浓区",
              "id": 710630
            }, {
              "value": "内门区",
              "label": "内门区",
              "id": 710631
            }, {
              "value": "杉林区",
              "label": "杉林区",
              "id": 710632
            }, {
              "value": "甲仙区",
              "label": "甲仙区",
              "id": 710633
            }, {
              "value": "六龟区",
              "label": "六龟区",
              "id": 710634
            }, {
              "value": "茂林区",
              "label": "茂林区",
              "id": 710635
            }, {
              "value": "桃源区",
              "label": "桃源区",
              "id": 710636
            }, {
              "value": "那玛夏区",
              "label": "那玛夏区",
              "id": 710637
            }]
          }, {
            "value": "基隆市",
            "label": "基隆市",
            "id": 710700,
            "children": [{
              "value": "中正区",
              "label": "中正区",
              "id": 710701
            }, {
              "value": "七堵区",
              "label": "七堵区",
              "id": 710702
            }, {
              "value": "暖暖区",
              "label": "暖暖区",
              "id": 710703
            }, {
              "value": "仁爱区",
              "label": "仁爱区",
              "id": 710704
            }, {
              "value": "中山区",
              "label": "中山区",
              "id": 710705
            }, {
              "value": "安乐区",
              "label": "安乐区",
              "id": 710706
            }, {
              "value": "信义区",
              "label": "信义区",
              "id": 710707
            }]
          }, {
            "value": "新竹市",
            "label": "新竹市",
            "id": 710800,
            "children": [{
              "value": "东区",
              "label": "东区",
              "id": 710801
            }, {
              "value": "北区",
              "label": "北区",
              "id": 710802
            }, {
              "value": "香山区",
              "label": "香山区",
              "id": 710803
            }]
          }, {
            "value": "嘉义市",
            "label": "嘉义市",
            "id": 710900,
            "children": [{
              "value": "东区",
              "label": "东区",
              "id": 710901
            }, {
              "value": "西区",
              "label": "西区",
              "id": 710902
            }, {
              "value": "宜兰县",
              "label": "宜兰县",
              "id": 719001
            }, {
              "value": "新竹县",
              "label": "新竹县",
              "id": 719002
            }, {
              "value": "苗栗县",
              "label": "苗栗县",
              "id": 719003
            }, {
              "value": "彰化县",
              "label": "彰化县",
              "id": 719004
            }, {
              "value": "南投县",
              "label": "南投县",
              "id": 719005
            }, {
              "value": "嘉义县",
              "label": "嘉义县",
              "id": 719006
            }, {
              "value": "云林县",
              "label": "云林县",
              "id": 719007
            }, {
              "value": "屏东县",
              "label": "屏东县",
              "id": 719008
            }, {
              "value": "台东县",
              "label": "台东县",
              "id": 719009
            }, {
              "value": "花莲县",
              "label": "花莲县",
              "id": 719010
            }, {
              "value": "澎湖县",
              "label": "澎湖县",
              "id": 719011
            }, {
              "value": "金门县",
              "label": "金门县",
              "id": 719012
            }, {
              "value": "连江县",
              "label": "连江县",
              "id": 719013
            }]
          }]
        }, {
          "value": "香港特别行政区",
          "label": "香港特别行政区",
          "id": 810000,
          "children": [{
            "value": "香港特别行政区",
            "label": "香港特别行政区",
            "id": 810100,
            "children": [{
              "value": "中西区",
              "label": "中西区",
              "id": 810101
            }, {
              "value": "湾仔区",
              "label": "湾仔区",
              "id": 810102
            }, {
              "value": "东区",
              "label": "东区",
              "id": 810103
            }, {
              "value": "南区",
              "label": "南区",
              "id": 810104
            }, {
              "value": "油尖旺区",
              "label": "油尖旺区",
              "id": 810105
            }, {
              "value": "深水埗区",
              "label": "深水埗区",
              "id": 810106
            }, {
              "value": "九龙城区",
              "label": "九龙城区",
              "id": 810107
            }, {
              "value": "黄大仙区",
              "label": "黄大仙区",
              "id": 810108
            }, {
              "value": "北区",
              "label": "北区",
              "id": 810110
            }, {
              "value": "大埔区",
              "label": "大埔区",
              "id": 810111
            }, {
              "value": "沙田区",
              "label": "沙田区",
              "id": 810112
            }, {
              "value": "西贡区",
              "label": "西贡区",
              "id": 810113
            }, {
              "value": "荃湾区",
              "label": "荃湾区",
              "id": 810114
            }, {
              "value": "屯门区",
              "label": "屯门区",
              "id": 810115
            }, {
              "value": "元朗区",
              "label": "元朗区",
              "id": 810116
            }, {
              "value": "葵青区",
              "label": "葵青区",
              "id": 810117
            }, {
              "value": "离岛区",
              "label": "离岛区",
              "id": 810118
            }, {
              "value": "观塘区",
              "label": "观塘区",
              "id": 810109
            }]
          }]
        }, {
          "value": "澳门特别行政区",
          "label": "澳门特别行政区",
          "id": 820000,
          "children": [{
            "value": "澳门特别行政区",
            "label": "澳门特别行政区",
            "id": 820100,
            "children": [{
              "value": "花地玛堂区",
              "label": "花地玛堂区",
              "id": 820101
            }, {
              "value": "圣安多尼堂区",
              "label": "圣安多尼堂区",
              "id": 820102
            }, {
              "value": "大堂区",
              "label": "大堂区",
              "id": 820103
            }, {
              "value": "望德堂区",
              "label": "望德堂区",
              "id": 820104
            }, {
              "value": "风顺堂区",
              "label": "风顺堂区",
              "id": 820105
            }, {
              "value": "嘉模堂区",
              "label": "嘉模堂区",
              "id": 820106
            }, {
              "value": "圣方济各堂区",
              "label": "圣方济各堂区",
              "id": 820107
            }, {
              "value": "路氹城",
              "label": "路氹城",
              "id": 820108
            }, {
              "value": "澳门新城",
              "label": "澳门新城",
              "id": 820109
            }]
          }]
        }],
        rdata: {
          min_number: 1,
          number: 1,
          dan_price: 0,
          e_mail:'',
          enterprise: {
            enterprise_name: '',
            portrait: ""
          }
        }
      }
    },
    computed: {
      total_price: function() {
        return (this.rdata.number * this.rdata.unit_price + parseFloat(this.rdata.dan_price)).toFixed(2);
      }
    },
    mounted() {
      that = this;
      that.init();
    },
    methods: {
      save() {
        var consignee = that.rdata.consignee;
        var receiving_phone = that.rdata.receiving_phone;
        var receiving_address = that.rdata.receiving_address;
        if (consignee == '') return that.$Message.error('请填写收货人地址');
        if (receiving_phone == '') return that.$Message.error('请填写收货手机号');
        if (receiving_phone.length !== 11) return that.$Message.error('手机号格式有误');
        if (receiving_address == '') return that.$Message.error('请填写详细收货地址');
        that.rdata.province = that.city[0];
        that.rdata.city = that.city[1];
        that.rdata.county = that.city[2];
        that.editSh = false;
      },
      fukuan() {
        var order_code = that.$route.params.id;
        var consignee = that.rdata.consignee;
        var receiving_phone = that.rdata.receiving_phone;
        var province = that.rdata.province;
        var city = that.rdata.city;
        var county = that.rdata.county;
        var receiving_address = that.rdata.receiving_address;
        var number = that.rdata.number;
        var e_mail = that.rdata.e_mail;

        if (consignee == '') return that.$Message.error('请填写收货人地址');
        if (receiving_phone == '') return that.$Message.error('请填写收货手机号');
        if (receiving_phone.length !== 11) return that.$Message.error('手机号格式有误');
        if (receiving_address == '') return that.$Message.error('请填写详细收货地址');
        if (e_mail == '') return that.$Message.error('请填写电子邮箱');
        　var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/; //

        if(!reg.test(e_mail)){ 
　　　　 that.$Message.error('邮箱格式有误');
　　　　return false;
　　}
   that.load = true;
        POST('/setPlaceOrder', {
          order_code,
          consignee,
          receiving_phone,
          province,
          city,
          county,
          receiving_address,
          number,
          e_mail
        }).then(function(res) {
   that.load = false;

          if (res.state == 200) {
            that.$router.push({
              path: '/pay/' + order_code
            })
          } else {
            that.$Message.error(res.msg);
          }
        });
      },
      init() {
        var order_code = that.$route.params.id;
        POST('/getPlaceOrder', {
          order_code
        }).then(function(res) {
          that.load = false;
          that.rdata = res.data;
          that.city[0] = res.data.province;
          that.city[1] = res.data.city;
          that.city[2] = res.data.county;
        });
      },
      loseFocus() {},
    }
  }
</script>
